define(["loglevel","jquery","underscore","underscore.string","fenix-ui-pivotator-utils","fenix-ui-filter-utils","fenix-ui-metadata-viewer","fenix-ui-dropdown","fenix-ui-bridge","fenix-ui-reports","swiper","amplify-pubsub","fenix-ui-filter","fenix-ui-chart-creator","bootstrap","fenix-ui-map-creator","fenix-ui-table-creator"], function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_42__, __WEBPACK_EXTERNAL_MODULE_45__, __WEBPACK_EXTERNAL_MODULE_46__, __WEBPACK_EXTERNAL_MODULE_47__, __WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_62__, __WEBPACK_EXTERNAL_MODULE_68__, __WEBPACK_EXTERNAL_MODULE_74__, __WEBPACK_EXTERNAL_MODULE_78__, __WEBPACK_EXTERNAL_MODULE_84__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(2),
	    __webpack_require__(3),
	    __webpack_require__(4),
	    __webpack_require__(5),
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(8),
	    __webpack_require__(9),
	    __webpack_require__(14),
	    __webpack_require__(15),
	    __webpack_require__(16),
	    __webpack_require__(36),
	    __webpack_require__(37),
	    __webpack_require__(38),
	    __webpack_require__(39),
	    __webpack_require__(40),
	    __webpack_require__(41),
	    __webpack_require__(42),
	    __webpack_require__(43),
	    __webpack_require__(44), //for map backtab
	    __webpack_require__(11),
	    __webpack_require__(45),
	    __webpack_require__(46),
	    __webpack_require__(47),
	    __webpack_require__(48)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (log, $, _, _str, C, ERR, EVT, BoxUtils, Utils, MetadataViewer, Template, FilterFilterTemplate, FilterMapTemplate,
	             FilterAggregationTemplate, StepFilterTemplate, StepMapTemplate, StepMetadataTemplate, JsonMenu, menuModel,
	             mapEarthstatLayers, i18nLabels, Bridge, Report, Swiper, amplify) {
	
	    'use strict';
	
	    var steps = {
	        filter: StepFilterTemplate,
	        map: StepMapTemplate,
	        metadata: StepMetadataTemplate
	    }, s = {
	        BOX: "[data-role='box']",
	        CONTENT_READY: "[data-content='ready']",
	        RIGHT_MENU: "[data-role='right-menu']",
	        FLIP_CONTAINER: "[data-role='flip-container']",
	        FLIP_BUTTONS: "[data-action='flip']",
	        FRONT_CONTENT: "[data-role='front-content']",
	        FRONT_TOOLBAR: "[data-role='front-toolbar']",
	        BACK_TOOLBAR: "[data-role='back-toolbar']",
	        PROCESS_STEPS: "[data-role='process-steps']",
	        PROCESS_DETAILS: "[data-role='process-details']",
	        BACK_CONTENT: "[data-role='back-content']",
	        BOX_TITLE: "[data-role='box-title']",
	        QUERY_BUTTON: "[data-action='query']",
	        ERROR_TEXT: "[data-role='error-text']",
	        EMPTY_FILTER_BUTTON: "[data-content='empty'] [data-action='filter'], [data-content='error'] [data-action='filter']",
	        BACK_FILTER_ERRORS: "[data-role='filter-error']",
	        FILTER_AGGREGATION_TEMPLATE: "[data-role='filter-aggregation-template']",
	        FILTER_FILTER_TEMPLATE: "[data-role='filter-filter-template']",
	        FILTER_MAP_TEMPLATE: "[data-role='filter-map-template']",
	        ROWS_SWIPER: "[data-role='filter-rows-swiper']",
	        BTN_SIDEBAR: "[data-action='show-back-sidebar']",
	        SIDEBAR: "[data-role='back-sidebar']",
	        FRONT_FACE: "[data-face='front']",
	        BACK_FACE: "[data-face='back']",
	        OTHER_CONTENT: "[data-content='empty'], [data-content='error'], [data-content='huge'], [data-content='toomany']"
	    }, pluginFolder = "./tabs/";
	
	    /* API */
	
	    /**
	     * Constructor
	     * @param {Object} obj
	     * @return {Object} box instance
	     */
	    function Box(obj) {
	        log.info("Create box");
	        log.info(obj);
	
	        //import css
	        __webpack_require__(49);
	        __webpack_require__(57);
	
	        //Extend instance with obj and $el
	        $.extend(true, this, C, {initial: obj || {}, $el: $(obj.el)});
	
	        var valid = this._validateInput();
	
	        if (valid === true) {
	
	            this._initState();
	
	            this._initVariables();
	
	            this._initObj();
	
	            this._setStatus("loading");
	
	            this._renderMenu();
	
	            this._bindEventListeners();
	
	            this._initTabSources();
	
	            this.valid = true;
	
	            this._getModelInfo();
	
	            this._reactToModelStatus();
	
	            return this;
	
	        } else {
	
	            this.valid = false;
	
	            log.error("Impossible to create visualization box");
	            log.error(valid);
	
	            this._setObjState("error", valid);
	
	        }
	    }
	
	    /**
	     * Set box status
	     * @param {Object} obj
	     * @return {Object} box instance
	     */
	    Box.prototype.render = function (obj) {
	        log.info("Render model for box [" + this.id + "]:");
	        log.info(obj);
	
	        $.extend(true, this, obj);
	
	        this._reactToModelStatus();
	    };
	
	    /**
	     * Dispose box
	     * @return {null}
	     */
	    Box.prototype.dispose = function () {
	
	        this._dispose();
	
	        log.info("Box [" + this.id + "] disposed");
	    };
	
	    /**
	     * Set box status
	     * @param {String} status
	     * @return {null}
	     */
	    Box.prototype.setStatus = function (status) {
	
	        this._setStatus(status);
	    };
	
	    /**
	     * Show a box's tab
	     * @param {String} tab. tab'sid
	     * @param {Object} opts. Options passed to tab instance
	     * @return {null}
	     */
	    Box.prototype.showTab = function (tab, opts) {
	
	        this._showFrontTab(tab, opts);
	    };
	
	    /**
	     * Set box width
	     * @param {String} size
	     * @return {null}
	     */
	    Box.prototype.setSize = function (size) {
	
	        this._setSize(size);
	    };
	
	    /**
	     * Flip the visualization box
	     * @param {String} face
	     * @return {null}
	     */
	    Box.prototype.flip = function (face) {
	        return this._flip(face);
	    };
	
	    /**
	     * pub/sub
	     * @return {Object} component instance
	     */
	    Box.prototype.on = function (channel, fn, context) {
	        var _context = context || this;
	        if (!this.channels[channel]) {
	            this.channels[channel] = [];
	        }
	        this.channels[channel].push({context: _context, callback: fn});
	        return this;
	    };
	
	    /**
	     * get box state
	     * @return {Object} box state
	     */
	    Box.prototype.getState = function () {
	
	        return this.state;
	    };
	
	    Box.prototype.setTitle = function (title) {
	        log.info("Set box title: " + title);
	
	        this._updateBoxTitle(title);
	
	    };
	
	    /* Internal fns*/
	
	    Box.prototype._validateInput = function () {
	
	        var valid = true,
	            errors = [];
	
	        //Check if box has a valid id
	        if (!this.id) {
	
	            window.fx_vis_box_id >= 0 ? window.fx_vis_box_id++ : window.fx_vis_box_id = 0;
	
	            this.id = "fx-box-" + window.fx_vis_box_id;
	
	            this._setObjState("id", this.id);
	
	            log.info("Set box id: " + this.id);
	        }
	
	        //Check if $el exist
	        if (this.$el.length === 0) {
	
	            errors.push({code: ERR.MISSING_CONTAINER});
	
	            log.warn("Impossible to find box container");
	
	        }
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    Box.prototype._initVariables = function () {
	
	        this.front_tab_instances = {};
	        this.back_tab_instances = {};
	        this.serviceProvider = this.initial.serviceProvider;
	
	        //console.log(this.serviceProvider);
	
	        this.bridge = new Bridge({
	            environment: this._getObjState("environment"),
	            cache: this._getObjState("cache"),
	            serviceProvider: this.serviceProvider
	        });
	
	        this.report = new Report({
	            environment: this._getObjState("environment"),
	            cache: this._getObjState("cache"),
	            serviceProvider: this.serviceProvider
	        });
	    };
	
	    Box.prototype._initObj = function () {
	
	        //Inject box blank template
	        var $html = $(Template($.extend(true, {}, this.getState(), this._getObjState("nls"))));
	
	        this.$el.html($html);
	
	        //pub/sub
	        this.channels = {};
	
	        //this._setObjState("hasMenu", this.$el.find(s.RIGHT_MENU).length > 0);
	        this.hasMenu = this.$el.find(s.RIGHT_MENU).length > 0;
	
	        //set flip side
	        this.flip(this._getObjState("face"));
	
	        //step process list
	        this.$processSteps = this.$el.find(s.PROCESS_STEPS);
	        this.$processStepDetails = this.$el.find(s.PROCESS_DETAILS);
	
	        this.$boxTitle = this.$el.find(s.BOX_TITLE);
	
	    };
	
	    Box.prototype._initState = function () {
	
	        var lang = this.initial.lang || C.lang;
	
	        lang = lang.toLowerCase();
	        this._setObjState("lang", lang);
	
	        //template options
	        this._setObjState("hideToolbar", !!this.initial.hideToolbar);
	        this._setObjState("hideMenu", !!this.initial.hideMenu);
	        this._setObjState("hideMetadataButton", !!this.initial.hideMetadataButton);
	        this._setObjState("hideRemoveButton", !!this.initial.hideRemoveButton);
	        this._setObjState("hideDownloadButton", !!this.initial.hideDownloadButton);
	        this._setObjState("hideCloneButton", !!this.initial.hideCloneButton);
	        this._setObjState("hideFlipButton", !!this.initial.hideFlipButton);
	        this._setObjState("hideMinimizeButton", !!this.initial.hideMinimizeButton);
	
	        //tabs
	        this._setObjState("tabStates", this.initial.tabStates || {});
	        this._setObjState("tabOptions", this.initial.tabOptions || {});
	        this._setObjState("tab", this.initial.tab);
	        this._setObjState("tabConfig", this.initial.tabConfig || C.tabConfig);
	
	        //flip side
	        this._setObjState("face", this.initial.face || C.face);
	        this._setObjState("faces", this.initial.faces || C.faces);
	
	        //resource process steps
	        this._setObjState("model", this.initial.model);
	        this._setObjState("version", this.initial.version ? this.initial.version : undefined);
	        this._setObjState("values", this.initial.values);
	        this._setObjState("process", this.initial.process || []);
	        this._setObjState("uid", this.initial.uid || BoxUtils.getNestedProperty("metadata.uid", this._getObjState("model")));
	
	        this._setObjState("size", this.initial.size || C.size);
	        this._setObjState("status", this.initial.status || C.status);
	        this._setObjState("environment", this.initial.environment);
	
	        //data validation
	        this._setObjState("maxDataSize", this.initial.maxDataSize || C.maxDataSize);
	        this._setObjState("minDataSize", this.initial.minDataSize || C.minDataSize);
	        this._setObjState("cache", typeof this.initial.cache === "boolean" ? this.initial.cache : C.cache);
	
	        // back filter values
	        this._setObjState("backFilter", this.initial.backFilter);
	        this._setObjState("backMap", this.initial.backMap);
	
	        var loadResourceServiceQueryParams = $.extend(true, this.initial.loadResourceServiceQueryParams || C.loadResourceServiceQueryParams, {
	            language: this._getObjState("lang").toUpperCase() !== "EN" ? "EN," + this._getObjState("lang").toUpperCase() : "EN"
	        });
	
	        this._setObjState("loadResourceServiceQueryParams", loadResourceServiceQueryParams);
	
	        this._setObjState("menuModel", this.initial.menu || menuModel);
	
	        this._setObjState("title", this.initial.title || this._getModelTitle);
	
	        this._setObjState("showFilter", typeof this.initial.showFilter === "boolean" ? this.initial.showFilter : false);
	
	        this._setObjState("nls", $.extend(true, {}, i18nLabels[this._getObjState("lang")], this.initial.nls));
	
	    };
	
	    Box.prototype._setObjState = function (key, val) {
	
	        BoxUtils.assign(this.state, key, val);
	
	        return val;
	    };
	
	    Box.prototype._getObjState = function (path) {
	
	        return BoxUtils.getNestedProperty(path, this.getState());
	    };
	
	    Box.prototype._reactToModelStatus = function (s) {
	        log.info("React to model status: ");
	        log.info(s);
	
	        //reset error
	        this._setObjState("error", null);
	
	        var status = s || this._getModelStatus();
	
	        log.info("Status found: ");
	        log.info(status);
	
	        switch (status) {
	            case 'ready' :
	                this._getModelInfo();
	                this._renderBox();
	                break;
	            case 'empty' :
	                this.setStatus("empty");
	                break;
	            case 'huge' :
	                this.setStatus("huge");
	                break;
	            case 'toomany' :
	                this.setStatus("toomany");
	                break;
	            case 'no_model' :
	                this.setStatus("loading");
	                break;
	            case 'to_load' :
	                this._loadResource()
	                    .then(
	                        _.bind(this._onLoadResourceSuccess, this),
	                        _.bind(this._onLoadResourceError, this));
	                break;
	            case "missing_metadata":
	                this._loadResourceMetadata()
	                    .then(
	                        _.bind(this._loadResourceMetadataSuccess, this),
	                        _.bind(this._loadResourceMetadataError, this));
	                break;
	            case "to_filter":
	                this._forceModelFilter();
	                break;
	            default :
	                this.setStatus("error");
	                break;
	        }
	    };
	
	    Box.prototype._getModelStatus = function () {
	
	        var uid = this._getObjState("uid"),
	            process = this._getObjState("process"),
	            version = this._getObjState("version"),
	            model = this._getObjState("model"),
	            metadata = this._getObjState("model.metadata"),
	            resourceType = this._getObjState("resourceRepresentationType");
	
	        if (_.isEmpty(metadata)) {
	            return 'missing_metadata';
	        }
	
	        if (resourceType === 'dataset') {
	
	            if (model) {
	
	                if (typeof model !== 'object') {
	                    return 'error';
	                }
	
	                if (!model.size || model.size === 0) {
	                    return 'empty';
	                }
	
	                if (!Array.isArray(model.data)) {
	                    return 'to_filter';
	                }
	
	                if (Array.isArray(model.data) && model.data.length <= this._getObjState("minDataSize")) {
	                    return 'empty';
	                }
	
	                // This line changes due to changes on d3p
	                if (model.data.length > this._getObjState("maxDataSize")) {
	                    return 'huge';
	                }
	
	                if (Array.isArray(model.data) && model.data.length > 0) {
	                    return 'ready';
	                }
	            }
	        }
	
	        if (resourceType === 'geographic') {
	
	            var dsd = this._getObjState("model.metadata.dsd"),
	                workspace = dsd.workspace,
	                layerName = dsd.layerName;
	
	            if (workspace && layerName) {
	                return 'ready'
	            }
	
	        }
	
	        this._setObjState("error", {code: ERR.RESOURCE_STATUS});
	
	        return 'error';
	
	    };
	
	    Box.prototype._loadResource = function (p) {
	        log.info("Loading FENIX resource");
	
	        this.setStatus("loading");
	
	        this._setObjState("showFilter", true);
	
	        var queryParams = this._getObjState("loadResourceServiceQueryParams"),
	            process = Array.isArray(p) ? p : [];
	
	        this._setObjState("process", process.slice(0));
	
	        return this.bridge.getProcessedResource({
	            body: process,
	            uid: this._getObjState("uid"),
	            version: this._getObjState("version"),
	            params: $.extend(true, {}, queryParams)
	        });
	    };
	
	    Box.prototype._onLoadResourceError = function (e) {
	        log.error("Impossible to load resource");
	
	        log.error(e);
	
	        if (e.responseText == '\"Result limit exceeded exception\"') {
	          this._setObjState("toomany", {code: ERR.LOAD_RESOURCE, filter: true});
	          this._setStatus("toomany");
	          return;
	        }
	
	        log.error({code: ERR.LOAD_RESOURCE});
	
	        this._setObjState("error", {code: ERR.LOAD_RESOURCE, filter: true});
	
	        this._setStatus("error");
	    };
	
	    Box.prototype._onLoadResourceSuccess = function (resource) {
	        log.info("Load resource success");
	
	        this._disposeBoxFaces();
	
	        this._updateModel(resource);
	
	        this._getModelInfo();
	
	        this.setStatus("ready");
	
	        this._reactToModelStatus();
	
	    };
	
	    Box.prototype._updateModel = function (resource) {
	
	        var model = this._getObjState("model") || {},
	            newMetadata = BoxUtils.getNestedProperty("metadata", resource),
	            newDsd = BoxUtils.getNestedProperty("dsd", newMetadata) || {},
	            newData = BoxUtils.getNestedProperty("data", resource),
	            newSize = BoxUtils.getNestedProperty("size", resource);
	
	        var dsdWithoutRid = _.without(Object.keys(newDsd), "rid");
	
	        //if metadata exists updated only dsd
	        if (dsdWithoutRid.length > 0) {
	            BoxUtils.assign(model, "metadata.dsd", newDsd);
	        }
	
	        if (Array.isArray(newData)) {
	            BoxUtils.assign(model, "data", newData);
	        }
	
	        if (model.size !== newSize) {
	            BoxUtils.assign(model, "size", newSize);
	        }
	
	        this._setObjState("model", model);
	    };
	
	    //preload resource info
	
	    Box.prototype._loadResourceMetadata = function () {
	        log.info("Loading FENIX resource metadata");
	
	        this.setStatus("loading");
	
	        var queryParams = this._getObjState("loadResourceServiceQueryParams");
	
	        return this.bridge.getMetadata({
	            uid: this._getObjState("uid"),
	            version: this._getObjState("version"),
	            params: $.extend(queryParams, {dsd: true, full: true})
	        });
	    };
	
	    Box.prototype._loadResourceMetadataError = function () {
	        log.error("Impossible to load resource");
	
	        log.error({code: ERR.LOAD_METADATA});
	
	        this._setObjState("error", {code: ERR.LOAD_METADATA});
	
	        this._setStatus("error");
	    };
	
	    Box.prototype._loadResourceMetadataSuccess = function (metadata) {
	        log.info("Load resource metadata success");
	        log.info(metadata);
	
	        this._setObjState("model", {metadata: metadata});
	
	        this._checkResourceType();
	
	    };
	
	    Box.prototype._checkResourceType = function () {
	        log.info("Check Resource type");
	
	        this._getModelInfo();
	
	        var resourceType = this._getObjState("resourceRepresentationType");
	
	        log.info("Check resource type: " + resourceType);
	
	        switch (resourceType) {
	            case "dataset" :
	                var datasources = BoxUtils.getNestedProperty("metadata.dsd.datasources", this._getObjState("model"));
	
	                if (_.isArray(datasources) && datasources.length > 0) {
	
	                    if (this._getObjState("process").length > 0) {
	                        log.info("Process present. Load resource instead of fetch()");
	
	                        this._loadResource(this._getObjState("process"))
	                            .then(
	                                _.bind(this._onLoadResourceSuccess, this),
	                                _.bind(this._onLoadResourceError, this));
	
	                    } else {
	                        this._fetchResource().then(
	                            _.bind(this._fetchResourceSuccess, this),
	                            _.bind(this._fetchResourceError, this)
	                        );
	                    }
	
	                } else {
	                    log.error({code: ERR.UNKNOWN_RESOURCE_TYPE});
	                    this._setObjState("error", {code: ERR.MISSING_DATASOURCES});
	                    this._setStatus("error");
	                }
	                break;
	
	            case "geographic" :
	
	                this.setStatus("ready");
	
	                this._reactToModelStatus();
	
	                break;
	            default :
	                log.error({code: ERR.UNKNOWN_RESOURCE_TYPE});
	                this._setObjState("error", {code: ERR.UNKNOWN_RESOURCE_TYPE});
	                this._setStatus("error")
	        }
	    };
	
	    Box.prototype._fetchResource = function () {
	        log.info("Fetching FENIX resource");
	
	        this.setStatus("loading");
	
	        this._setObjState("showFilter", false);
	
	        return this.bridge.getResource({
	            body: [],
	            uid: this._getObjState("uid"),
	            version: this._getObjState("version"),
	            params: $.extend(true, {}, {perPage: 1})
	        });
	    };
	
	    Box.prototype._fetchResourceError = function (e) {
	        log.error("Impossible to fetch resource");
	        log.error(e);
	        log.error({code: ERR.FETCH_RESOURCE});
	
	        this._setObjState("error", {code: ERR.FETCH_RESOURCE});
	
	        this._setStatus("error");
	    };
	
	    Box.prototype._fetchResourceSuccess = function (resource) {
	        log.info("Fetch resource success");
	
	        this._updateModel(resource);
	
	        this._checkModelSize();
	
	    };
	
	    Box.prototype._checkModelSize = function () {
	
	        var status = this._getModelStatus();
	
	        switch (status.toLowerCase()) {
	            case  "ready" :
	                this._reactToModelStatus("to_load");
	                break;
	            default:
	                this._reactToModelStatus(status);
	        }
	
	    };
	
	    Box.prototype._getModelInfo = function () {
	
	        var rt = this._getObjState("model.metadata.meContent.resourceRepresentationType") || "",
	            resourceType = rt.toLowerCase();
	
	        log.info("Resource type is: ");
	        log.info(resourceType);
	
	        this._setObjState("resourceRepresentationType", resourceType);
	    };
	
	    Box.prototype._renderBox = function () {
	        log.info("Render box start:");
	
	        this._setStatus("ready");
	
	        this._renderBoxFaces();
	    };
	
	    Box.prototype._initTabSources = function () {
	
	        var registeredTabs = $.extend(true, {}, this.pluginRegistry),
	            tabs = this.tabs,
	            tabsKeys = Object.keys(tabs),
	            paths = [];
	
	        _.each(tabsKeys, _.bind(function (tab) {
	
	            var conf = registeredTabs[tab];
	
	            if (!conf) {
	                log.error('Registration not found for "' + tab + ' tab".');
	            }
	
	            if (!$.isPlainObject(tabs[tab])) {
	                this._setObjState("tabs." + tab, {});
	            }
	
	            this._setObjState("tabs." + tab + ".suitable", false);
	
	            if (conf.path) {
	                paths.push(conf.path);
	            } else {
	                log.error('Impossible to find path configuration for "' + tab + ' tab".');
	            }
	
	        }, this));
	
	        log.info("Tab paths found: ");
	        log.info(paths);
	    };
	
	    Box.prototype._renderBoxFaces = function () {
	
	        log.info("Render box faces");
	
	        this._updateBoxTitle();
	
	        this._renderFrontFace();
	
	        this._renderBackFace();
	
	        this._updateBoxTitle();
	
	    };
	
	    Box.prototype._updateBoxTitle = function (tl) {
	
	        var extractTitleFn = this._getObjState("title"),
	            title = typeof extractTitleFn === 'function' ? extractTitleFn.call(this, this._getObjState("model")) : extractTitleFn;
	
	        if (this.computed) {
	            title = title + i18nLabels[this._getObjState("lang")]["computed_resource"];
	        }
	        this.$boxTitle.html(tl || title);
	
	    };
	
	    Box.prototype._getModelTitle = function (model) {
	
	        var title = BoxUtils.getNestedProperty("metadata.title", model),
	            uid = BoxUtils.getNestedProperty("metadata.uid", model);
	
	        return this._getI18nLabel(title) || uid;
	
	    };
	
	    Box.prototype._getI18nLabel = function (obj) {
	
	        if (typeof obj !== "object") {
	            return "";
	        }
	
	        var languages = this.langFallbackOrder.slice(0),
	            label = "Missing label";
	
	        languages.unshift(this._getObjState("lang"));
	        languages = _.uniq(languages);
	
	        for (var i = 0; i < languages.length; i++) {
	            label = obj[languages[i]];
	
	            if (label) {
	                break;
	            }
	        }
	
	        return label;
	
	    };
	
	    // Load resource
	
	    Box.prototype._validateValues = function (values) {
	
	        this._hideFilterError();
	
	        var valid = true,
	            model = this._getObjState("model"),
	            resourceColumns = BoxUtils.getNestedProperty("metadata.dsd.columns", model) || [],
	            resourceKeyColumns = BoxUtils.cleanArray(resourceColumns.map(function (c) {
	                if (c.key === true) {
	                    return c.id;
	                }
	            })),
	            errors = [],
	            aggregations = BoxUtils.getNestedProperty("aggregations.values.aggregations", values) || [],
	            columns = BoxUtils.getNestedProperty("filter.values", values) || {},
	            columnsKey = Object.keys(columns) || [],
	            valueDimension = _.findWhere(resourceColumns, {subject: "value"}) || {},
	            valueId = valueDimension.id;
	
	
	        var sum = _.where(aggregations, {parent: 'sum'}).map(function (item) {
	                return item.value;
	            }),
	            avg = _.where(aggregations, {parent: 'avg'}).map(function (item) {
	                return item.value;
	            }),
	            first = _.where(aggregations, {parent: 'first'}).map(function (item) {
	                return item.value;
	            }),
	            last = _.where(aggregations, {parent: 'last'}).map(function (item) {
	                return item.value;
	            }),
	            group = _.where(aggregations, {parent: 'group'}).map(function (item) {
	                return item.value;
	            }),
	            sumLength = parseInt(sum.length, 10),
	            avgLength = parseInt(avg.length, 10),
	            firstLength = parseInt(first.length, 10),
	            lastLength = parseInt(last.length, 10),
	            groupLength = parseInt(group.length, 10),
	            aggregationRulesLength = sumLength + avgLength + firstLength + lastLength;
	
	        // aggregations on dataType !== number
	        _.each(sum, function (dimension) {
	
	            var column = _.findWhere(resourceColumns, {id: dimension}) || {},
	                dataType = column.dataType;
	
	            if (dataType !== 'number') {
	                errors.push({
	                    code: ERR.NO_NUMBER_DATATYPE,
	                    value: dimension,
	                    label: _.findWhere(aggregations, {value: dimension}).label
	                });
	            }
	
	        });
	        _.each(avg, function (dimension) {
	
	            var column = _.findWhere(resourceColumns, {id: dimension}) || {},
	                dataType = column.dataType;
	
	            if (dataType !== 'number') {
	                errors.push({
	                    code: ERR.NO_NUMBER_DATATYPE,
	                    value: dimension,
	                    label: _.findWhere(aggregations, {value: dimension}).label
	                });
	            }
	
	        });
	
	        //no 'value' on group by
	        if (_.contains(group, valueId)) {
	
	            var valueInGroupBy = _.findWhere(aggregations, {value: valueId});
	
	            errors.push({
	                code: ERR.VALUE_IN_GROUP_BY,
	                value: valueInGroupBy.value,
	                label: valueInGroupBy.label
	            });
	        }
	
	        //if aggregation rules -> group has to be populated
	        if (aggregationRulesLength > 0 && groupLength === 0) {
	            errors.push({
	                code: ERR.MISSING_GROUP_BY
	            });
	        }
	
	        //if group by is populated -> value in aggregation rules
	        if (groupLength > 0) {
	
	            var isValueInAggregationRules =
	                _.contains(sum, valueId) || _.contains(avg, valueId) || _.contains(first, valueId) || _.contains(last, valueId);
	
	            if (!isValueInAggregationRules) {
	                errors.push({
	                    code: ERR.MISSING_VALUE_IN_AGGREGATION_RULES
	                });
	            }
	        }
	
	        //no exclude key dimensions
	        var excludedColumns = _.difference(resourceKeyColumns, columnsKey);
	        if (columnsKey.length > 0 && excludedColumns.length > 0) {
	
	            var labels = _.map(excludedColumns, _.bind(function (dim) {
	                return _.findWhere(resourceColumns, {id: dim}).title[this._getObjState("lang")]
	            }, this));
	
	            errors.push({
	                code: ERR.EXCLUDE_KEY_DIMENSION,
	                value: labels,
	                label: labels.join(", ")
	            });
	        }
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    Box.prototype._createQuery = function (payload) {
	
	        var self = this,
	            filter = [],
	            filterStep,
	            groupStep,
	            computed = false;
	
	        filterStep = createFilterStep(payload);
	
	        groupStep = createGroupStep(payload);
	
	        if (filterStep) {
	            computed = true;
	            filter.push(filterStep);
	        }
	
	        if (groupStep) {
	            computed = true;
	            filter.push(groupStep);
	        }
	
	        this.computed = computed;
	
	        return filter;
	
	        function createFilterStep(payload) {
	
	            var step = {
	                    name: "filter",
	                    parameters: {}
	                },
	                hasValues = false,
	                columns = Object.keys(BoxUtils.getNestedProperty('filter.values', payload) || {}),
	                rowValues = payload.rows || {},
	                resourceColumns = BoxUtils.getNestedProperty("metadata.dsd.columns", self._getObjState("model")) || [],
	                columnsSet = resourceColumns
	                    .filter(function (c) {
	                        return !Utils._endsWith(c.id, "_" + self._getObjState("lang").toUpperCase()) && !Utils._endsWith(c.id,"_EN");
	                    })
	                    .map(function (c) {
	                        return c.id;
	                    }).sort(),
	                valueDimension = _.findWhere(resourceColumns, {subject: "value"});
	
	            if (Object.getOwnPropertyNames(rowValues).length > 0) {
	                step.parameters.rows = rowValues;
	                hasValues = true;
	            } else {
	                log.warn("Filter.rows not included");
	            }
	
	            if (columns.length > 0 && !_.contains(columns, valueDimension.id)) {
	                columns.push(valueDimension.id);
	            }
	
	            //If they are equals it means i want to include all columns so no filter is needed
	            columns = columns.sort();
	
	            if (columns.length > 0 && !_.isEqual(columnsSet, columns)) {
	                step.parameters.columns = columns;
	                hasValues = true;
	            } else {
	                log.warn("Filter.columns not included");
	            }
	
	            return hasValues ? step : null;
	
	        }
	
	        function createGroupStep(payload) {
	
	            if (!payload.aggregations) {
	                return;
	            }
	
	            var step = {
	                    name: "group",
	                    parameters: {}
	                },
	                hasValues = false,
	                values = BoxUtils.getNestedProperty("aggregations.values.aggregations", payload),
	                by = [],
	                sum = [],
	                avg = [],
	                first = [],
	                last = [],
	                aggregations = [];
	
	            _.each(values, function (obj) {
	
	                switch (obj.parent.toLowerCase()) {
	                    case "group":
	                        by.push(obj.value);
	                        break;
	                    case "sum":
	                        sum.push(obj.value);
	                        break;
	                    case "avg":
	                        avg.push(obj.value);
	                        break;
	                    case "first":
	                        first.push(obj.value);
	                        break;
	                    case "last":
	                        last.push(obj.value);
	                        break;
	                }
	
	            });
	
	            sum = BoxUtils.cleanArray(sum).map(function (i) {
	                return {"columns": [i], "rule": "SUM"};
	            });
	
	            avg = BoxUtils.cleanArray(avg).map(function (i) {
	                return {"columns": [i], "rule": "AVG"};
	            });
	
	            first = BoxUtils.cleanArray(first).map(function (i) {
	                return {"columns": [i], "rule": "FIRST"};
	            });
	
	            last = BoxUtils.cleanArray(last).map(function (i) {
	                return {"columns": [i], "rule": "LAST"};
	            });
	
	            //Add group by
	            if (by.length > 0) {
	                step.parameters.by = BoxUtils.cleanArray(by);
	                hasValues = true
	            }
	
	            //Add aggregations
	            _.each([sum, avg, first, last], function (a) {
	
	                if (a.length > 0) {
	                    aggregations = _.uniq(_.union(aggregations, a), false);
	                }
	
	            });
	
	            if (aggregations.length > 0) {
	                step.parameters.aggregations = aggregations;
	                hasValues = true
	            }
	
	            return hasValues ? step : null;
	        }
	    };
	
	    // Front face
	
	    Box.prototype._renderFrontFace = function () {
	        log.info("Start rendering box front face");
	
	        var faces = this._getObjState("faces");
	
	        if (!_.contains(faces, 'front') || this.frontFaceIsRendered === true) {
	            log.warn("Abort 'front' face rendering. face is already rendered: " + this.frontFaceIsRendered + ", config render face: " + _.contains(faces, 'front'));
	            return;
	        }
	
	        this.frontFaceIsRendered = true;
	
	        this._checkSuitableTabs();
	
	        //TODO enforce logic
	        //check is resource type is dataset
	        if (this._getObjState("resourceRepresentationType") === 'dataset') {
	            this._showMenuItem("download");
	        } else {
	            log.warn("Download menu item not show because resource is not 'dataset'");
	        }
	
	        this._showDefaultFrontTab();
	
	    };
	
	    Box.prototype._bindFrameEventListeners = function () {
	
	        var self = this;
	
	        this.$el.find(s.FRONT_FACE).find("[data-action]").each(function () {
	
	            var $this = $(this),
	                action = $this.data("action"),
	                event = self._getEventTopic(action);
	
	            $this.on("click", {event: event, box: self}, function (e) {
	                e.preventDefault();
	
	                log.info("Raise event: " + e.data.event);
	
	                amplify.publish(event, {target: this, box: e.data.box, state: self.getState()});
	
	            });
	        });
	
	    };
	
	    Box.prototype._showFrontTab = function (tab, opts, force) {
	        log.info('Show tab ' + tab);
	        log.info(opts);
	
	        var tabs = this.tabs;
	
	        //check if it is a valid tab
	        if (!tabs[tab]) {
	            log.error("Error on show tab content: ", tab);
	
	            log.error({code: ERR.MISSING_TAB});
	
	            this._setObjState("error", {code: ERR.MISSING_TAB});
	
	            this._setStatus("error");
	
	            return;
	        }
	
	        var currentTab = this._getObjState("tab"),
	            currentOpts = this._getObjState("tabOptions")[currentTab];
	
	        //TODO check if currentTab is undefined
	
	        if (!force && currentTab === tab && _.isEqual(currentOpts, opts)) {
	            log.info("Aborting show tab current tab is equal to selected one");
	            return;
	        }
	
	        if (this._getObjState("tabs." + tab + ".suitable") !== true) {
	            log.error("Aborting show tab because selected tab is not suitable with current model");
	            //TODO find first suitable tab and then raise error
	            return;
	        }
	
	        log.info("Show '" + tab + "' tab for result id: " + this.id);
	
	        //if opts is empty get default options
	        if (!opts) {
	            opts = BoxUtils.getNestedProperty("options", this.tabs[tab])
	        }
	
	        this._setObjState("tab", tab);
	        this._setObjState("tabOptions." + tab, opts);
	
	        //hide all tabs and show the selected one
	        this.$el.find(s.CONTENT_READY).attr("data-tab", this._getObjState("tab"));
	
	        this._showTabContent();
	    };
	
	    Box.prototype._showTabContent = function () {
	
	        var tabs = this.tabs,
	            tab = this._getObjState("tab");
	
	        if (!tabs[tab]) {
	            log.error("Error on show tab content: " + tab);
	
	            log.error({code: ERR.MISSING_TAB});
	
	            this._setObjState("error", {code: ERR.MISSING_TAB});
	
	            this._setStatus("error");
	
	            return;
	        }
	
	        this._setObjState("tabs." + tab + ".initialized", true);
	
	        this._callTabInstanceMethod({tab: tab, method: "show", opt1: this._getObjState("tabOptions")[tab]});
	
	    };
	
	    Box.prototype._createTabInstance = function (tab) {
	
	        var state = this._getObjState("tabStates." + tab) || {},
	            model = $.extend(true, {}, this._getObjState("model")),
	            registry = this.pluginRegistry,
	            language = this._getObjState("lang") || C.lang,
	            //Note that for sync call the argument of require() is not an array but a string
	            Tab = __webpack_require__(59)(this._getPluginPath(registry[tab]) + ".js"),
	            config = $.extend(true, {}, state, {
	                el: this._getTabContainer(tab),
	                box: this,
	                lang: language,
	                model: model,
	                id: tab + "_" + this.id,
	                environment: this._getObjState("environment"),
	                cache: this._getObjState("cache"),
	                serviceProvider: this.serviceProvider,
	                config: this._getObjState("tabConfig")[tab],
	                nls : this._getObjState("nls")
	            }),
	            instance;
	
	        instance = new Tab(config);
	        //Subscribe to tab events
	        instance.on('filter', _.bind(this._onTabToolbarChangeEvent, this));
	
	        instance.on('state', _.bind(this._onTabStateChangeEvent, this, tab));
	
	        instance.on('initialized', _.bind(this._onInitializatedEvent, this));
	
	        instance.on('title.change', _.bind(this._onTitleChangeEvent, this, tab));
	
	        //cache the plugin instance
	        this.front_tab_instances[tab] = instance;
	
	        return instance;
	
	    };
	
	    Box.prototype._onTitleChangeEvent = function (tab, title) {
	
	        this._updateBoxTitle(title);
	    };
	
	    Box.prototype._getTabInstance = function (tab, face) {
	
	        return face === 'back' ? this.back_tab_instances[tab] : this.front_tab_instances[tab];
	    };
	
	    Box.prototype._getTabContainer = function (tab) {
	
	        var $container = this.$el.find(s.FRONT_CONTENT).find("[data-section='" + tab + "']");
	
	        if ($container.length === 0) {
	
	            $container = $('<div data-section="' + tab + '"></div>');
	            this.$el.find(s.FRONT_CONTENT).append($container)
	        }
	
	        return $container;
	    };
	
	    Box.prototype._checkSuitableTabs = function () {
	
	        var registeredTabs = this.pluginRegistry,
	            tabsKeys = Object.keys(this.tabs);
	
	        _.each(tabsKeys, _.bind(function (tab) {
	            var conf = registeredTabs[tab];
	
	            if (!conf) {
	                log.error('Registration not found for "' + tab + ' tab".');
	            }
	
	            if (conf.path) {
	
	                this._createTabInstance(tab);
	
	                this._setObjState("tabs." + tab + ".suitable",
	                    this._callTabInstanceMethod({tab: tab, method: 'isSuitable'}));
	
	                log.info(tab + " tab is suitable? ", this._callTabInstanceMethod({tab: tab, method: 'isSuitable'}))
	
	                if (this._getObjState("tabs." + tab + ".suitable") === true) {
	                    this._showMenuItem(tab);
	                } else {
	                    this._hideMenuItem(tab);
	                }
	
	            } else {
	                log.error('Impossible to find path configuration for "' + tab + ' tab".');
	            }
	        }, this));
	
	        this._syncFrontTabs();
	
	    };
	
	    Box.prototype._showDefaultFrontTab = function () {
	
	        var tab = this._getObjState("tab") || C.tab,
	            defaultTabIsSuitable = this._getObjState("tabs." + tab + ".suitable"),
	            options = this._getObjState("tabOptions." + tab);
	
	        if (defaultTabIsSuitable !== true) {
	            log.warn("Default tab is not suitable. Find first suitable tab to show");
	
	            var tabsKeys = Object.keys(this.tabs),
	                found = false;
	
	            _.each(tabsKeys, _.bind(function (t) {
	
	                if (!found === this._getObjState("tabs." + t + ".suitable") === true) {
	
	                    tab = t;
	                }
	
	            }, this));
	
	        }
	
	        this._showFrontTab(tab, options, true);
	    };
	
	    Box.prototype._syncFrontTabs = function () {
	        log.info("Send front 'sync' signal");
	
	        var tabsKeys = Object.keys(this.tabs);
	
	        _.each(tabsKeys, _.bind(function (tab) {
	
	            if (this._getObjState("tabs." + tab + ".suitable") === true) {
	
	                this._callTabInstanceMethod({
	                    tab: tab,
	                    method: 'sync',
	                    opt1: this._getObjState("sync") || {}
	                });
	            }
	
	        }, this));
	
	    };
	
	    // Back face
	
	    Box.prototype._renderBackFace = function () {
	        log.info("Start rendering box back face");
	
	        var faces = this._getObjState("faces");
	
	        if (!_.contains(faces, 'back') || this.backFaceIsRendered === true) {
	            log.warn("Abort 'front' face rendering. face is already rendered: " + this.backFaceIsRendered + ", confing render face: " + _.contains(faces, 'front'))
	            return;
	        }
	        this.backFaceIsRendered = true;
	
	        this._hideFilterError();
	
	        this._createProcessSteps();
	
	        this._renderProcessSteps();
	
	        this._bindBackFaceEventListeners();
	
	    };
	
	    Box.prototype._bindBackFaceEventListeners = function () {
	
	        var self = this;
	
	        this.$el.find(s.BTN_SIDEBAR).on("click", _.bind(function () {
	            this.$el.find(s.SIDEBAR).toggleClass('hidden-xs hidden-sm');
	        }, this));
	
	        this.$el.find(s.BACK_FACE).find("[data-action]").each(function () {
	
	            var $this = $(this),
	                action = $this.data("action"),
	                event = self._getEventTopic(action);
	
	            $this.on("click", {event: event, box: self}, function (e) {
	                e.preventDefault();
	
	                log.info("Raise box event: " + e.data.event);
	
	                amplify.publish(event, {target: this, box: e.data.box, state: self.getState()});
	            });
	        });
	    };
	
	    Box.prototype._createProcessSteps = function () {
	
	        var filterConfiguration,
	            aggregationConfiguration,
	            mapConfiguration,
	            model;
	
	        filterConfiguration = this._createBackTabConfiguration("filter");
	
	        aggregationConfiguration = this._createBackTabConfiguration("aggregations");
	
	        mapConfiguration = this._createBackTabConfiguration("map");
	
	        model = $.extend(true, {}, this._getObjState("model"));
	
	        this.processSteps = [];
	
	        if (this._stepControlAccess("metadata")) {
	
	            var title = BoxUtils.getNestedProperty("metadata.title", model) || {},
	                uid = BoxUtils.getNestedProperty("metadata.uid", model),
	                label = title[this._getObjState("lang")] ? title[this._getObjState("lang")] : uid;
	
	            this.processSteps.push({
	                tab: "metadata",
	                id: "metadata",
	                model: model,
	                labels: {
	                    title: label
	                }
	            });
	        }
	
	        if (this._stepControlAccess("filter")) {
	            this.processSteps.push({
	                id: "filter",
	                tab: "filter",
	                values: filterConfiguration.values,
	                config: filterConfiguration.config,
	                template: filterConfiguration.template,
	                onReady: filterConfiguration.onReady,
	                labels: {
	                    title: this._getObjState("nls")["step_filter"]
	                }
	            });
	        }
	
	        if (this._stepControlAccess("aggregations")) {
	
	            this.processSteps.push({
	                id: "aggregations",
	                tab: "filter",
	                values: aggregationConfiguration.values,
	                config: aggregationConfiguration.filter,
	                template: aggregationConfiguration.template,
	                labels: {
	                    title: this._getObjState("nls")["step_aggregations"]
	                }
	            });
	        }
	
	        /*if (this._stepControlAccess("map")) {
	         this.processSteps.push({
	         id: "map",
	         tab: "filter",
	         values: mapConfiguration.values,
	         config: mapConfiguration.filter,
	         template: mapConfiguration.template,
	         onReady: mapConfiguration.onReady,
	         labels: {
	         title: this._getObjState("nls")["step_map"]
	         }
	         });
	         }*/
	    };
	
	    Box.prototype._stepControlAccess = function (tab) {
	
	        var resourceType = this._getObjState("resourceRepresentationType");
	
	        switch (tab.toLowerCase()) {
	            case "metadata" :
	                return true;
	            case "filter" :
	                return resourceType === 'dataset';
	            case "aggregations" :
	                return resourceType === 'dataset';
	            case "map" :
	                return this._getObjState("tabs.map.suitable");
	            default :
	                return false;
	        }
	    };
	
	    Box.prototype._createBackTabConfiguration = function (tab) {
	
	        var configuration,
	            filterValues = this._getObjState("backFilter") || {},
	            mapValues = this._getObjState("backMap") || {};
	
	        switch (tab.toLowerCase()) {
	            case 'aggregations':
	                configuration = this._createBackAggregationTabConfiguration(filterValues[tab]);
	                break;
	            case 'filter':
	                configuration = this._createBackFilterTabConfiguration(filterValues[tab]);
	                break;
	            case 'map':
	                configuration = this._createBackMapTabConfiguration(mapValues[tab]);
	                break;
	            default :
	                configuration = {};
	        }
	
	        return configuration;
	    };
	
	    Box.prototype._createBackFilterTabConfiguration = function (values) {
	
	        var self = this,
	            forbiddenIds = ["value"],
	            forbiddenSubjects = ["value"];
	
	        var columnsFromDsd = BoxUtils.getNestedProperty("metadata.dsd.columns", this._getObjState("model")) || [],
	            cols = columnsFromDsd.filter(function (col) {
	                return !_.contains(forbiddenSubjects, col.subject);
	            }),
	            columns = cols
	                .filter(function (col) {
	                    return !_.contains(forbiddenIds, col.id.toLowerCase());
	                })
	                .filter(function (c) {
	                    return !Utils._endsWith(c.id, "_" + self._getObjState("lang").toUpperCase()) && !Utils._endsWith(c.id,"_EN");
	                }),
	            config;
	
	        config = Utils.createConfiguration({
	            model: this._getObjState("model"),
	            common: {
	                selector: {
	                    hideSummary: true
	                },
	                template: {
	                    hideSwitch: true,
	                    hideHeader: false
	                }
	            }
	        });
	
	        //TODO remove workaround with default lang in createConfiguration()
	        var x = {};
	        _.each(config, function (value, key) {
	            if ( !Utils._endsWith(key, "_" + self._getObjState("lang").toUpperCase()) && !Utils._endsWith(key,"_EN") ) {
	                x[key] = value;
	            }
	        });
	
	        return {
	
	            values: values,
	
	            config: x,
	
	            template: FilterFilterTemplate({columns: columns}),
	
	            onReady: _.bind(function () {
	
	                var mySwiper = new Swiper(this.$el.find(s.ROWS_SWIPER), {
	                    // Optional parameters
	                    //direction: 'vertical',
	                    //loop: true,
	
	                    // If we need pagination
	                    pagination: this.$el.find(s.ROWS_SWIPER).find('.swiper-pagination'),
	                    paginationClickable: true,
	
	                    // Navigation arrows
	                    nextButton: this.$el.find(s.ROWS_SWIPER).find('.swiper-button-next'),
	                    prevButton: this.$el.find(s.ROWS_SWIPER).find('.swiper-button-prev'),
	
	                    slidesPerView: 'auto',
	                    //centeredSlides: true,
	                    //spaceBetween: 30,
	                    //freeMode: true,
	                    simulateTouch: false
	
	                    // And if we need scrollbar
	                    //scrollbar: '.swiper-scrollbar',
	                })
	
	            }, this)
	
	        };
	    };
	
	    Box.prototype._createBackMapTabConfiguration = function (values) {
	
	        return $.extend(true, {}, {
	
	            values: values,
	
	            filter: {
	                layers: {
	                    selector: {
	                        id: "tree",
	                        source: _.map(mapEarthstatLayers, function (layer) {
	
	                            var title = layer.Title.replace('area', '').replace('3857', '');
	
	                            return {
	                                label: _str.humanize(title),
	                                value: 'earthstat:' + layer.Name
	                            };
	                        }),
	                        config: {core: {multiple: true}}
	                    },
	                    dependencies: {
	                        "layergroups": {id: "focus", event: "select"}
	                    },
	                    template: {
	                        title: "Select layers to show on map",
	                        hideSwitch: true,
	                        hideRemoveButton: true
	                    }
	                }
	            },
	
	            template: FilterMapTemplate({layers: []}),
	
	            onReady: _.bind(function (payload) {
	
	            }, this)
	
	        });
	    };
	
	    Box.prototype._createBackAggregationTabConfiguration = function (values) {
	
	        var source = this._getSourceForAggregationTabConfiguration();
	
	        return $.extend(true, {}, {
	
	            values: values,
	
	            filter: {
	                aggregations: {
	                    selector: {
	                        id: "sortable",
	                        source: source, // Static data
	                        config: {
	                            groups: {
	                                dimensions: this._getObjState("nls")['aggregations_dimensions'],
	                                group: this._getObjState("nls")['aggregations_group'],
	                                sum: this._getObjState("nls")['aggregations_sum'],
	                            }
	                        }
	                    },
	                    template: {
	                        hideHeader: true
	                    }
	                }
	            },
	
	            template: FilterAggregationTemplate(this._getObjState("nls"))
	        });
	    };
	
	    Box.prototype._getSourceForAggregationTabConfiguration = function () {
	
	        //TODO integrate fenixTool
	
	        var source = [],
	            lang = this._getObjState("lang").toUpperCase(),
	            columns = BoxUtils.getNestedProperty("metadata.dsd.columns", this._getObjState("model"));
	
	        _.each(columns, function (c) {
	
	            var title,
	                label,
	                isI18n,
	                t;
	
	            if (!Utils._endsWith(c.id, "_" + lang) && !Utils._endsWith(c.id, "_EN")) {
	
	                title = BoxUtils.getNestedProperty("title", c);
	                isI18n = typeof title === 'object' ? title : {};
	                t = isI18n[lang] || isI18n[Object.keys(title)[0]];
	
	                if (t) {
	                    label = t;
	                } else {
	                    window.fx_vis_box_missing_title >= 0 ? window.fx_vis_box_missing_title++ : window.fx_vis_box_missing_title = 0;
	                    label = "Missing dimension title [" + c.id + "]";
	                }
	                source.push($.extend(true, {}, {
	                    value: c.id,
	                    parent: "dimensions",
	                    label: label
	                }));
	            }
	        });
	
	        return source;
	    };
	
	    Box.prototype._renderProcessSteps = function () {
	
	        var self = this,
	            readyEventCounter = 0,
	            list = this.processSteps;
	
	        _.each(list, _.bind(function (step, index) {
	
	            var $html = $(steps[step.tab]($.extend(true, {}, step, this._getObjState("nls"), this._getObjState("model"), this._getObjState("model"))));
	
	            this._bindStepLabelEventListeners($html, step);
	
	            this.$processSteps.append($html);
	
	            var registry = this.pluginRegistry,
	                Tab = __webpack_require__(59)(this._getPluginPath(registry[step.tab]) + ".js");
	
	            //Add details container
	            var $el = this.$processStepDetails.find("[data-tab='" + step.id + "']");
	            if ($el.length === 0) {
	                $el = $("<li data-tab='" + step.id + "'></li>");
	
	                if (index !== 0) {
	                    $el.hide();
	                }
	                this.$processStepDetails.append($el);
	            }
	
	            //render tab
	            var Instance = new Tab({
	                el: $el,
	                box: this,
	                cache: this._getObjState("cache"),
	                serviceProvider: this.serviceProvider,
	                model: $.extend(true, {}, this._getObjState("model")),
	                config: step.config,
	                lang: this._getObjState("lang"),
	                values: step.values || {},
	                id: step.tab + "_" + step.id,
	                labels: step.labels,
	                template: step.template,
	                onReady: step.onReady,
	                environment: this._getObjState("environment")
	            });
	
	            if (typeof step.onReady === 'function') {
	                Instance.on("ready", _.bind(step.onReady, this));
	            }
	
	            this.back_tab_instances[step.id] = Instance;
	
	            onTabReady.call(this);
	
	        }, this));
	
	        function onTabReady() {
	
	            readyEventCounter++;
	
	            if (list.length === readyEventCounter) {
	
	                //Remove disable from query btn
	                this.$el.find(s.BACK_CONTENT).find(s.QUERY_BUTTON).attr("disabled", false);
	                self._bindStepEventListeners();
	                self._onBackTabsReady();
	            }
	        }
	    };
	
	    Box.prototype._onBackTabsReady = function () {
	
	        var first = Object.keys(this.back_tab_instances)[0];
	
	        this._showBackTab(first);
	
	    };
	
	    Box.prototype._bindStepLabelEventListeners = function ($html, step) {
	
	        $html.on("click", {step: step}, _.bind(function (e) {
	
	            this._showBackTab(e.data.step.id);
	
	        }, this));
	    };
	
	    Box.prototype._showBackTab = function (tab) {
	
	        //show details
	        this.$processStepDetails.find(">li").hide();
	        this.$processStepDetails.find(">li[data-tab='" + tab + "']").show();
	
	        //active handler
	        this.$processSteps.find("[data-tab]").removeClass("active");
	        this.$processSteps.find("[data-tab='" + tab + "']").addClass("active");
	
	        this.back_tab_instances[tab].show(this._getBackSyncModel());
	
	    };
	
	    Box.prototype._bindStepEventListeners = function () {
	
	        var aggregationInstance = this.back_tab_instances["aggregations"],
	            filterInstance = this.back_tab_instances["filter"];
	
	        if (aggregationInstance && filterInstance) {
	
	            filterInstance.on("change", _.bind(this._onBackFilterChangeEvent, this));
	
	            aggregationInstance.on("change", _.bind(this._onBackFilterChangeEvent, this));
	        }
	    };
	
	    Box.prototype._onBackFilterChangeEvent = function () {
	
	        var values = this._getBackFilterValues(),
	            valid = this._validateValues(values);
	
	        if (valid !== true) {
	            this._printFilterError(valid);
	            return;
	        } else {
	            log.warn("Invalid back filter values:");
	            log.warn(valid);
	        }
	
	        this._syncBackTabs();
	
	    };
	
	    Box.prototype._getBackSyncModel = function () {
	
	        var self = this,
	            sync = {},
	            source = [],
	            values = this._getBackFilterValues(),
	            columns = BoxUtils.getNestedProperty("metadata.dsd.columns", self._getObjState("model")) || [],
	            columnsSet = columns
	                .filter(function (c) {
	                    return !Utils._endsWith(c.id, "_" + self._getObjState("lang").toUpperCase());
	                })
	                .map(function (c) {
	                    return c.id;
	                }).sort(),
	            aggregationsValues = BoxUtils.getNestedProperty("aggregations.values.aggregations", values) || [],
	            enabledColumns = BoxUtils.getNestedProperty("filter.values", values) || {},
	            enabledColumnsIds = Object.keys(enabledColumns).length > 0 ? Object.keys(enabledColumns) : columnsSet,
	            filterIsInitialized = !$.isEmptyObject(enabledColumns),
	            resourceColumns = BoxUtils.getNestedProperty("metadata.dsd.columns", this._getObjState("model")) || [],
	            resourceColumnsIds = _.map(resourceColumns, function (col) {
	                return col.id;
	            }),
	            disabledColumnsIds = _.without.apply(_, [resourceColumnsIds].concat(enabledColumnsIds)),
	            valueDimension = _.findWhere(resourceColumns, {subject: "value"}) || {};
	
	        if (filterIsInitialized === true || aggregationsValues.length > 0) {
	
	            _.each(aggregationsValues, _.bind(function (item) {
	
	                if (!_.contains(disabledColumnsIds, item.value) || valueDimension.id === item.value) {
	                    addToSource(item.value);
	                }
	
	            }, this));
	
	            _.each(resourceColumnsIds, _.bind(function (id) {
	
	                if (!_.contains(disabledColumnsIds, id) && !_.findWhere(source, {value: id})) {
	                    addToSource(id)
	                }
	
	            }, this));
	
	        } else {
	
	            // if filter is not initialized get default source
	            source = this._getSourceForAggregationTabConfiguration();
	        }
	
	
	        //add value dimension
	        addToSource(valueDimension.id);
	
	        //TODO clear the code above because it is a workaround
	
	        if (source.length > 0) {
	            var agg = _.uniq(source, function (item, key, a) {
	                return item.value;
	            }).filter(function (item) {
	                return !Utils._endsWith(item.value, "_" + self._getObjState("lang").toUpperCase()) && !Utils._endsWith(item.value, "_EN");
	            });
	
	            BoxUtils.assign(sync, "values.aggregations", agg);
	
	        }
	
	        return sync;
	
	        function addToSource(id) {
	
	            var item = _.findWhere(aggregationsValues, {value: id}),
	                inSource = _.findWhere(source, {value: id});
	
	            if (!!inSource || !id) {
	                log.info("Not include dimension because already present: " + id);
	                return;
	            }
	
	            if (!item) {
	
	                var col = _.findWhere(resourceColumns, {id: id}),
	                    label = col.title[self._getObjState("lang").toUpperCase()] || col.title[Object.keys(col.title)[0]];
	
	                source.push({
	                    value: id,
	                    parent: "dimensions",
	                    label: label
	                })
	            } else {
	                source.push(item);
	            }
	        }
	    };
	
	    Box.prototype._syncBackTabs = function () {
	
	        var aggregationInstance = this.back_tab_instances["aggregations"],
	            sync = this._getBackSyncModel();
	
	
	        if (aggregationInstance) {
	            aggregationInstance.setValues(sync);
	        }
	    };
	
	    // Event binding and callbacks
	
	    Box.prototype._bindEventListeners = function () {
	
	        var self = this;
	
	        amplify.subscribe(this._getEventTopic("remove"), this, this._onRemoveEvent);
	
	        amplify.subscribe(this._getEventTopic("resize"), this, this._onResizeEvent);
	
	        amplify.subscribe(this._getEventTopic("clone"), this, this._onCloneEvent);
	
	        amplify.subscribe(this._getEventTopic("flip"), this, this._onFlipEvent);
	
	        amplify.subscribe(this._getEventTopic("metadata"), this, this._onMetadataEvent);
	
	        amplify.subscribe(this._getEventTopic("tab"), this, this._onTabEvent);
	
	        amplify.subscribe(this._getEventTopic("minimize"), this, this._onMinimizeEvent);
	
	        amplify.subscribe(this._getEventTopic("query"), this, this._onQueryEvent);
	
	        amplify.subscribe(this._getEventTopic("filter"), this, this._onFilterEvent);
	
	        amplify.subscribe(this._getEventTopic("download"), this, this._onDownloadEvent);
	
	        amplify.subscribe(this._getEventTopic("noelem"), this, this._onNoElemEvent);
	
	        this.$el.find(s.RIGHT_MENU).on('click', "a", function (e) {
	            e.preventDefault();
	        });
	
	        this.$el.find(s.OTHER_CONTENT).find("[data-action]").each(function () {
	
	            var $this = $(this),
	                action = $this.data("action"),
	                event = self._getEventTopic(action);
	
	            $this.on("click", {event: event, box: self}, function (e) {
	                e.preventDefault();
	
	                log.info("Raise box event: " + e.data.event);
	
	                amplify.publish(event, {target: this, box: e.data.box, state: self.getState()});
	
	            });
	        });
	
	        //download events
	        this.report.on("export.success", function () {  /* TODO add feedback*/
	        });
	
	        this._bindFrameEventListeners();
	
	    };
	
	    Box.prototype._onLoadedEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("loaded"));
	        console.log('IT IS LOADED!');
	    }
	
	    Box.prototype._onRemoveEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("remove"));
	        log.info(payload);
	
	        var r = confirm(this._getObjState("nls").confirm_remove),
	            state = $.extend(true, {}, this.getState());
	
	        if (r == true) {
	            amplify.publish(EVT['remove'], this);
	
	            this._dispose();
	
	            this._trigger("remove", state);
	        } else {
	            log.info("Abort remove");
	        }
	
	    };
	
	    Box.prototype._onResizeEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("resize"));
	        log.info(payload);
	
	        var size;
	
	        if (payload.target && $(payload.target).data("size")) {
	
	            size = $(payload.target).data("size");
	            log.info("Size: " + size);
	
	            this._setSize(size);
	        }
	    };
	
	    Box.prototype._onCloneEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("clone"));
	        log.info(payload);
	
	        var state = $.extend(true, {}, this.getState());
	
	        //Exclude id for publish events
	        amplify.publish(this._getEventTopic("clone", true), state);
	
	        this._trigger("clone", state);
	    };
	
	    Box.prototype._onFlipEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("flip"));
	        log.info(payload);
	
	        if (this._getObjState('face') !== "back") {
	            this._flip("back");
	        } else {
	            this._flip("front");
	        }
	
	        log.info("Set box face to: " + this._getObjState('face'));
	
	    };
	
	    Box.prototype._onMetadataEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("metadata"));
	        log.info(payload);
	
	        this.showTab('metadata');
	    };
	
	    Box.prototype._onMinimizeEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("minimize"));
	        log.info(payload);
	
	        var state = $.extend(true, {}, this.getState());
	
	        //Exclude id for publish events
	        amplify.publish(this._getEventTopic("minimize", true), state);
	
	        this._trigger("minimize", state);
	
	        this.dispose();
	    };
	
	    Box.prototype._onTabEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("tab"));
	        log.info(payload);
	
	        var opts = {};
	        opts.type = $(payload.target).data("type");
	
	        this._showFrontTab($(payload.target).data("tab"), opts);
	
	    };
	
	    Box.prototype._onTabToolbarChangeEvent = function (values) {
	
	        if (!_.isEmpty(values.values)) {
	            this._setObjState("sync.toolbar", values);
	            this._syncFrontTabs();
	        } else {
	            log.warn("Abort sync");
	        }
	
	    };
	
	    Box.prototype._onTabStateChangeEvent = function (tab, state) {
	
	        this._setObjState("tabStates." + tab, state);
	    };
	
	    Box.prototype._onInitializatedEvent = function (payload) {
	
	        this._trigger("initializated", payload);
	    };
	
	    Box.prototype._onQueryEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("query"));
	        log.info(payload);
	
	        var filterValues = this._getBackFilterValues(),
	            valid = this._validateValues(filterValues),
	            mapValues = this._getBackMapValues(),
	            mapIsEmpty = everyPropertyIsEmptyArray(BoxUtils.getNestedProperty("map.values", mapValues));
	
	        if (valid === true) {
	
	            this._enableFlip();
	
	            // check filter values
	
	            var process = this._createQuery(filterValues) || [];
	
	            if (!_.isEqual(process, this._getObjState("process"))) {
	
	                this._setObjState("backFilter", $.extend(true, {}, filterValues));
	
	                this._setObjState("process", process.slice(0));
	
	                log.info("D3P process", process);
	
	                this._loadResource(process)
	                    .then(
	                        _.bind(this._onLoadResourceSuccess, this),
	                        _.bind(this._onLoadResourceError, this));
	
	            }
	            else {
	                log.warn("Abort resource filter because process have not changed");
	            }
	
	            // check map values
	
	            if (!mapIsEmpty && !_.isEqual(mapValues, this._getObjState("backMap"))) {
	
	                this._setObjState("backMap", $.extend(true, {}, mapValues));
	
	                this._updateMap();
	
	            }
	            else {
	                log.warn("Abort map update because values have not changed");
	            }
	
	            this._flip("front");
	
	        }
	        else {
	            this._printFilterError(valid);
	        }
	
	        function everyPropertyIsEmptyArray(obj) {
	            var valid = true;
	
	            _.each(obj, function (key) {
	
	                if (!Array.isArray(key) || key.length > 0) {
	                    valid = false;
	                }
	
	            });
	
	            return valid;
	        }
	
	    };
	
	    Box.prototype._updateMap = function () {
	
	        if (this._getObjState("tabs.map.suitable") !== true) {
	            log.warn("Abort map update because map table is not suitable for current resource");
	            return;
	        }
	
	        var mapValues = this._getObjState("backMap").map;
	
	        this._setObjState("sync.map", mapValues);
	
	        this._syncFrontTabs();
	
	        var currentTab = this._getObjState('tab');
	
	        this._showFrontTab(currentTab);
	
	    };
	
	    Box.prototype._onNoElemEvent = function (param) {
	        // this._setStatus("noelem");
	        // this._trigger("noelem");
	
	        this._trigger("noelem", param)
	    };
	
	    Box.prototype._onDownloadEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("download"));
	        log.info(payload);
	
	        if (this._getObjState("resourceRepresentationType") !== 'dataset') {
	            log.warn("Abort download because resource is not 'dataset'");
	            return;
	        }
	
	        var target = $(payload.target).attr("data-target") || "";
	
	        switch (target.toLocaleLowerCase()) {
	            case "data":
	                log.info("Data download");
	                this._downloadData();
	                break;
	            case "metadata":
	                log.info("Metadata download");
	                this._downloadMetadata();
	                break;
	            default :
	                log.warn("Unknown download target");
	
	        }
	    };
	
	    Box.prototype._downloadData = function () {
	
	        var payload = {
	            resource: this._getObjState("model"),
	            input: {
	                config: {}
	            },
	            output: {
	                config: {
	                    lang: this._getObjState("lang").toUpperCase()
	                }
	            }
	        };
	
	        log.info("Configure FENIX export: table");
	
	        this._getObjState("lang").toUpperCase()
	
	        if(this.computed) payload.output.config.notes = i18nLabels[this._getObjState("lang").toLowerCase()]['computed_export'];
	
	        if((this.initial)&&(this.initial.filterSelection)) payload.output.config.notes = this.initial.filterSelection.notes;
	
	        log.info(payload);
	
	        this.report.export({
	            format: "table",
	            config: payload
	        });
	    };
	
	    Box.prototype._getMetadataTemplate = function (context) {
	
	        // performance wise
	        console.log(context);
	        if (context == "undefined") return 'fao';
	        if (context === 'uneca') return context;
	        if (String(context).includes("cstat")) return 'cstat';
	
	        return 'fao';
	
	    };
	
	
	    Box.prototype._downloadMetadata = function () {
	
	        var model = this._getObjState("model"),
	            title = BoxUtils.getNestedProperty("metadata.title", model) || {},
	            fileName = title[this._getObjState("lang")] ? title[this._getObjState("lang")] : "fenix_export",
	            contextSystem = BoxUtils.getNestedProperty("metadata.dsd.contextSystem", model),
	            template = this._getMetadataTemplate(contextSystem);
	
	        var payload = {
	            resource: {
	                metadata: {
	                    uid: BoxUtils.getNestedProperty("metadata.uid", model)
	                },
	                data: []
	            },
	            input: {
	                config: {}
	            },
	            output: {
	                config: {
	                    template: template,
	                    lang: this._getObjState("lang").toUpperCase(),
	                    fileName: fileName.replace(/[^a-z0-9]/gi, '_') + '.pdf'
	                }
	            }
	        };
	
	        log.info("Configure FENIX export: metadata");
	
	        log.info(payload);
	
	        this.report.export({
	            format: "metadata",
	            config: payload
	        });
	    };
	
	    Box.prototype._onFilterEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("filter"));
	        log.info(payload);
	
	        this._forceModelFilter();
	    };
	
	    // flip
	
	    Box.prototype._flip = function (f) {
	
	        var face = f || "front";
	
	        switch (face.toLocaleLowerCase()) {
	            case "front" :
	                this.$el.find(s.FLIP_CONTAINER).removeClass(C.flippedClassName);
	                break;
	            case "back" :
	                this.$el.find(s.FLIP_CONTAINER).addClass(C.flippedClassName);
	                break;
	        }
	
	        this._setObjState('face', face);
	
	    };
	
	    Box.prototype._disableFlip = function () {
	        this.$el.find(s.FLIP_BUTTONS).attr("disabled", true);
	    };
	
	    Box.prototype._enableFlip = function () {
	        this.$el.find(s.FLIP_BUTTONS).attr("disabled", false);
	    };
	
	    // error handling
	
	    Box.prototype._printFilterError = function (errors) {
	
	        var self = this,
	            err = {},
	            $message = $("<ul class='list-unstyled'></ul>");
	
	        _.each(errors, function (obj) {
	
	            if (!err[obj.code]) {
	                err[obj.code] = [];
	            }
	
	            err[obj.code].push(obj.label);
	
	        });
	
	        _.each(err, function (values, e) {
	            $message.append($('<li>' + self._getObjState("nls")[e] + '</li>'))
	        });
	
	        this._showFilterError($message);
	    };
	
	    Box.prototype._showFilterError = function (err) {
	
	        this.$el.find(s.BACK_FILTER_ERRORS).html(err).show();
	    };
	
	    Box.prototype._hideFilterError = function () {
	
	        this.$el.find(s.BACK_FILTER_ERRORS).hide();
	    };
	
	    Box.prototype._getBackFilterValues = function () {
	
	        var prevValues = this.forceModelFilter === true ? {} : this._getObjState('backFilter') || {},
	            filterValues = this.back_tab_instances["filter"] ? this.back_tab_instances["filter"].getValues(null) : null,
	            aggregationValues = this.back_tab_instances["aggregations"] ? this.back_tab_instances["aggregations"].getValues(null) : null,
	            rowValues = this.back_tab_instances["filter"] ? this.back_tab_instances["filter"].getValues('fenix') : null;
	
	        var payload = {
	            filter: !_.isEqual(filterValues, prevValues.filter) ? filterValues : prevValues.filter,
	            aggregations: !_.isEqual(aggregationValues, prevValues.aggregations) ? aggregationValues : prevValues.aggregations,
	            rows: !_.isEqual(rowValues, prevValues.rows) ? rowValues : prevValues.rows
	        };
	
	        return $.extend(true, {}, payload);
	
	    };
	
	    Box.prototype._getBackMapValues = function () {
	
	        var prevValues = this._getObjState('backMap') || {},
	            mapValues = this.back_tab_instances["map"] ? this.back_tab_instances["map"].getValues(null) : null;
	
	        var payload = {
	            map: !_.isEmpty(mapValues) ? mapValues : prevValues
	        };
	
	        return $.extend(true, {}, payload);
	
	    };
	
	    // Box menu
	
	    Box.prototype._renderMenu = function () {
	
	        var self = this;
	
	        if (this.hasMenu === true) {
	
	            this.rightMenu = new JsonMenu({
	                el: this.$el.find(s.RIGHT_MENU),
	                model: this._getObjState("menuModel").map(function (i) {
	                    return $.extend(i, {label: i18nLabels[self._getObjState("lang")]["menu_" + i.id]})
	                })
	            });
	
	        } else {
	            log.warn("Menu will not be rendered. Impossible to find container.")
	        }
	
	    };
	
	    Box.prototype._showMenuItem = function (item) {
	
	        if (this.hasMenu) {
	            this.rightMenu.showItem(item);
	        }
	    };
	
	    Box.prototype._hideMenuItem = function (item) {
	
	        if (this.hasMenu) {
	            this.rightMenu.hideItem(item);
	        }
	    };
	
	    // Internal methods
	
	    Box.prototype._callTabInstanceMethod = function (obj) {
	
	        var Instance = this._getTabInstance(obj.tab, obj.face);
	
	        if (Instance && $.isFunction(Instance[obj.method])) {
	            return Instance[obj.method](obj.opt1, obj.opt2);
	
	        } else {
	            log.error(obj.tab + " tab does not implement the " + obj.method + "() fn");
	        }
	
	
	    };
	
	    Box.prototype._trigger = function (channel) {
	        if (!this.channels[channel]) {
	            return false;
	        }
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0, l = this.channels[channel].length; i < l; i++) {
	            var subscription = this.channels[channel][i];
	            subscription.callback.apply(subscription.context, args);
	        }
	        return this;
	    };
	
	    Box.prototype._setStatus = function (status) {
	        log.info("Set '" + status + "' status for result id: " + this.id);
	
	        this._setObjState("status", status);
	
	        this.$el.find(s.BOX).attr("data-status", this._getObjState("status"));
	
	        switch (this._getObjState("status").toLowerCase()) {
	            case "error" :
	
	                var error = this._getObjState("error");
	
	                this.$el.find(s.ERROR_TEXT).html(this._getObjState("nls")[error.code] ? this._getObjState("nls")[error.code] : error.code);
	
	                //hide/show filter button
	                if (error.filter === true) {
	                    this.$el.find(s.EMPTY_FILTER_BUTTON).show();
	                } else {
	                    this.$el.find(s.EMPTY_FILTER_BUTTON).hide();
	                }
	
	                break;
	            case "empty" :
	
	                var $filterBtn = this.$el.find(s.EMPTY_FILTER_BUTTON);
	
	                this._getObjState("showFilter") ?
	                    $filterBtn.show() :
	                    $filterBtn.hide();
	
	                break;
	        }
	
	    };
	
	    Box.prototype._setSize = function (size) {
	
	        //TODO check if it is a valid size
	
	        if (this._getObjState("size") === size) {
	            log.info("Aborting resize because current size is equal to selected one");
	            return;
	        }
	
	        this._setObjState("size", size);
	
	        this.$el.find(s.BOX).attr("data-size", this._getObjState("size"));
	
	        var state = $.extend(true, {}, this.getState());
	
	        amplify.publish(EVT["resize"], this);
	
	        this._trigger("resize", state);
	
	        //keep after trigger for now
	        this._redrawTabs();
	
	    };
	
	    Box.prototype._redrawTabs = function () {
	
	        var tab = this._getObjState("tab");
	
	        this._callTabInstanceMethod({tab: tab, method: "redraw"});
	
	        this._syncFrontTabs();
	
	    };
	
	    Box.prototype._getEventTopic = function (evt, excludeId) {
	
	        var baseEvent = EVT[evt] ? EVT[evt] : evt;
	
	        return excludeId === true ? baseEvent : baseEvent + "." + this.id;
	    };
	
	    Box.prototype._forceModelFilter = function () {
	
	        log.warn("Force model filter");
	        this.forceModelFilter = true;
	
	        this._disableFlip();
	
	        this._flip("back");
	
	        this._renderBackFace();
	
	        this._setStatus("ready");
	
	    };
	
	    // Disposition
	
	    Box.prototype._dispose = function () {
	
	        this._unbindEventListeners();
	
	        this._disposeBoxFaces();
	
	        this.$el.remove();
	
	        this._trigger("dispose");
	
	        delete this;
	
	    };
	
	    Box.prototype._disposeBoxFaces = function () {
	
	        this._disposeFrontFace();
	
	        this._disposeBackFace();
	
	    };
	
	    Box.prototype._disposeFrontFace = function () {
	
	        var tabs = this.front_tab_instances,
	            keys = Object.keys(tabs);
	
	        _.each(keys, _.bind(function (tab) {
	
	            this._callTabInstanceMethod({tab: tab, method: "dispose"});
	
	        }, this));
	
	        this.frontFaceIsRendered = false;
	
	    };
	
	    Box.prototype._disposeBackFace = function () {
	
	        var tabs = this.back_tab_instances,
	            keys = Object.keys(tabs);
	
	        _.each(keys, _.bind(function (tab) {
	
	            this._callTabInstanceMethod({tab: tab, method: "dispose", face: "back"});
	
	        }, this));
	
	        this.$el.find(s.BACK_FACE).find("[data-action]").off();
	
	        this.$processSteps.empty();
	
	        this.backFaceIsRendered = false;
	
	    };
	
	    Box.prototype._unbindEventListeners = function () {
	
	        amplify.unsubscribe(this._getEventTopic("remove"), this._onRemoveEvent);
	
	        amplify.unsubscribe(this._getEventTopic("resize"), this._onResizeEvent);
	
	        amplify.unsubscribe(this._getEventTopic("clone"), this._onCloneEvent);
	
	        amplify.unsubscribe(this._getEventTopic("flip"), this._onFlipEvent);
	
	        amplify.unsubscribe(this._getEventTopic("metadata"), this._onMetadataEvent);
	
	        amplify.unsubscribe(this._getEventTopic("tab"), this._onTabEvent);
	
	        amplify.unsubscribe(this._getEventTopic("minimize"), this._onMinimizeEvent);
	
	        amplify.unsubscribe(this._getEventTopic("query"), this._onQueryEvent);
	
	        amplify.unsubscribe(this._getEventTopic("filter"), this._onFilterEvent);
	
	        amplify.unsubscribe(this._getEventTopic("download"), this._onDownloadEvent);
	
	        amplify.unsubscribe(this._getEventTopic("noelem"), this._onNoElemEvent);
	
	        this.$el.find("[data-action]").off();
	
	        this.$el.find(s.RIGHT_MENU).off();
	
	        this.$el.find(s.OTHER_CONTENT).find("[data-action]").off();
	
	        this.$el.find(s.FRONT_FACE).find("[data-action]").off();
	
	    };
	
	    // Utils
	
	    Box.prototype._getPluginPath = function (id) {
	        return pluginFolder + id.path;
	    };
	
	    return Box;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    return {
	
	        status : "loading",
	        tab : "table",
	        size : "full",
	        face : "front", // back || front
	        faces : ["front", "back"],
	        pluginRegistry: {
	            'blank': {
	                path: 'blank'
	            },
	            'table': {
	                path: 'table'
	            },
	            'map': {
	                path: 'map'
	            },
	            'chart': {
	                path:'chart'
	            },
	            'metadata': {
	                path:'metadata'
	            },
	            'filter': {
	                path:'filter'
	            },
	            'download': {
	                path:'download'
	            }
	        },
	        tabs: {
	            //blank: {options : {}},
	            table: {options : {}},
	            metadata: {options : {}},
	            filter: {options : {}},
	            map: {options : {}},
	            chart: {options : {type : "line"}},
	            download: { options : {}}
	        },
	
	        tabConfig : {
	            //:id : { /*...*/}
	        },
	
	        flippedClassName : "flipped",
	
	        state : {},
	
	        lang : "FR",
	
	        langFallbackOrder : ["EN", "FR", "ES", "AR", "PR"],
	
	        //Tabs
	        toolbarPosition : "up", // up | down
	
	        //Load resource
	        loadResourceServiceQueryParams : {
	            dsd : true
	        },
	
	        syncTabsOnToolbarChange : false,
	
	        renderVisualizationComponents : true,
	
	        maxDataSize : 3500,
	
	        minDataSize : 0,
	
	        cache : false
	
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    var prefix = "";
	
	    return {
	
	        MISSING_CONTAINER: prefix + "missing_container",
	        LOAD_RESOURCE: prefix + "load_resource",
	        LOAD_METADATA: prefix + "load_metadata",
	        MISSING_TAB: prefix + "missing_tab",
	        FETCH_RESOURCE: prefix + "fetch_resource",
	        MISSING_DATASOURCES: prefix + "missing_datasources",
	        UNKNOWN_RESOURCE_TYPE: prefix + "unknown_resource_type",
	        MISSING_GEO_COLUMN: prefix + "missing_geo_column",
	
	        //Back filter datatype
	        NO_NUMBER_DATATYPE: prefix + "no_number_datatype",
	        VALUE_IN_GROUP_BY: prefix + "value_in_group_by",
	        MISSING_GROUP_BY: prefix + "missing_group_by",
	        MISSING_VALUE_IN_AGGREGATION_RULES: prefix + "missing_value_in_aggregation_rules",
	        GROUP_BY_CONTAINS_NO_KEY: prefix + "group_by_contains_no_key",
	        EXCLUDE_KEY_DIMENSION: prefix + "exclude_key_dimension",
	
	        INCOMPATIBLE_RESOURCE_TYPE: prefix + "incompatible_resource_type",
	        RESOURCE_STATUS: prefix + "resource_status"
	
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    var prefix = "fx.visualization.";
	
	    return {
	
	        remove: prefix + "remove",
	        resize: prefix + "resize",
	        clone: prefix + "clone",
	        flip: prefix + "flip",
	        metadata: prefix + "metadata",
	        tab: prefix + "tab",
	        query: prefix + "query",
	        
	        toolbar: prefix + "toolbar",
	
	        model_done : "model.done",
	        model_error : "model.error"
	
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(2),
	    __webpack_require__(4),
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(8),
	    __webpack_require__(10),
	    __webpack_require__(11)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, log, _, C, ERR, EVT, FenixTool, i18nLabels) {
	
	    'use strict';
	
	    function Utils() {
	        this.fenixTool = new FenixTool();
	        return this;
	    }
	
	    //Toolbar configurations
	
	    Utils.prototype._getToolbarConfig = function (Model, opts) {
	
	        return this.fenixTool.toFilter(Model, opts);
	    };
	
	    Utils.prototype.getTableToolbarConfig = function (Model, opts) {
	
	        return this._getToolbarConfig(Model, opts);
	    };
	
	    Utils.prototype.getChartToolbarConfig = function (Model, opts) {
	        return this._getToolbarConfig(Model, $.extend(opts, {
	            rowLabel: i18nLabels.series,
	            columnsLabel: i18nLabels.xAxis,
	            valuesLabel: i18nLabels.yAxis
	        }));
	    };
	
	    Utils.prototype.getMapToolbarConfig = function (Model, opts) {
	
	        return {};
	    };
	
	    //Creators configurations
	
	    Utils.prototype.getChartCreatorConfiguration = function (values) {
	
	        return this.fenixTool.toChartConfig(values);
	    };
	
	    Utils.prototype.getTableCreatorConfiguration = function (values) {
	
	        return this.fenixTool.toTableConfig(values);
	    };
	
	    Utils.prototype.getMapCreatorConfiguration = function (values) {
	
	        return this.fenixTool.toTableConfig(values);
	    };
	
	    /* COMMONS */
	
	    Utils.prototype.assign = function (obj, prop, value) {
	        if (typeof prop === "string")
	            prop = prop.split(".");
	
	        if (prop.length > 1) {
	            var e = prop.shift();
	            this.assign(obj[e] =
	                    Object.prototype.toString.call(obj[e]) === "[object Object]"
	                        ? obj[e]
	                        : {},
	                prop,
	                value);
	        } else {
	            obj[prop[0]] = value;
	        }
	    };
	
	    Utils.prototype.getNestedProperty = function (path, obj) {
	
	        var obj = $.extend(true, {}, obj),
	            arr = path.split(".");
	
	        while (arr.length && (obj = obj[arr.shift()]));
	
	        return obj;
	
	    };
	
	    Utils.prototype.cleanArray = function (actual) {
	        var newArray = [];
	        for (var i = 0; i < actual.length; i++) {
	            if (actual[i]) {
	                newArray.push(actual[i]);
	            }
	        }
	        return newArray;
	    };
	
	    return new Utils();
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global define*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(12),
	        __webpack_require__(13)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18nEn, i18nFr) {
	
	        'use strict';
	
	        return {
	
	            en: i18nEn,
	            fr: i18nFr
	        }
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    return {
	
	        confirm_remove : "Remove resource?",
	        submit_button : "Submit",
	        reset_button : "Reset",
	        add_button : "Add",
	        remove_button : "Remove",
	        cancel_button : "Cancel",
	
	        computed_resource : " (computed)",
	        computed_export : "This is a computed resource.",
	
	        back_current_resource : "Resources",
	        no_number_datatype : "Impossible to aggregate for [{{ dimensions }}] because the data type is not number",
	        value_in_group_by : "'Value' dimension can not be in group by",
	        missing_group_by : "Specify at least one 'group by'",
	        missing_value_in_aggregation_rules : "'Value' should be in Sum, Average, First or Last",
	        group_by_contains_no_key : "'Group by' can contains only key dimensions",
	        exclude_key_dimension : "The dimensions [{{ dimensions }}] can not be excluded because keys.",
	
	        aggregations_dimensions : "Dimensions",
	        aggregations_group : "Group by",
	        aggregations_sum : "Sum",
	        aggregations_avg : "Average",
	        aggregations_first : "First",
	        aggregations_last : "Last",
	
	        map_select_overlay : "Select Overlayer",
	        map_baselayers: "Base Layers",
	        map_selected_layers: "Selected Layers",
	        map_show_bounds: "Show Map Boundaries",
	        map_show_labels: "Show Map Labels",
	
	        //back steps
	        step_metadata : "Metadata",
	        step_filter: "Filter",
	        step_aggregations : "Aggregations",
	        step_map : "Earthstat Layer Collection",
	
	        series : "Series",
	        xAxis : "X Axis",
	        yAxis : "Y Axis",
	
	        tooltip_right_menu : "Settings",
	        tooltip_remove_button : "Close resource",
	        tooltip_resize_button : "Resize resource",
	        tooltip_clone_button : "Clone resource",
	        tooltip_flip_button : "Resource filtering",
	        tooltip_metadata_button : "Visualize metadata",
	        tooltip_minimize_button : "Minimize resource",
	        tooltip_download_button : "Download resource",
	        tooltip_toolbar_button : "Visualization options",
	
	        //Error content
	        error_content_title : "An error occurred",
	        error_content_text : "You can remove the AVB, please use the button below",
	        empty_content_title : "The result is empty",
	        empty_content_text : "You can remove the AVB or redo the filtering, please use the button below",
	        huge_content_title : "The result is too big for the visualization",
	        huge_content_text : "You can redo the filtering, please use the button below",
	
	        //menu
	        menu_download : "Download",
	        menu_download_data : "Resource",
	        menu_download_metadata : "Metadata",
	        menu_visualize_as : "Visualize as",
	        menu_visualize_as_chart : "Chart",
	        menu_chart_line : "Line",
	        menu_chart_column : "Column",
	        menu_chart_column_stacked : "Column stacked",
	        menu_chart_area : "Area",
	        menu_visualize_as_map : "Map",
	        menu_visualize_as_table : "Table",
	        menu_size : "Size",
	        menu_full : "Full",
	        menu_half : "Half",
	
	        //table toolbar
	        tab_table_toolbar_format : "Format",
	        tab_table_toolbar_decimals : "Decimals",
	        tab_table_toolbar_show : "Show",
	        tab_table_toolbar_dimensionsSort : "Sort dimension",
	        tab_table_toolbar_aggregationValue : "Aggregator for Value",
	        tab_table_toolbar_rows : "Rows",
	        tab_table_toolbar_columns : "Columns",
	        tab_table_toolbar_hidden : "Hidden",
	        tab_table_toolbar_values : "Values",
	        tab_table_toolbar_aggregations : "Aggregations",
	        tab_table_toolbar_unit : "Unit",
	        tab_table_toolbar_flag : "Flag",
	        tab_table_toolbar_code : "Code"
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    return {
	
	        confirm_remove : "Voulez-vou supprimer la ressource?",
	        submit_button : "Envoyer",
	        reset_button : "Réinitialiser",
	        add_button : "Ajouter",
	        remove_button : "Supprimer",
	        cancel_button : "Annuler",
	
	        computed_resource : " (calculé)",
	        computed_export : "Il s'agit d'une ressource calculée.",
	
	        back_current_resource : "Ressources",
	        no_number_datatype : "Impossible agréger par [{{ dimensions }}] parce que le type de données n’est pas un nombre",
	        value_in_group_by : "La dimension 'Valeur' ne peut pas être dans le groupe par",
	        missing_group_by : "Spécifier au moins un 'groupe par'",
	        missing_value_in_aggregation_rules : "'Valeur' doit être dan Somme, Moyenne, Premier ou Dernier",
	        group_by_contains_no_key : "'Groupe par' peut contenir seulement des dimensions",
	        exclude_key_dimension : "Les dimensions [{{ dimensions }}] ne peuvent pas être exclues parce qu’elles sont clés.",
	        aggregations_dimensions : "Dimensions",
	        aggregations_group : "Grouper par",
	        aggregations_sum : "Somme",
	        aggregations_avg : "Moyenne",
	        aggregations_first : "Premier",
	        aggregations_last : "Dernier",
	
	        map_select_overlay : "Sélectionner la Surcouche",
	        map_baselayers: "Couches de base",
	        map_selected_layers: "Couches sélectionnés",
	        map_show_bounds: "Voir la carte des limites",
	        map_show_labels: "Voir la carte des étiquettes",
	
	        //back steps
	        step_metadata : "Métadonnées",
	        step_filter: "Filtrer",
	        step_aggregations : "Agrégations",
	        step_map : "Collection de Couche Earthstat",
	        series : "Série",
	        xAxis : "Axe X",
	        yAxis : "Axe Y",
	        tooltip_right_menu : "Paramètres",
	        tooltip_remove_button : "Fermer la ressource",
	        tooltip_resize_button : "Redimensionner la ressource",
	        tooltip_clone_button : "Dupliquer la ressource",
	        tooltip_flip_button : "Filtrer la ressource",
	        tooltip_metadata_button : "Visualiser les métadonnées",
	        tooltip_minimize_button : "Minimiser la ressource",
	        tooltip_download_button : "Télécharger la ressource",
	        tooltip_toolbar_button : "Options de Visualisation ",
	
	        //Error content
	        error_content_title : "Une erreur est survenue",
	        error_content_text : "Vous pouvez supprimer l’AVB en utilisant le bouton ci-dessous",
	        empty_content_title : "Le résultat est vide",
	        empty_content_text : "Vous pouvez supprimer l’AVB ou refaire le filtrage en utilisant le bouton ci-dessous",
	        huge_content_title : "Le résultat est trop vaste pour être visualisé",
	        huge_content_text : "Vous pouvez refaire le filtrage en utilisant le bouton ci-dessous",
	
	        //menu
	        menu_download : "Téléchargement",
	        menu_download_data : "Ressource",
	        menu_download_metadata : "Métadonnées",
	        menu_visualize_as : "Visualiser comme",
	        menu_visualize_as_chart : "Graphique",
	        menu_chart_line : "En ligne",
	        menu_chart_column : "En colonnes",
	        menu_chart_column_stacked : "En colonnes empilées",
	        menu_chart_area : "En zone",
	        menu_visualize_as_map : "Carte",
	        menu_visualize_as_table : "Tableau",
	        menu_size : "Largeur",
	        menu_full : "Largeur complète",
	        menu_half : "Demi-largeur",
	
	        //table toolbar
	        tab_table_toolbar_format : "Format",
	        tab_table_toolbar_decimals : "Décimales",
	        tab_table_toolbar_show : "Montrer",
	        tab_table_toolbar_dimensionsSort : "Ordre des dimensions",
	        tab_table_toolbar_aggregationValue : "Agrégateur pour Valeur",
	        tab_table_toolbar_rows : "Lignes",
	        tab_table_toolbar_columns : "Colonnes",
	        tab_table_toolbar_hidden : "Caché",
	        tab_table_toolbar_values : "Valeurs",
	        tab_table_toolbar_aggregations : "Agrégations",
	        tab_table_toolbar_unit : "Unité",
	        tab_table_toolbar_flag : "Flag",
	        tab_table_toolbar_code : "Code"
	
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : {};
	
	  return "\n                            <div data-role=\"front-toolbar\" class=\"vb-toolbar front-toolbar clearfix\">\n\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideMenu : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                                <h6 data-role=\"box-title\" class=\"box-title fx-text-primary-color truncate\"\n                                    data-grid=\"fx-grid-item-handle\"></h6>\n\n                                <div class=\"btn-group toolbar-cmd-right\">\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideFlipButton : depth0),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideDownloadButton : depth0),{"name":"unless","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideCloneButton : depth0),{"name":"unless","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideMinimizeButton : depth0),{"name":"unless","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideRemoveButton : depth0),{"name":"unless","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                                </div>\n                            </div>\n\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : {};
	
	  return "\n                                    <div class=\"toolbar-cmd-left\">\n                                        <div data-role=\"right-menu\" class=\"dropdown pull-left\"\n                                             title=\""
	    + container.escapeExpression(((helper = (helper = helpers.tooltip_right_menu || (depth0 != null ? depth0.tooltip_right_menu : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"tooltip_right_menu","hash":{},"data":data}) : helper)))
	    + "\">\n\n                                            <button class=\"btn btn-default\" type=\"button\" data-toggle=\"dropdown\">\n                                                <span class=\"icojam_preview_list\"></span>\n                                            </button>\n                                        </div>\n\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideMetadataButton : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                                    </div>\n\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                                            <button data-action=\"metadata\" class=\"btn btn-default meta-btn pull-left\"\n                                                    type=\"button\" title=\""
	    + container.escapeExpression(((helper = (helper = helpers.tooltip_metadata_button || (depth0 != null ? depth0.tooltip_metadata_button : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"tooltip_metadata_button","hash":{},"data":data}) : helper)))
	    + "\">META\n                                            </button>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                                        <button data-action=\"flip\" class=\"btn btn-default\" type=\"button\"\n                                                title=\""
	    + container.escapeExpression(((helper = (helper = helpers.tooltip_flip_button || (depth0 != null ? depth0.tooltip_flip_button : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"tooltip_flip_button","hash":{},"data":data}) : helper)))
	    + "\">\n                                            <span class=\"icojam_options_1\"></span>\n                                        </button>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                                        <button data-action=\"download\" data-target=\"data\" class=\"btn btn-default\"\n                                                title=\""
	    + container.escapeExpression(((helper = (helper = helpers.tooltip_download_button || (depth0 != null ? depth0.tooltip_download_button : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"tooltip_download_button","hash":{},"data":data}) : helper)))
	    + "\"\n                                                type=\"button\">\n                                            <span class=\"icojam_download_1\"></span>\n                                        </button>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                                        <button data-action=\"clone\" class=\"btn btn-default\" type=\"button\"\n                                                title=\""
	    + container.escapeExpression(((helper = (helper = helpers.tooltip_clone_button || (depth0 != null ? depth0.tooltip_clone_button : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"tooltip_clone_button","hash":{},"data":data}) : helper)))
	    + "\">\n                                            <span class=\"icojam_wedding_jewel\"></span>\n                                        </button>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                                        <button data-action=\"minimize\" class=\"btn btn-default\" type=\"button\"\n                                                title=\""
	    + container.escapeExpression(((helper = (helper = helpers.tooltip_minimize_button || (depth0 != null ? depth0.tooltip_minimize_button : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"tooltip_minimize_button","hash":{},"data":data}) : helper)))
	    + "\">\n                                            <span class=\"icojam_view_roll-up_1\"></span>\n                                        </button>\n";
	},"13":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                                        <button data-action=\"remove\" class=\"btn btn-default\" type=\"button\"\n                                                title=\""
	    + container.escapeExpression(((helper = (helper = helpers.tooltip_remove_button || (depth0 != null ? depth0.tooltip_remove_button : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"tooltip_remove_button","hash":{},"data":data}) : helper)))
	    + "\">\n                                            <span class=\"icojam_button_delete_1\"></span>\n                                        </button>\n";
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : {};
	
	  return "\n                            <div data-role=\"back-toolbar\" class=\"vb-toolbar back-toolbar clearfix\">\n\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideMenu : depth0),{"name":"unless","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                                <h6 data-role=\"box-title\" class=\"box-title fx-text-primary-color truncate\"></h6>\n\n                                <div class=\"btn-group toolbar-cmd-right\">\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideFlipButton : depth0),{"name":"unless","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideDownloadButton : depth0),{"name":"unless","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideCloneButton : depth0),{"name":"unless","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideMinimizeButton : depth0),{"name":"unless","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideRemoveButton : depth0),{"name":"unless","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                                </div>\n                            </div>\n\n";
	},"16":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "\n                                    <div class=\"toolbar-cmd-left\">\n                                        <div data-role=\"right-menu\" class=\"dropdown pull-left\">\n\n                                            <button class=\"btn btn-default\" type=\"button\" data-toggle=\"dropdown\">\n                                                <span class=\"icojam_preview_list\"></span>\n                                            </button>\n                                        </div>\n"
	    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.hideMetadataButton : depth0),{"name":"unless","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                                    </div>\n\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    return "                                            <button data-action=\"metadata\" class=\"btn btn-default meta-btn pull-left\"\n                                                    type=\"button\">META\n                                            </button>\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    return "                                        <button data-action=\"flip\" class=\"btn btn-default\" type=\"button\">\n                                            <span class=\"icojam_options_1\"></span>\n                                        </button>\n";
	},"21":function(container,depth0,helpers,partials,data) {
	    return "                                        <button data-action=\"download\" data-target=\"data\" class=\"btn btn-default\"\n                                                type=\"button\">\n                                            <span class=\"icojam_download_1\"></span>\n                                        </button>\n";
	},"23":function(container,depth0,helpers,partials,data) {
	    return "                                        <button data-action=\"clone\" class=\"btn btn-default\" type=\"button\">\n                                            <span class=\"icojam_wedding_jewel\"></span>\n                                        </button>\n";
	},"25":function(container,depth0,helpers,partials,data) {
	    return "                                        <button data-action=\"minimize\" class=\"btn btn-default\" type=\"button\">\n                                            <span class=\"icojam_view_roll-up_1\"></span>\n                                        </button>\n";
	},"27":function(container,depth0,helpers,partials,data) {
	    return "                                        <button data-action=\"remove\" class=\"btn btn-default\" type=\"button\">\n                                            <span class=\"icojam_button_delete_1\"></span>\n                                        </button>\n";
	},"29":function(container,depth0,helpers,partials,data) {
	    return "                    <button data-action=\"remove\" class=\"btn btn-floating fx-background-color-primary-color btn-fx-status-btn\" type=\"button\">\n                        <span class=\"icojam_minus\"></span>\n                    </button>\n";
	},"31":function(container,depth0,helpers,partials,data) {
	    return "\n                    <button data-action=\"remove\" class=\"btn btn-floating fx-background-color-primary-color btn-fx-status-btn\" type=\"button\">\n                        <span class=\"icojam_minus\"></span>\n                    </button>\n\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "    <div data-role=\"box\" class=\"fx-box\" data-status=\""
	    + alias4(((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"status","hash":{},"data":data}) : helper)))
	    + "\" data-size=\""
	    + alias4(((helper = (helper = helpers.size || (depth0 != null ? depth0.size : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"size","hash":{},"data":data}) : helper)))
	    + "\">\n\n        <div data-content=\"ready\" data-tab=\""
	    + alias4(((helper = (helper = helpers.default_tab || (depth0 != null ? depth0.default_tab : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"default_tab","hash":{},"data":data}) : helper)))
	    + "\">\n\n            <div data-role=\"flip-container\" class=\"flip-container\">\n\n                <div class=\"flipper\">\n\n                    <!-- Front -->\n                    <div class=\"front\" data-face=\"front\">\n                        <!-- front content -->\n\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideToolbar : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                        <div data-role=\"front-content\" class=\"front-content\">\n\n                            <div data-section=\"chart\"></div>\n                            <div data-section=\"map\"></div>\n                            <div data-section=\"table\"></div>\n                            <div data-section=\"blank\"></div>\n                            <div data-section=\"metadata\"></div>\n                            <div data-section=\"filter\"></div>\n                            <div data-section=\"download\"></div>\n\n                        </div>\n\n                    </div>\n\n                    <!-- back -->\n                    <div class=\"back\" data-face=\"back\">\n\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideToolbar : depth0),{"name":"unless","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                        <div data-role=\"back-content\" class=\"container-fluid back-content\">\n                            <div class=\"alert alert-danger\" role=\"alert\" data-role=\"filter-error\">...</div>\n                            <div class=\"row back-row\">\n                                <div data-role='back-sidebar' class=\"col-xs-12 col-sm-8 col-md-4 hidden-xs hidden-sm\">\n                                    <div class=\"sidebar-content\">\n                                        <h6 class=\"sidebar-title\">"
	    + alias4(((helper = (helper = helpers.back_current_resource || (depth0 != null ? depth0.back_current_resource : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"back_current_resource","hash":{},"data":data}) : helper)))
	    + "</h6>\n                                        <div class=\"process-steps-container\">\n                                            <ul data-role='process-steps' class=\"list-unstyled list-group\"></ul>\n                                        </div>\n\n                                    </div>\n                                </div>\n\n                                <button data-action=\"show-back-sidebar\"\n                                        class=\"btn btn-floating fx-background-color-primary-color btn-fx-toolbar visible-sm visible-xs show-back-sidebar\"\n                                        type=\"button\"><span class=\"icojam_grid_32\"></span></button>\n\n                                <div class=\"col-md-8 col-xs-12 back-right-content\">\n\n                                    <ul data-role=\"process-details\"\n                                        class=\"list-unstyled list-group process-details\"></ul>\n\n                                    <div class=\"row\">\n                                        <div class=\"col-xs-12\">\n                                            <div class=\"btn-group pull-right back-btns\">\n\n                                                <button type=\"button\" data-action=\"flip\"\n                                                        class=\"btn btn-default\">"
	    + alias4(((helper = (helper = helpers.cancel_button || (depth0 != null ? depth0.cancel_button : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"cancel_button","hash":{},"data":data}) : helper)))
	    + "\n                                                </button>\n                                                <button type=\"button\" data-action=\"query\" class=\"btn btn-primary fx-button-primary-color\"\n                                                        disabled>"
	    + alias4(((helper = (helper = helpers.submit_button || (depth0 != null ? depth0.submit_button : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"submit_button","hash":{},"data":data}) : helper)))
	    + "</button>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                </div>\n\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n\n        </div>\n\n        <div data-content=\"error\" class=\"text-center\">\n\n            <div class=\"content-message text-center\">\n                <div class=\"content-message-img error-img\"></div>\n\n                <h2>"
	    + alias4(((helper = (helper = helpers.error_content_title || (depth0 != null ? depth0.error_content_title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"error_content_title","hash":{},"data":data}) : helper)))
	    + "</h2>\n                <p>"
	    + alias4(((helper = (helper = helpers.error_content_text || (depth0 != null ? depth0.error_content_text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"error_content_text","hash":{},"data":data}) : helper)))
	    + "</p>\n\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideRemoveButton : depth0),{"name":"unless","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            </div>\n\n        </div>\n\n        <div data-content=\"loading\" class=\"text-center\">\n            <span class=\"loading loading-48\"></span>\n        </div>\n\n        <div data-content=\"empty\" class=\"text-center\">\n\n            <div class=\"content-message text-center\">\n                <div class=\"content-message-img empty-img\"></div>\n                <h2>"
	    + alias4(((helper = (helper = helpers.empty_content_title || (depth0 != null ? depth0.empty_content_title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"empty_content_title","hash":{},"data":data}) : helper)))
	    + "</h2>\n                <p>"
	    + alias4(((helper = (helper = helpers.empty_content_text || (depth0 != null ? depth0.empty_content_text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"empty_content_text","hash":{},"data":data}) : helper)))
	    + "</p>\n\n                <button data-action=\"filter\" class=\"btn btn-floating fx-background-color-primary-color btn-fx-status-btn\" type=\"button\">\n                    <span class=\"icojam_filter\"></span>\n                </button>\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideRemoveButton : depth0),{"name":"unless","hash":{},"fn":container.program(31, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            </div>\n\n        </div>\n\n        <div data-content=\"huge\" class=\"text-center\">\n\n            <div class=\"content-message text-center\">\n                <div class=\"content-message-img huge-img\"></div>\n                <h2>"
	    + alias4(((helper = (helper = helpers.huge_content_title || (depth0 != null ? depth0.huge_content_title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"huge_content_title","hash":{},"data":data}) : helper)))
	    + "</h2>\n                <p>"
	    + alias4(((helper = (helper = helpers.huge_content_text || (depth0 != null ? depth0.huge_content_text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"huge_content_text","hash":{},"data":data}) : helper)))
	    + "</p>\n\n                <button data-action=\"filter\" class=\"btn btn-floating fx-background-color-primary-color btn-fx-status-btn\" type=\"button\">\n                    <span class=\"icojam_filter\"></span>\n                </button>\n\n            </div>\n\n        </div>\n\n\n        <div data-content=\"toomany\" class=\"text-center\">\n\n            <div class=\"content-message text-center\">\n                <div class=\"content-message-img huge-img\"></div>\n                <h2>"
	    + alias4(((helper = (helper = helpers.huge_content_title || (depth0 != null ? depth0.huge_content_title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"huge_content_title","hash":{},"data":data}) : helper)))
	    + "</h2>\n                <p>"
	    + alias4(((helper = (helper = helpers.error_content_text || (depth0 != null ? depth0.error_content_text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"error_content_text","hash":{},"data":data}) : helper)))
	    + "</p>\n\n                <button data-action=\"remove\" class=\"btn btn-floating fx-background-color-primary-color btn-fx-status-btn\" type=\"button\">\n                    <span class=\"icojam_minus\"></span>\n                </button>\n\n            </div>\n\n        </div>\n\n    </div>\n";
	},"useData":true});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// Create a simple path alias to allow browserify to resolve
	// the runtime on a supported path.
	module.exports = __webpack_require__(18)['default'];


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _handlebarsBase = __webpack_require__(19);
	
	var base = _interopRequireWildcard(_handlebarsBase);
	
	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)
	
	var _handlebarsSafeString = __webpack_require__(33);
	
	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);
	
	var _handlebarsException = __webpack_require__(21);
	
	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);
	
	var _handlebarsUtils = __webpack_require__(20);
	
	var Utils = _interopRequireWildcard(_handlebarsUtils);
	
	var _handlebarsRuntime = __webpack_require__(34);
	
	var runtime = _interopRequireWildcard(_handlebarsRuntime);
	
	var _handlebarsNoConflict = __webpack_require__(35);
	
	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);
	
	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();
	
	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;
	
	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };
	
	  return hb;
	}
	
	var inst = create();
	inst.create = create;
	
	_handlebarsNoConflict2['default'](inst);
	
	inst['default'] = inst;
	
	exports['default'] = inst;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(20);
	
	var _exception = __webpack_require__(21);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _helpers = __webpack_require__(22);
	
	var _decorators = __webpack_require__(30);
	
	var _logger = __webpack_require__(32);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var VERSION = '4.0.5';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 7;
	
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0'
	};
	
	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';
	
	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};
	
	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}
	
	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,
	
	  logger: _logger2['default'],
	  log: _logger2['default'].log,
	
	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },
	
	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },
	
	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  }
	};
	
	var log = _logger2['default'].log;
	
	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};
	
	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;
	
	function escapeChar(chr) {
	  return escape[chr];
	}
	
	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	var toString = Object.prototype.toString;
	
	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function (value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;
	
	/* eslint-enable func-style */
	
	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
	};
	
	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.
	
	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }
	
	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }
	
	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}
	
	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}
	
	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}
	
	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];
	
	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      column = undefined;
	  if (loc) {
	    line = loc.start.line;
	    column = loc.start.column;
	
	    message += ' - ' + line + ':' + column;
	  }
	
	  var tmp = Error.prototype.constructor.call(this, message);
	
	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }
	
	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }
	
	  if (loc) {
	    this.lineNumber = line;
	    this.column = column;
	  }
	}
	
	Exception.prototype = new Error();
	
	exports['default'] = Exception;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _helpersBlockHelperMissing = __webpack_require__(23);
	
	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);
	
	var _helpersEach = __webpack_require__(24);
	
	var _helpersEach2 = _interopRequireDefault(_helpersEach);
	
	var _helpersHelperMissing = __webpack_require__(25);
	
	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);
	
	var _helpersIf = __webpack_require__(26);
	
	var _helpersIf2 = _interopRequireDefault(_helpersIf);
	
	var _helpersLog = __webpack_require__(27);
	
	var _helpersLog2 = _interopRequireDefault(_helpersLog);
	
	var _helpersLookup = __webpack_require__(28);
	
	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);
	
	var _helpersWith = __webpack_require__(29);
	
	var _helpersWith2 = _interopRequireDefault(_helpersWith);
	
	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7eUNBQXVDLGdDQUFnQzs7OzsyQkFDOUMsZ0JBQWdCOzs7O29DQUNQLDBCQUEwQjs7Ozt5QkFDckMsY0FBYzs7OzswQkFDYixlQUFlOzs7OzZCQUNaLGtCQUFrQjs7OzsyQkFDcEIsZ0JBQWdCOzs7O0FBRWxDLFNBQVMsc0JBQXNCLENBQUMsUUFBUSxFQUFFO0FBQy9DLHlDQUEyQixRQUFRLENBQUMsQ0FBQztBQUNyQywyQkFBYSxRQUFRLENBQUMsQ0FBQztBQUN2QixvQ0FBc0IsUUFBUSxDQUFDLENBQUM7QUFDaEMseUJBQVcsUUFBUSxDQUFDLENBQUM7QUFDckIsMEJBQVksUUFBUSxDQUFDLENBQUM7QUFDdEIsNkJBQWUsUUFBUSxDQUFDLENBQUM7QUFDekIsMkJBQWEsUUFBUSxDQUFDLENBQUM7Q0FDeEIiLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCByZWdpc3RlckJsb2NrSGVscGVyTWlzc2luZyBmcm9tICcuL2hlbHBlcnMvYmxvY2staGVscGVyLW1pc3NpbmcnO1xuaW1wb3J0IHJlZ2lzdGVyRWFjaCBmcm9tICcuL2hlbHBlcnMvZWFjaCc7XG5pbXBvcnQgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nIGZyb20gJy4vaGVscGVycy9oZWxwZXItbWlzc2luZyc7XG5pbXBvcnQgcmVnaXN0ZXJJZiBmcm9tICcuL2hlbHBlcnMvaWYnO1xuaW1wb3J0IHJlZ2lzdGVyTG9nIGZyb20gJy4vaGVscGVycy9sb2cnO1xuaW1wb3J0IHJlZ2lzdGVyTG9va3VwIGZyb20gJy4vaGVscGVycy9sb29rdXAnO1xuaW1wb3J0IHJlZ2lzdGVyV2l0aCBmcm9tICcuL2hlbHBlcnMvd2l0aCc7XG5cbmV4cG9ydCBmdW5jdGlvbiByZWdpc3RlckRlZmF1bHRIZWxwZXJzKGluc3RhbmNlKSB7XG4gIHJlZ2lzdGVyQmxvY2tIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJFYWNoKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJJZihpbnN0YW5jZSk7XG4gIHJlZ2lzdGVyTG9nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJMb29rdXAoaW5zdGFuY2UpO1xuICByZWdpc3RlcldpdGgoaW5zdGFuY2UpO1xufVxuIl19


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(20);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;
	
	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }
	
	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }
	
	      return fn(context, options);
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvYmxvY2staGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztxQkFBc0QsVUFBVTs7cUJBRWpELFVBQVMsUUFBUSxFQUFFO0FBQ2hDLFVBQVEsQ0FBQyxjQUFjLENBQUMsb0JBQW9CLEVBQUUsVUFBUyxPQUFPLEVBQUUsT0FBTyxFQUFFO0FBQ3ZFLFFBQUksT0FBTyxHQUFHLE9BQU8sQ0FBQyxPQUFPO1FBQ3pCLEVBQUUsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUVwQixRQUFJLE9BQU8sS0FBSyxJQUFJLEVBQUU7QUFDcEIsYUFBTyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDakIsTUFBTSxJQUFJLE9BQU8sS0FBSyxLQUFLLElBQUksT0FBTyxJQUFJLElBQUksRUFBRTtBQUMvQyxhQUFPLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUN0QixNQUFNLElBQUksZUFBUSxPQUFPLENBQUMsRUFBRTtBQUMzQixVQUFJLE9BQU8sQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFO0FBQ3RCLFlBQUksT0FBTyxDQUFDLEdBQUcsRUFBRTtBQUNmLGlCQUFPLENBQUMsR0FBRyxHQUFHLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQzlCOztBQUVELGVBQU8sUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO09BQ2hELE1BQU07QUFDTCxlQUFPLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztPQUN0QjtLQUNGLE1BQU07QUFDTCxVQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLEdBQUcsRUFBRTtBQUMvQixZQUFJLElBQUksR0FBRyxtQkFBWSxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7QUFDckMsWUFBSSxDQUFDLFdBQVcsR0FBRyx5QkFBa0IsT0FBTyxDQUFDLElBQUksQ0FBQyxXQUFXLEVBQUUsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO0FBQzdFLGVBQU8sR0FBRyxFQUFDLElBQUksRUFBRSxJQUFJLEVBQUMsQ0FBQztPQUN4Qjs7QUFFRCxhQUFPLEVBQUUsQ0FBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUM7S0FDN0I7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJibG9jay1oZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7YXBwZW5kQ29udGV4dFBhdGgsIGNyZWF0ZUZyYW1lLCBpc0FycmF5fSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVySGVscGVyKCdibG9ja0hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbihjb250ZXh0LCBvcHRpb25zKSB7XG4gICAgbGV0IGludmVyc2UgPSBvcHRpb25zLmludmVyc2UsXG4gICAgICAgIGZuID0gb3B0aW9ucy5mbjtcblxuICAgIGlmIChjb250ZXh0ID09PSB0cnVlKSB7XG4gICAgICByZXR1cm4gZm4odGhpcyk7XG4gICAgfSBlbHNlIGlmIChjb250ZXh0ID09PSBmYWxzZSB8fCBjb250ZXh0ID09IG51bGwpIHtcbiAgICAgIHJldHVybiBpbnZlcnNlKHRoaXMpO1xuICAgIH0gZWxzZSBpZiAoaXNBcnJheShjb250ZXh0KSkge1xuICAgICAgaWYgKGNvbnRleHQubGVuZ3RoID4gMCkge1xuICAgICAgICBpZiAob3B0aW9ucy5pZHMpIHtcbiAgICAgICAgICBvcHRpb25zLmlkcyA9IFtvcHRpb25zLm5hbWVdO1xuICAgICAgICB9XG5cbiAgICAgICAgcmV0dXJuIGluc3RhbmNlLmhlbHBlcnMuZWFjaChjb250ZXh0LCBvcHRpb25zKTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHJldHVybiBpbnZlcnNlKHRoaXMpO1xuICAgICAgfVxuICAgIH0gZWxzZSB7XG4gICAgICBpZiAob3B0aW9ucy5kYXRhICYmIG9wdGlvbnMuaWRzKSB7XG4gICAgICAgIGxldCBkYXRhID0gY3JlYXRlRnJhbWUob3B0aW9ucy5kYXRhKTtcbiAgICAgICAgZGF0YS5jb250ZXh0UGF0aCA9IGFwcGVuZENvbnRleHRQYXRoKG9wdGlvbnMuZGF0YS5jb250ZXh0UGF0aCwgb3B0aW9ucy5uYW1lKTtcbiAgICAgICAgb3B0aW9ucyA9IHtkYXRhOiBkYXRhfTtcbiAgICAgIH1cblxuICAgICAgcmV0dXJuIGZuKGNvbnRleHQsIG9wdGlvbnMpO1xuICAgIH1cbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(20);
	
	var _exception = __webpack_require__(21);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }
	
	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;
	
	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }
	
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }
	
	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;
	
	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }
	
	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }
	
	    if (context && typeof context === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else {
	        var priorKey = undefined;
	
	        for (var key in context) {
	          if (context.hasOwnProperty(key)) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          }
	        }
	        if (priorKey !== undefined) {
	          execIteration(priorKey, i - 1, true);
	        }
	      }
	    }
	
	    if (i === 0) {
	      ret = inverse(this);
	    }
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _exception = __webpack_require__(21);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvaGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozt5QkFBc0IsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxlQUFlLEVBQUUsaUNBQWdDO0FBQ3ZFLFFBQUksU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7O0FBRTFCLGFBQU8sU0FBUyxDQUFDO0tBQ2xCLE1BQU07O0FBRUwsWUFBTSwyQkFBYyxtQkFBbUIsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLENBQUM7S0FDdkY7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJoZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFeGNlcHRpb24gZnJvbSAnLi4vZXhjZXB0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbigvKiBbYXJncywgXW9wdGlvbnMgKi8pIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMSkge1xuICAgICAgLy8gQSBtaXNzaW5nIGZpZWxkIGluIGEge3tmb299fSBjb25zdHJ1Y3QuXG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBTb21lb25lIGlzIGFjdHVhbGx5IHRyeWluZyB0byBjYWxsIHNvbWV0aGluZywgYmxvdyB1cC5cbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ01pc3NpbmcgaGVscGVyOiBcIicgKyBhcmd1bWVudHNbYXJndW1lbnRzLmxlbmd0aCAtIDFdLm5hbWUgKyAnXCInKTtcbiAgICB9XG4gIH0pO1xufVxuIl19


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(20);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }
	
	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });
	
	  instance.registerHelper('unless', function (conditional, options) {
	    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }
	
	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;
	
	    instance.log.apply(instance, args);
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUUsa0NBQWlDO0FBQzlELFFBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDO1FBQ2xCLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUM5QyxTQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDN0MsVUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6Qjs7QUFFRCxRQUFJLEtBQUssR0FBRyxDQUFDLENBQUM7QUFDZCxRQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksRUFBRTtBQUM5QixXQUFLLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7S0FDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxFQUFFO0FBQ3JELFdBQUssR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztLQUM1QjtBQUNELFFBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRWhCLFlBQVEsQ0FBQyxHQUFHLE1BQUEsQ0FBWixRQUFRLEVBQVMsSUFBSSxDQUFDLENBQUM7R0FDeEIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvZycsIGZ1bmN0aW9uKC8qIG1lc3NhZ2UsIG9wdGlvbnMgKi8pIHtcbiAgICBsZXQgYXJncyA9IFt1bmRlZmluZWRdLFxuICAgICAgICBvcHRpb25zID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICBmb3IgKGxldCBpID0gMDsgaSA8IGFyZ3VtZW50cy5sZW5ndGggLSAxOyBpKyspIHtcbiAgICAgIGFyZ3MucHVzaChhcmd1bWVudHNbaV0pO1xuICAgIH1cblxuICAgIGxldCBsZXZlbCA9IDE7XG4gICAgaWYgKG9wdGlvbnMuaGFzaC5sZXZlbCAhPSBudWxsKSB7XG4gICAgICBsZXZlbCA9IG9wdGlvbnMuaGFzaC5sZXZlbDtcbiAgICB9IGVsc2UgaWYgKG9wdGlvbnMuZGF0YSAmJiBvcHRpb25zLmRhdGEubGV2ZWwgIT0gbnVsbCkge1xuICAgICAgbGV2ZWwgPSBvcHRpb25zLmRhdGEubGV2ZWw7XG4gICAgfVxuICAgIGFyZ3NbMF0gPSBsZXZlbDtcblxuICAgIGluc3RhbmNlLmxvZyguLi4gYXJncyk7XG4gIH0pO1xufVxuIl19


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field) {
	    return obj && obj[field];
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9va3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsVUFBUyxHQUFHLEVBQUUsS0FBSyxFQUFFO0FBQ3JELFdBQU8sR0FBRyxJQUFJLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQztHQUMxQixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJsb29rdXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbihpbnN0YW5jZSkge1xuICBpbnN0YW5jZS5yZWdpc3RlckhlbHBlcignbG9va3VwJywgZnVuY3Rpb24ob2JqLCBmaWVsZCkge1xuICAgIHJldHVybiBvYmogJiYgb2JqW2ZpZWxkXTtcbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(20);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    var fn = options.fn;
	
	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }
	
	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _decoratorsInline = __webpack_require__(31);
	
	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);
	
	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Z0NBQTJCLHFCQUFxQjs7OztBQUV6QyxTQUFTLHlCQUF5QixDQUFDLFFBQVEsRUFBRTtBQUNsRCxnQ0FBZSxRQUFRLENBQUMsQ0FBQztDQUMxQiIsImZpbGUiOiJkZWNvcmF0b3JzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHJlZ2lzdGVySW5saW5lIGZyb20gJy4vZGVjb3JhdG9ycy9pbmxpbmUnO1xuXG5leHBvcnQgZnVuY3Rpb24gcmVnaXN0ZXJEZWZhdWx0RGVjb3JhdG9ycyhpbnN0YW5jZSkge1xuICByZWdpc3RlcklubGluZShpbnN0YW5jZSk7XG59XG5cbiJdfQ==


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(20);
	
	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function (context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }
	
	    props.partials[options.args[0]] = options.fn;
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMvaW5saW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQXFCLFVBQVU7O3FCQUVoQixVQUFTLFFBQVEsRUFBRTtBQUNoQyxVQUFRLENBQUMsaUJBQWlCLENBQUMsUUFBUSxFQUFFLFVBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsT0FBTyxFQUFFO0FBQzNFLFFBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQztBQUNiLFFBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ25CLFdBQUssQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0FBQ3BCLFNBQUcsR0FBRyxVQUFTLE9BQU8sRUFBRSxPQUFPLEVBQUU7O0FBRS9CLFlBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFDbEMsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsY0FBTyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxRCxZQUFJLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLGlCQUFTLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM5QixlQUFPLEdBQUcsQ0FBQztPQUNaLENBQUM7S0FDSDs7QUFFRCxTQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUU3QyxXQUFPLEdBQUcsQ0FBQztHQUNaLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6ImlubGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7ZXh0ZW5kfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVyRGVjb3JhdG9yKCdpbmxpbmUnLCBmdW5jdGlvbihmbiwgcHJvcHMsIGNvbnRhaW5lciwgb3B0aW9ucykge1xuICAgIGxldCByZXQgPSBmbjtcbiAgICBpZiAoIXByb3BzLnBhcnRpYWxzKSB7XG4gICAgICBwcm9wcy5wYXJ0aWFscyA9IHt9O1xuICAgICAgcmV0ID0gZnVuY3Rpb24oY29udGV4dCwgb3B0aW9ucykge1xuICAgICAgICAvLyBDcmVhdGUgYSBuZXcgcGFydGlhbHMgc3RhY2sgZnJhbWUgcHJpb3IgdG8gZXhlYy5cbiAgICAgICAgbGV0IG9yaWdpbmFsID0gY29udGFpbmVyLnBhcnRpYWxzO1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBleHRlbmQoe30sIG9yaWdpbmFsLCBwcm9wcy5wYXJ0aWFscyk7XG4gICAgICAgIGxldCByZXQgPSBmbihjb250ZXh0LCBvcHRpb25zKTtcbiAgICAgICAgY29udGFpbmVyLnBhcnRpYWxzID0gb3JpZ2luYWw7XG4gICAgICAgIHJldHVybiByZXQ7XG4gICAgICB9O1xuICAgIH1cblxuICAgIHByb3BzLnBhcnRpYWxzW29wdGlvbnMuYXJnc1swXV0gPSBvcHRpb25zLmZuO1xuXG4gICAgcmV0dXJuIHJldDtcbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(20);
	
	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',
	
	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }
	
	    return level;
	  },
	
	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);
	
	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      if (!console[method]) {
	        // eslint-disable-line no-console
	        method = 'log';
	      }
	
	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }
	
	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};
	
	exports['default'] = logger;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	// Build out our basic SafeString type
	'use strict';
	
	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}
	
	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};
	
	exports['default'] = SafeString;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3NhZmUtc3RyaW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFDQSxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUU7QUFDMUIsTUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7Q0FDdEI7O0FBRUQsVUFBVSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEdBQUcsWUFBVztBQUN2RSxTQUFPLEVBQUUsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO0NBQ3pCLENBQUM7O3FCQUVhLFVBQVUiLCJmaWxlIjoic2FmZS1zdHJpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBCdWlsZCBvdXQgb3VyIGJhc2ljIFNhZmVTdHJpbmcgdHlwZVxuZnVuY3Rpb24gU2FmZVN0cmluZyhzdHJpbmcpIHtcbiAgdGhpcy5zdHJpbmcgPSBzdHJpbmc7XG59XG5cblNhZmVTdHJpbmcucHJvdG90eXBlLnRvU3RyaW5nID0gU2FmZVN0cmluZy5wcm90b3R5cGUudG9IVE1MID0gZnVuY3Rpb24oKSB7XG4gIHJldHVybiAnJyArIHRoaXMuc3RyaW5nO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgU2FmZVN0cmluZztcbiJdfQ==


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _utils = __webpack_require__(20);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _exception = __webpack_require__(21);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _base = __webpack_require__(19);
	
	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;
	
	  if (compilerRevision !== currentRevision) {
	    if (compilerRevision < currentRevision) {
	      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	    } else {
	      // Use the embedded version info since the runtime doesn't know about this revision yet
	      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	    }
	  }
	}
	
	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
	  }
	
	  templateSpec.main.decorator = templateSpec.main_d;
	
	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as psuedo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);
	
	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }
	
	    partial = env.VM.resolvePartial.call(this, partial, context, options);
	    var result = env.VM.invokePartial.call(this, partial, context, options);
	
	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, options);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }
	
	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }
	
	  // Just add water
	  var container = {
	    strict: function strict(obj, name) {
	      if (!(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
	      }
	      return obj[name];
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        if (depths[i] && depths[i][name] != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },
	
	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,
	
	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },
	
	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },
	
	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    merge: function merge(param, common) {
	      var obj = param || common;
	
	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }
	
	      return obj;
	    },
	
	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };
	
	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var data = options.data;
	
	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context !== options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }
	
	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }
	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }
	  ret.isTop = true;
	
	  ret._setup = function (options) {
	    if (!options.partial) {
	      container.helpers = container.merge(options.helpers, env.helpers);
	
	      if (templateSpec.usePartial) {
	        container.partials = container.merge(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = container.merge(options.decorators, env.decorators);
	      }
	    } else {
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	    }
	  };
	
	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }
	
	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}
	
	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var currentDepths = depths;
	    if (depths && context !== depths[0]) {
	      currentDepths = [context].concat(depths);
	    }
	
	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }
	
	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);
	
	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}
	
	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}
	
	function invokePartial(partial, context, options) {
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }
	
	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    options.data = _base.createFrame(options.data);
	    partialBlock = options.data['partial-block'] = options.fn;
	
	    if (partialBlock.partials) {
	      options.partials = Utils.extend({}, options.partials, partialBlock.partials);
	    }
	  }
	
	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }
	
	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}
	
	function noop() {
	  return '';
	}
	
	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}
	
	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL25vLWNvbmZsaWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUNlLFVBQVMsVUFBVSxFQUFFOztBQUVsQyxNQUFJLElBQUksR0FBRyxPQUFPLE1BQU0sS0FBSyxXQUFXLEdBQUcsTUFBTSxHQUFHLE1BQU07TUFDdEQsV0FBVyxHQUFHLElBQUksQ0FBQyxVQUFVLENBQUM7O0FBRWxDLFlBQVUsQ0FBQyxVQUFVLEdBQUcsWUFBVztBQUNqQyxRQUFJLElBQUksQ0FBQyxVQUFVLEtBQUssVUFBVSxFQUFFO0FBQ2xDLFVBQUksQ0FBQyxVQUFVLEdBQUcsV0FBVyxDQUFDO0tBQy9CO0FBQ0QsV0FBTyxVQUFVLENBQUM7R0FDbkIsQ0FBQztDQUNIIiwiZmlsZSI6Im5vLWNvbmZsaWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsIHdpbmRvdyAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oSGFuZGxlYmFycykge1xuICAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAqL1xuICBsZXQgcm9vdCA9IHR5cGVvZiBnbG9iYWwgIT09ICd1bmRlZmluZWQnID8gZ2xvYmFsIDogd2luZG93LFxuICAgICAgJEhhbmRsZWJhcnMgPSByb290LkhhbmRsZWJhcnM7XG4gIC8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG4gIEhhbmRsZWJhcnMubm9Db25mbGljdCA9IGZ1bmN0aW9uKCkge1xuICAgIGlmIChyb290LkhhbmRsZWJhcnMgPT09IEhhbmRsZWJhcnMpIHtcbiAgICAgIHJvb3QuSGFuZGxlYmFycyA9ICRIYW5kbGViYXJzO1xuICAgIH1cbiAgICByZXR1cm4gSGFuZGxlYmFycztcbiAgfTtcbn1cbiJdfQ==
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "                <div class=\"swiper-slide filter-slide \">\n                    <div data-selector=\""
	    + container.escapeExpression(container.lambda((depth0 != null ? depth0.id : depth0), depth0))
	    + "\"></div>\n                </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div data-role=\"filter-filter-template\">\n\n    <!-- Slider main container -->\n    <div data-role='filter-rows-swiper' class=\"swiper-container\">\n        <!-- Additional required wrapper -->\n        <div class=\"swiper-wrapper\">\n\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.columns : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n        </div>\n        <!-- If we need pagination -->\n        <div class=\"swiper-pagination\"></div>\n\n        <!-- If we need navigation buttons -->\n        <div class=\"swiper-button-prev\"></div>\n        <div class=\"swiper-button-next\"></div>\n\n    </div>\n\n</div>";
	},"useData":true});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div data-role=\"filter-map-template\"></div>";
	},"useData":true});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div data-role=\"filter-aggregation-template\">\n\n    <div data-selector=\"aggregations\"></div>\n\n</div>";
	},"useData":true});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression;
	
	  return "<li data-role=\"step-filter\" class=\"step-container\" data-tab=\""
	    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"id","hash":{},"data":data}) : helper)))
	    + "\">\n    <span class=\"step-icon fx-background-color-primary-color icojam_filter\"></span>\n    <h6 class=\"truncate step-title\">"
	    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.labels : depth0)) != null ? stack1.title : stack1), depth0))
	    + "</h6>\n</li>";
	},"useData":true});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression;
	
	  return "<li data-role=\"step-map\" class=\"step-container\" data-tab=\""
	    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"id","hash":{},"data":data}) : helper)))
	    + "\">\n    <span class=\"step-icon fx-background-color-primary-color icojam_languages\"></span>\n    <h6 class=\"truncate step-title\">"
	    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.labels : depth0)) != null ? stack1.title : stack1), depth0))
	    + "</h6>\n</li>";
	},"useData":true});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;
	
	  return "<li data-role=\"step-metadata\" class=\"step-container\" data-tab=\""
	    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"id","hash":{},"data":data}) : helper)))
	    + "\"\n    data-resourceRepresentationType=\""
	    + alias1(alias2(((stack1 = ((stack1 = (depth0 != null ? depth0.metadata : depth0)) != null ? stack1.meContent : stack1)) != null ? stack1.resourceRepresentationType : stack1), depth0))
	    + "\">\n    <span class=\"step-icon fx-background-color-primary-color icojam_box\"></span>\n    <h6 class=\"truncate step-title\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.labels : depth0)) != null ? stack1.title : stack1), depth0))
	    + "</h6>\n</li>";
	},"useData":true});

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_42__;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    return [
	        //Download
	        {
	            label: "Download",
	            url: "",
	            parent_id: "root",
	            id: "download",
	            a_attrs: {
	                "data-id": "download",
	                "class": "hidden"
	            }
	        },
	        {
	            label: "Resource",
	            url: "",
	            parent_id: "download",
	            id: "download_data",
	            a_attrs: {
	                "data-action": "download",
	                "data-id": "download",
	                "data-target": "data"
	            }
	        },
	        {
	            label: "Metadata",
	            url: "",
	            parent_id: "download",
	            id: "download_metadata",
	            a_attrs: {
	                "data-action": "download",
	                "data-id": "download",
	                "data-target": "metadata"
	            }
	        },
	        //Visualize as
	        {
	            label: "Visualize as",
	            url: "",
	            parent_id: "root",
	            id: "visualize_as"
	        },
	        //Chart
	        {
	            label: "Chart",
	            url: "",
	            parent_id: "visualize_as",
	            id: "visualize_as_chart",
	            a_attrs: {
	                "data-action": "tab",
	                "data-tab": "chart",
	                "data-id": "chart",
	                "class": "hidden"
	            }
	        },
	        {
	            label: "Line",
	            url: "",
	            parent_id: "visualize_as_chart",
	            id: "chart_line",
	            a_attrs: {
	                "data-action": "tab",
	                "data-tab": "chart",
	                "data-id": "chart",
	                "data-type": "line"
	            }
	        },
	        {
	            label: "Column",
	            url: "",
	            parent_id: "visualize_as_chart",
	            id: "chart_column",
	            a_attrs: {
	                "data-action": "tab",
	                "data-tab": "chart",
	                "data-id": "chart",
	                "data-type": "column"
	            }
	        },
	        {
	            label: "Column stacked",
	            url: "",
	            parent_id: "visualize_as_chart",
	            id: "chart_column_stacked",
	            a_attrs: {
	                "data-action": "tab",
	                "data-tab": "chart",
	                "data-id": "chart",
	                "data-type": "column_stacked"
	            }
	        },
	        {
	            label: "Area",
	            url: "",
	            parent_id: "visualize_as_chart",
	            id: "chart_area",
	            a_attrs: {
	                "data-action": "tab",
	                "data-tab": "chart",
	                "data-id": "chart",
	                "data-type": "area"
	            }
	        },
	/*        {
	            label: "Pie",
	            url: "",
	            parent_id: "visualize_as_chart",
	            id: "chart_pied",
	            a_attrs: {
	                "data-action": "tab",
	                "data-tab": "chart",
	                "data-id": "chart",
	                "data-type": "pie"
	            }
	        },*/
	        //Map
	        {
	            label: "Map",
	            url: "",
	            parent_id: "visualize_as",
	            id: "visualize_as_map",
	            a_attrs: {
	                "data-action": "tab",
	                "data-tab": "map",
	                "data-id": "map",
	                "class": "hidden"
	            }
	        },
	        //Table
	        {
	            label: "Table",
	            url: "",
	            parent_id: "visualize_as",
	            id: "visualize_as_table",
	            a_attrs: {
	                "data-action": "tab",
	                "data-tab": "table",
	                "data-id": "table",
	                "class": "hidden"
	            }
	        },
	        //Layout
	        {
	            label: "Set size",
	            url: "",
	            parent_id: "root",
	            id: "size"
	        },
	        {
	            label: "Full",
	            url: "",
	            parent_id: "size",
	            id: "full",
	            a_attrs: {
	                "data-action": "resize",
	                "data-size": "full"
	            }
	        },
	        {
	            label: "Half",
	            url: "",
	            parent_id: "size",
	            id: "half",
	            a_attrs: {
	                "data-action": "resize",
	                "data-size": "half"
	            }
	        }
	    ];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	  return [
	{
	  "Name": "berrynes_area_3857",
	  "Title": "berrynes_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "berrynes_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=berrynes_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "blueberry_area_3857",
	  "Title": "blueberry_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "blueberry_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=blueberry_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "brazil_area_3857",
	  "Title": "brazil_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "brazil_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=brazil_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "broadbean_area_3857",
	  "Title": "broadbean_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "broadbean_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=broadbean_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "buckwheat_area_3857",
	  "Title": "buckwheat_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "buckwheat_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=buckwheat_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cabbagefor_area_3857",
	  "Title": "cabbagefor_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cabbagefor_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cabbagefor_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "canaryseed_area_3857",
	  "Title": "canaryseed_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "canaryseed_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=canaryseed_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "carob_area_3857",
	  "Title": "carob_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "carob_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=carob_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "carrotarea_3857",
	  "Title": "carrotarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "carrotarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=carrotarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "carrotforarea_3857",
	  "Title": "carrotforarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "carrotforarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=carrotforarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cashewapplearea_3857",
	  "Title": "cashewapplearea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cashewapplearea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cashewapplearea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cashewarea_3857",
	  "Title": "cashewarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cashewarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cashewarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cassavaarea_3857",
	  "Title": "cassavaarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cassavaarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cassavaarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "castorarea_3857",
	  "Title": "castorarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "castorarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=castorarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cauliflowerarea_3857",
	  "Title": "cauliflowerarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cauliflowerarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cauliflowerarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cerealnesarea_3857",
	  "Title": "cerealnesarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cerealnesarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cerealnesarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cherryarea_3857",
	  "Title": "cherryarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cherryarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cherryarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "chestnutarea_3857",
	  "Title": "chestnutarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "chestnutarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=chestnutarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "chickpeaarea_3857",
	  "Title": "chickpeaarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "chickpeaarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=chickpeaarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "chicoryarea_3857",
	  "Title": "chicoryarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "chicoryarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=chicoryarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "chilietcarea_3857",
	  "Title": "chilietcarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "chilietcarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=chilietcarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cinnamonarea_3857",
	  "Title": "cinnamonarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cinnamonarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cinnamonarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "citrusnesarea_3857",
	  "Title": "citrusnesarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "citrusnesarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=citrusnesarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "clovearea_3857",
	  "Title": "clovearea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "clovearea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=clovearea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cloverarea_3857",
	  "Title": "cloverarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cloverarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cloverarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cocoaarea_3857",
	  "Title": "cocoaarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cocoaarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cocoaarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "coconutarea_3857",
	  "Title": "coconutarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "coconutarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=coconutarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "coffeearea_3857",
	  "Title": "coffeearea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "coffeearea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=coffeearea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "coirarea_3857",
	  "Title": "coirarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "coirarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -179.99999237060547,
	    -85.87863889373075,
	    179.98662764288167,
	    85.81776046752934
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037507.49348893,
	        -21205770.720520623,
	        20036019.738804124,
	        21112163.63770032
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=coirarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cottonarea_3857",
	  "Title": "cottonarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cottonarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cottonarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "cowpeaarea_3857",
	  "Title": "cowpeaarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "cowpeaarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cowpeaarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},    
	{
	  "Name": "abacaarea_3857",
	  "Title": "abacaarea_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "abacaarea_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=abacaarea_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "agave_area_3857",
	  "Title": "agave_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "agave_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=agave_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "alfalfa_area_3857",
	  "Title": "alfalfa_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "alfalfa_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=alfalfa_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "almond_area_3857",
	  "Title": "almond_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "almond_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=almond_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "aniseetc_area_3857",
	  "Title": "aniseetc_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "aniseetc_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=aniseetc_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "apple_area_3857",
	  "Title": "apple_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "apple_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=apple_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "apricot_area_3857",
	  "Title": "apricot_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "apricot_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=apricot_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "areca_area_3857",
	  "Title": "areca_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "areca_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=areca_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "artichoke_area_3857",
	  "Title": "artichoke_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "artichoke_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=artichoke_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "asparagus_area_3857",
	  "Title": "asparagus_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "asparagus_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=asparagus_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "avocado_area_3857",
	  "Title": "avocado_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "avocado_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=avocado_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "bambara_area_3857",
	  "Title": "bambara_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "bambara_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=bambara_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	},
	{
	  "Name": "banana_area_3857",
	  "Title": "banana_area_3857",
	  "Abstract": "",
	  "KeywordList": [
	    "WCS",
	    "GeoTIFF",
	    "banana_area_3857"
	  ],
	  "SRS": [
	    "EPSG:3857"
	  ],
	  "LatLonBoundingBox": [
	    -180.00000000000003,
	    -85.81552819353568,
	    179.95503414565607,
	    85.81395348836212
	  ],
	  "BoundingBox": [
	    {
	      "crs": "EPSG:3857",
	      "extent": [
	        -20037508.342789248,
	        -21108757.183934048,
	        20032502.766780593,
	        21106355.272253364
	      ],
	      "res": [
	        null,
	        null
	      ]
	    }
	  ],
	  "Style": [
	    {
	      "Name": "earthstat_crop_area_EN",
	      "Title": "Rain distribution",
	      "Abstract": "",
	      "LegendURL": [
	        {
	          "Format": "image/png",
	          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=banana_area_3857",
	          "size": [
	            20,
	            20
	          ]
	        }
	      ]
	    }
	  ],
	  "queryable": true,
	  "opaque": false,
	  "noSubsets": false
	}
	];
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_45__;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_46__;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_47__;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_48__;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./index.js": 1,
		"./tabs/blank.js": 60,
		"./tabs/chart.js": 64,
		"./tabs/download.js": 69,
		"./tabs/filter.js": 71,
		"./tabs/map.js": 73,
		"./tabs/metadata.js": 79,
		"./tabs/table.js": 81,
		"./utils.js": 9
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 59;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(2),
	    __webpack_require__(4),
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(8),
	    __webpack_require__(14),
	    __webpack_require__(61),
	    __webpack_require__(62),
	    __webpack_require__(63),
	    __webpack_require__(48)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, log, _, C, ERR, EVT, Utils, tabTemplate, Filter, ToolbarModel, amplify) {
	
	    'use strict';
	
	    var s = {
	        TOOLBAR: "[data-role='toolbar']",
	        FILTER_BTN: "[data-role='toolbar'] [data-role='filter-btn']"
	    };
	
	    function BlankTab(obj) {
	
	        $.extend(true, this, {initial: obj, $el: $(obj.el), box: obj.box, model: obj.model, id: obj.id});
	
	        this.channels = {};
	        this.state = {};
	        this.lang = this.initial.lang;
	
	        return this;
	    }
	
	    /* API */
	    /**
	     * Tab initialization method
	     * Optional method
	     */
	    BlankTab.prototype.init = function () {
	        log.info("Tab initialized successfully");
	    };
	
	    /**
	     * Method invoked when the tab is shown in the FENIX visualization box
	     * Mandatory method
	     */
	    BlankTab.prototype.show = function (state) {
	
	        var valid = this._validateInput();
	
	        if (valid === true) {
	
	            this._show(state);
	
	            this.ready = true;
	
	            log.info("Tab shown successfully");
	
	            return this;
	
	        } else {
	
	            log.error("Impossible to create show blank tab");
	            log.error(valid)
	        }
	    };
	
	    /**
	     * Check if the current model is suitable to be displayed within the tab
	     * Mandatory method
	     */
	    BlankTab.prototype.isSuitable = function () {
	
	        var isSuitable = this._isSuitable();
	
	        log.info("Bank tab: is tab suitable? ", isSuitable);
	
	        if (isSuitable === true) {
	            return true;
	        } else {
	            log.error(isSuitable);
	            this._setState("errors", isSuitable);
	            return false;
	        }
	
	    };
	
	    /**
	     * Disposition method
	     * Mandatory method
	     */
	    BlankTab.prototype.dispose = function () {
	
	        this._dispose();
	
	        log.info("Tab disposed successfully");
	
	    };
	
	    /**
	     * pub/sub
	     * @return {Object} component instance
	     */
	    BlankTab.prototype.on = function (channel, fn, context) {
	        var _context = context || this;
	        if (!this.channels[channel]) {
	            this.channels[channel] = [];
	        }
	        this.channels[channel].push({context: _context, callback: fn});
	        return this;
	    };
	
	    /**
	     * Sync tab to passed state
	     * @param {Object} state
	     * @return {Object} filter instance
	     */
	    BlankTab.prototype.sync = function (state) {
	        log.info("Sync tab. State:" + JSON.stringify(state));
	
	        if (state.hasOwnProperty("toolbar") && this.toolbar) {
	            this.toolbar.setValues(state.toolbar, true);
	        } else {
	            log.warn("Abort toolbar sync")
	        }
	    };
	
	    /* END - API */
	
	    BlankTab.prototype._trigger = function (channel) {
	        if (!this.channels[channel]) {
	            return false;
	        }
	
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0, l = this.channels[channel].length; i < l; i++) {
	            var subscription = this.channels[channel][i];
	            subscription.callback.apply(subscription.context, args);
	        }
	        return this;
	    };
	
	    BlankTab.prototype._validateInput = function () {
	
	        var valid = true,
	            errors = [];
	
	        //Check if box has an id
	        /*        if (!this.id) {
	
	         window.fx_vis_box_id >= 0 ? window.fx_vis_box_id++ : window.fx_vis_box_id = 0;
	
	         this.id = window.fx_vis_box_id;
	
	         log.warn("Impossible to find id. Set auto id to: " + this.id);
	         }         */
	
	        //Check if $el exist
	        if (this.$el.length === 0) {
	
	            errors.push({code: ERR.MISSING_CONTAINER});
	
	            log.warn("Impossible to find tab container");
	
	        }
	
	        return errors.length > 0 ? errors : valid;
	
	    };
	
	    BlankTab.prototype._show = function (syncModel) {
	
	        if (this.initialized === true) {
	            log.info("Tab Blank shown again");
	
	        } else {
	
	            log.info("Tab Blank shown for the first time");
	
	            this.syncModel = syncModel;
	
	            this._attach();
	
	            this._initVariables();
	
	            this._renderComponents();
	
	            this._bindEventListeners();
	
	            this.initialized = true;
	
	            this._trigger('initialized');
	        }
	
	    };
	
	    BlankTab.prototype._attach = function () {
	
	        var html = tabTemplate(this);
	
	        this.$el.html(html);
	    };
	
	    BlankTab.prototype._initVariables = function () {
	
	        this.$toolbar = this.$el.find(s.TOOLBAR);
	
	        this.$toolbarBtn = this.$el.find(s.FILTER_BTN);
	
	    };
	
	    BlankTab.prototype._bindEventListeners = function () {
	
	        var self = this;
	
	        amplify.subscribe(this._getEventTopic("toolbar"), this, this._onToolbarEvent);
	
	        this.$el.find("[data-action]").each(function () {
	
	            var $this = $(this),
	                action = $this.data("action"),
	                event = self._getEventTopic(action);
	
	            $this.on("click", {event: event, tab: self}, function (e) {
	                e.preventDefault();
	
	                log.info("Raise event: " + e.data.event);
	
	                amplify.publish(event, {target: this, tab: e.data.tab});
	
	            });
	        });
	
	        this.$toolbarBtn.on("click", _.bind(this._onToolbarBtnClick, this));
	
	        //Toolbar events
	
	        if (C.syncTabsOnToolbarChange === true ) {
	            this.toolbar.on('change', _.bind(this._onToolbarChangeEvent, this));
	        }
	    };
	
	    BlankTab.prototype._onToolbarEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("toolbar"));
	        log.trace(payload);
	
	        var direction = this.toolbarPosition !== "up" ? "up" : "down";
	
	        this._slideToolbar(direction)
	
	    };
	
	    BlankTab.prototype._slideToolbar = function (direction) {
	
	        if (direction !== "up") {
	            this.$toolbar.show();
	            this.toolbarPosition = "down";
	        } else {
	            this.$toolbar.hide();
	            this.toolbarPosition = "up";
	        }
	
	        this._setState("toolbarPosition", this.toolbarPosition);
	
	    };
	
	    BlankTab.prototype._onToolbarBtnClick = function () {
	
	        this._onToolbarEvent();
	
	        this._onConfigurationChange();
	
	    };
	
	    BlankTab.prototype._onToolbarChangeEvent = function () {
	
	        this._onConfigurationChange();
	
	    };
	
	    BlankTab.prototype._onConfigurationChange = function () {
	
	        this._trigger("filter", this.toolbar.getValues());
	
	    };
	
	    BlankTab.prototype._renderComponents = function () {
	
	        this._renderToolbar();
	
	        //init toolbar position
	        this._slideToolbar(this.initial.toolbarPosition || C.toolbarPosition );
	
	        //render creator
	    };
	
	    BlankTab.prototype._renderToolbar = function () {
	        log.info("Blank tab render toolbar");
	
	        this.toolbar = new Filter({
	            selectors: this._createFilterConfiguration(ToolbarModel),
	            el: this.$el.find(s.TOOLBAR)
	        });
	
	    };
	
	    BlankTab.prototype._createFilterConfiguration = function () {
	
	        var configuration = $.extend(true, {}, Utils.mergeConfigurations(ToolbarModel, this.syncModel || {}));
	
	        return configuration;
	
	    };
	
	    BlankTab.prototype._unbindEventListeners = function () {
	
	        this.$toolbarBtn.off();
	
	        this.$el.find("[data-action]").off();
	
	        amplify.unsubscribe(this._getEventTopic("toolbar"), this._onToolbarEvent);
	
	    };
	
	    BlankTab.prototype._isSuitable = function () {
	
	        var valid = true,
	            errors = [];
	
	        //errors.push({code: ERR.MISSING_CONTAINER});
	
	        return errors.length > 0 ? errors : valid;
	
	    };
	
	    BlankTab.prototype._dispose = function () {
	
	        if (this.ready === true) {
	            this._unbindEventListeners();
	        }
	    };
	
	    BlankTab.prototype._getEventTopic = function (evt) {
	
	        return EVT[evt] ? EVT[evt] + this.id : evt + this.id;
	    };
	
	    BlankTab.prototype._setState = function (key, val) {
	
	        this._assign(this.state, key, val);
	
	        this._trigger("state", $.extend(true, {}, this.state));
	    };
	
	    return BlankTab;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<div data-role=\"toolbar\" class=\"col-xs-12 col-sm-6 col-md-6\">\n    <button data-action=\"toolbar\" class=\"btn btn-default\" type=\"button\">toolbar</button>\n\n    <button data-role=\"filter-btn\" class=\"btn btn-default\" type=\"button\">\n        <span class=\"glyphicon glyphicon-filter\" aria-hidden=\"true\"></span>\n    </button>\n</div>\n\n<div>\n    <button data-action=\"toolbar\" class=\"btn btn-default\" type=\"button\">toolbar</button>\n\n    <div class=\"alert alert-warning\" role=\"alert\"><h1>Hi i'm the blank tab: "
	    + container.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"id","hash":{},"data":data}) : helper)))
	    + "</h1></div>\n</div>";
	},"useData":true});

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_62__;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    return {
	
	        "sort": {
	
	            "selector": {
	                "id": "sortable",
	                "source": [
	                    {"value": "sort_1", "label": "Sort 1", parent: 'group_1'},
	                    {"value": "sort_2", "label": "Sort 2", parent: 'group_1'},
	                    {"value": "sort_3", "label": "Sort 3", parent: 'group_2'},
	                    {"value": "sort_4", "label": "Sort 4", parent: 'group_3'}
	                ], // Static data
	                "config": { //SortableJS configuration
	                    //disabled: true
	                }
	            },
	
	            "template": {
	                //"hideHeader": true,
	                "hideSwitch": true,
	                "hideRemoveButton": true,
	                "title": "Sort dimension"
	            }
	
	        },
	
	        "aggregation": {
	
	            "selector": {
	                "id": "dropdown",
	                "source": [
	                    {"value": "aggregation_1", "label": "Aggregation 1"},
	                    {"value": "aggregation_2", "label": "Aggregation 2"},
	                    {"value": "aggregation_3", "label": "Aggregation 3"},
	                    {"value": "aggregation_4", "label": "Aggregation 4"}
	                ], // Static data
	                "config": { //Selectize configuration
	                    "maxItems": 1
	                }
	            },
	
	            "template": {
	                //"hideHeader": true,
	                "hideSwitch": true,
	                "hideRemoveButton": true,
	                "title": "Aggregation function"
	            }
	
	        },
	
	        "renderer": {
	
	            "selector": {
	                "id": "dropdown",
	                "source": [
	
	                    {"value": "table", "label": "Grid"},
	                    {"value": "chart", "label": "Chart"},
	
	
	                ], // Static data
	                "config": { //Selectize configuration
	                    "maxItems": 1
	                }
	            },
	
	            "template": {
	                //"hideHeader": true,
	                "hideSwitch": true,
	                "hideRemoveButton": true,
	                "title": "Renderer function"
	            }
	
	        },
	
	        "decimal_separator": {
	
	            "selector": {
	                "id": "input",
	                "type": "radio",
	                "default": ["dot"],
	                "source": [
	                    {"value": "dot", "label": "Dot"},
	                    {"value": "comma", "label": "Comma"}
	
	                ]
	            },
	
	            "template": {
	                //"hideHeader": true,
	                "hideSwitch": true,
	                "hideRemoveButton": true,
	                "title": "Decimal separator"
	            }
	
	        },
	
	        "thousand": {
	
	            "selector": {
	                "id": "input",
	                "type": "radio",
	                "default": ["enable"],
	                "source": [
	                    {"value": "enable", "label": "Enable"},
	                    {"value": "disable", "label": "Disable"}
	                ]
	            },
	
	            "template": {
	                //"hideHeader": true,
	                "hideSwitch": true,
	                "hideRemoveButton": true,
	                "title": "Thousand"
	            }
	
	        },
	
	        "decimals": {
	
	            "selector": {
	                "id": "input",
	                "type": "number",
	                "source": [
	                    {"value": "2"}
	                ]
	            },
	
	            "template": {
	                //"hideHeader": true,
	                "hideSwitch": true,
	                "hideRemoveButton": true,
	                "title": "Decimal digit"
	            }
	
	        }
	
	    }
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(2),
	    __webpack_require__(4),
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(8),
	    __webpack_require__(9),
	    __webpack_require__(14),
	    __webpack_require__(65),
	    __webpack_require__(62),
	    __webpack_require__(66),
	    __webpack_require__(11),
	    __webpack_require__(68),
	    __webpack_require__(48)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, log, _, C, ERR, EVT, BoxUtils, Utils, tabTemplate, Filter, ToolbarModel, i18nLabels, ChartCreator, amplify) {
	
	    'use strict';
	
	    var s = {
	        TOOLBAR: "[data-role='toolbar']",
	        FILTER_BTN: "[data-role='filter-btn']"
	    };
	
	    function ChartTab(obj) {
	
	        $.extend(true, this, {initial: obj, $el: $(obj.el), box: obj.box, model: obj.model, id: obj.id});
	
	        this.channels = {};
	        this.state = {};
	
	        this.nls = $.extend(true, {}, i18nLabels, this.initial.nls);
	
	        this.cache = this.initial.cache;
	        this.lang = this.initial.lang;
	        this.environment = this.initial.environment;
	
	        return this;
	    }
	
	    /* API */
	    /**
	     * Tab initialization method
	     * Optional method
	     */
	    ChartTab.prototype.init = function () {
	        log.info("Tab initialized successfully");
	    };
	
	    /**
	     * Method invoked when the tab is shown in the FENIX visualization box
	     * Mandatory method
	     */
	    ChartTab.prototype.show = function (opts) {
	
	        var valid = this._validateInput();
	
	        if (valid === true) {
	
	            this._show(opts);
	
	            log.info("Chart tab shown successfully");
	
	            return this;
	
	        } else {
	
	            log.error("Impossible to create show table tab");
	            log.error(valid)
	        }
	    };
	
	    /**
	     * Check if the current model is suitable to be displayed within the tab
	     * Mandatory method
	     */
	    ChartTab.prototype.isSuitable = function () {
	
	        var isSuitable = this._isSuitable();
	
	        log.info("Chart tab: is tab suitable? ", isSuitable);
	
	        if (isSuitable === true) {
	            return true;
	        } else {
	            log.error(isSuitable);
	            this._setState("errors", isSuitable);
	            return false;
	        }
	
	    };
	
	    /**
	     * Disposition method
	     * Mandatory method
	     */
	    ChartTab.prototype.dispose = function () {
	
	        this._dispose();
	
	        log.info("Tab disposed successfully");
	
	    };
	
	    /**
	     * pub/sub
	     * @return {Object} component instance
	     */
	    ChartTab.prototype.on = function (channel, fn, context) {
	        var _context = context || this;
	        if (!this.channels[channel]) {
	            this.channels[channel] = [];
	        }
	        this.channels[channel].push({context: _context, callback: fn});
	        return this;
	    };
	
	    /**
	     * Sync tab to passed state
	     * @param {Object} state
	     * @return {Object} chart tab instance
	     */
	    ChartTab.prototype.sync = function (state) {
	        log.info("Sync tab. State:" + JSON.stringify(state));
	
	        this.syncState = state;
	
	        this.toSync = true;
	
	        return this;
	    };
	
	    /**
	     * Force redrawing
	     * @return {Object} chart tab instance
	     */
	    ChartTab.prototype.redraw = function () {
	
	        if (this.chart && $.isFunction(this.chart.redraw)){
	            this.chart.redraw();
	        } else {
	            log.warn("Abort redraw");
	        }
	
	    };
	
	    /* END - API */
	
	    ChartTab.prototype._trigger = function (channel) {
	        if (!this.channels[channel]) {
	            return false;
	        }
	
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0, l = this.channels[channel].length; i < l; i++) {
	            var subscription = this.channels[channel][i];
	            subscription.callback.apply(subscription.context, args);
	        }
	        return this;
	    };
	
	    ChartTab.prototype._validateInput = function () {
	
	        var valid = true,
	            errors = [];
	
	        //Check if box has an id
	        /*        if (!this.id) {
	
	         window.fx_vis_box_id >= 0 ? window.fx_vis_box_id++ : window.fx_vis_box_id = 0;
	
	         this.id = window.fx_vis_box_id;
	
	         log.warn("Impossible to find id. Set auto id to: " + this.id);
	         }         */
	
	        //Check if $el exist
	        if (this.$el.length === 0) {
	
	            errors.push({code: ERR.MISSING_CONTAINER});
	
	            log.warn("Impossible to find tab container");
	
	        }
	
	        return errors.length > 0 ? errors : valid;
	
	    };
	
	    ChartTab.prototype._show = function (opts) {
	
	        this.type = opts.type;
	
	        if (this.initialized !== true) {
	
	            log.info("Tab chart shown for the first time");
	
	            this._attach();
	
	            this._initVariables();
	
	            this._renderComponents();
	
	            this._bindEventListeners();
	
	            this.initialized = true;
	
	            this._trigger('initialized');
	
	        } else {
	            log.info("Tab chart shown again");
	
	            if (this.toSync === true) {
	                log.info("Sync tab. State:" + JSON.stringify(this.syncState));
	
	                if (this.syncState.hasOwnProperty("toolbar") && this.toolbar) {
	                    this.toolbar.setValues(this.syncState.toolbar, true);
	                    this.type = opts.type;
	                    this._renderChart();
	
	                } else {
	                    this._updateChart()
	                }
	            }
	        }
	
	        return this;
	
	    };
	
	    ChartTab.prototype._attach = function () {
	
	        var html = tabTemplate($.extend(true, {}, this, this.nls));
	
	        this.$el.html(html);
	
	        var initialConfig = this.initial.config || {};
	
	        if (initialConfig.toolbar && initialConfig.toolbar.template) {
	            this.$el.find(s.TOOLBAR).html(initialConfig.toolbar.template);
	        }
	
	    };
	
	    ChartTab.prototype._initVariables = function () {
	
	        this.$toolbar = this.$el.find(s.TOOLBAR);
	
	        this.$toolbarBtn = this.$el.find(s.FILTER_BTN);
	
	    };
	
	    ChartTab.prototype._bindEventListeners = function () {
	
	        var self = this;
	
	        amplify.subscribe(this._getEventTopic("toolbar"), this, this._onToolbarEvent);
	
	        this.$el.find("[data-action]").each(function () {
	
	            var $this = $(this),
	                action = $this.data("action"),
	                event = self._getEventTopic(action);
	
	            $this.on("click", {event: event, tab: self}, function (e) {
	                e.preventDefault();
	
	                log.info("Raise event: " + e.data.event);
	
	                amplify.publish(event, {target: this, tab: e.data.tab});
	
	            });
	        });
	
	        this.$toolbarBtn.on("click", _.bind(this._onToolbarBtnClick, this));
	
	        //Toolbar events
	        if (C.syncTabsOnToolbarChange === true) {
	            this.toolbar.on('change', _.bind(this._onToolbarChangeEvent, this));
	        } else {
	            log.warn("Tab sync is disabled by configuration")
	        }
	
	    };
	
	    ChartTab.prototype._onToolbarEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("toolbar"));
	        log.trace(payload);
	
	        var direction = this.toolbarPosition !== "up" ? "up" : "down";
	
	        this._slideToolbar(direction)
	
	    };
	
	    ChartTab.prototype._slideToolbar = function (direction) {
	
	        if (direction !== "up") {
	            this.$toolbar.addClass('in');
	            this.$toolbarBtn.addClass('in');
	            this.toolbarPosition = "down";
	        } else {
	            this.$toolbar.removeClass('in');
	            this.$toolbarBtn.removeClass('in');
	            this.toolbarPosition = "up";
	        }
	
	        this._setState("toolbarPosition", this.toolbarPosition);
	
	    };
	
	    ChartTab.prototype._onToolbarBtnClick = function () {
	
	        this._onToolbarEvent();
	
	        this._onConfigurationChange();
	
	    };
	
	    ChartTab.prototype._renderChart = function () {
	
	        var toolbarValues = this.toolbar.getValues(),
	            initialConfig = this.initial.config || {},
	            configuration;
	
	        console.log('Tabchart _renderChart', toolbarValues);
	
	        if (typeof initialConfig.config === "function") {
	            configuration = initialConfig.config.call(this, this.model, toolbarValues)
	        } else {
	            configuration = BoxUtils.getChartCreatorConfiguration(toolbarValues)
	        }
	
	        if (C.renderVisualizationComponents === false ) {
	            log.warn("Render Visualization component blocked by configuration");
	            return;
	        }
	
	        var boxTitle = this.box.$boxTitle.html();
	
	        var model = $.extend(true, {}, configuration, {
	            model: this.model,
	            el: "#chart_" + this.id,
	            type: this.type,
	            config: {
	                exporting: {
	                    enabled: true,
	                    chartOptions: {
	                        title: {
	                            text: boxTitle
	                        }
	                    }
	                }
	            }
	        });
	
	        if(this.chart)
	            this.chart.dispose();
	        this.chart = new ChartCreator(model);
	    };
	
	    ChartTab.prototype._updateChart = function () {
	
	        var toolbarValues = this.toolbar.getValues(),
	            configuration = BoxUtils.getChartCreatorConfiguration(toolbarValues);
	
	        if (C.renderVisualizationComponents === false) {
	            log.warn("Render Visualization component blocked by configuration");
	            return;
	        }
	
	        this.chart.update($.extend(true, {}, configuration, {
	            model: this.model,
	            el: "#chart_" + this.id,
	            type: this.type
	        }));
	
	    };
	
	    ChartTab.prototype._renderToolbar = function () {
	        log.info("Chart tab render toolbar");
	
	        var self = this,
	            model = {
	                selectors: this._createFilterConfiguration(),
	                cache: this.cache,
	                el: this.$el.find(s.TOOLBAR),
	                environment: this.initial.environment,
	                lang : this.lang
	            };
	
	        //force labels
	
	        var labeled = {};
	        if (model.selectors.hasOwnProperty("dimensionsSort")) {
	            _.each(model.selectors.dimensionsSort.selector.config.groups,function(value, key) {
	                labeled[key] = i18nLabels[self.lang.toLowerCase()]["tab_table_toolbar_" + key];
	            });
	            model.selectors.dimensionsSort.selector.config.groups =labeled;
	        }
	
	        //i18n
	        if (BoxUtils.getNestedProperty("selectors.show")){
	            var source = BoxUtils.getNestedProperty("selectors.show.selector.source", model);
	            _.map(source, function(i) {
	                i.label =  i18nLabels[self.lang.toLowerCase()]["tab_table_toolbar_" + i.value] || i.label;
	                return i;
	            });
	
	            BoxUtils.assign(model, "selectors.show.selector.source", source);
	        }
	
	        this.toolbar = new Filter(model);
	        console.log(model)
	        console.log(this.toolbar)
	
	        if((model!=null)&&(typeof model!='undefined')&&(model.selectors!=null)&&(typeof model.selectors!='undefined')&&(model.selectors.compare!=null)&&(typeof model.selectors.compare!='undefined')&&(model.selectors.compare.selector!=null)&&(typeof model.selectors.compare.selector!='undefined')&&(model.selectors.compare.selector.source!=null)&&(typeof model.selectors.compare.selector.source!='undefined')){
	            if(model.selectors.compare.selector.source.length<=0)
	            {
	                amplify.publish(this._getEventTopicNoElem("noelem"), this);
	            }
	        }
	
	        this.toolbar.on("ready", _.bind(this._renderChart, this))
	
	    };
	
	    ChartTab.prototype._createFilterConfiguration = function () {
	
	        var initialConfig = this.initial.config || {},
	            toolbarConfig = initialConfig.toolbar || {},
	            result;
	
	        switch(typeof toolbarConfig.config) {
	            case "function" :
	                result = toolbarConfig.config(this.model);
	                break;
	            case "object" :
	                result = toolbarConfig.config;
	                break;
	            default :
	                var configurationFromFenixTool = BoxUtils.getChartToolbarConfig(this.model),
	                    configuration = $.extend(true, {}, ToolbarModel, configurationFromFenixTool);
	
	                result = $.extend(true, {}, Utils.mergeConfigurations(configuration, this.syncState.toolbar || {}));
	        }
	
	        _.each(result, _.bind(function (value, key) {
	            value.template.title = this.nls["tab_table_toolbar_" + key];
	        }, this));
	
	        return result;
	
	    };
	
	    ChartTab.prototype._onToolbarChangeEvent = function () {
	
	        this._onConfigurationChange();
	
	    };
	
	    ChartTab.prototype._onConfigurationChange = function () {
	
	        this._trigger("filter", this.toolbar.getValues());
	
	        this._renderChart();
	
	    };
	
	    ChartTab.prototype._renderComponents = function () {
	
	        this._renderToolbar();
	
	        //Chart will be create when filter is 'ready'
	
	        //init toolbar position
	        var position = this.initial.toolbarPosition || C.toolbarPosition ;
	        if (position === 'up') {
	            this.toolbarPosition = 'up';
	            //this.$toolbar.hide();
	        } else {
	            this.toolbarPosition = 'down';
	        }
	    };
	
	    ChartTab.prototype._unbindEventListeners = function () {
	
	        this.$toolbarBtn.off();
	        this.$el.find("[data-action]").off();
	
	        amplify.unsubscribe(this._getEventTopic("toolbar"), this._onToolbarEvent);
	
	    };
	
	    ChartTab.prototype._isSuitable = function () {
	
	        var valid = true,
	            errors = [];
	
	        var resourceType = BoxUtils.getNestedProperty("metadata.meContent.resourceRepresentationType", this.model);
	
	        if (resourceType !== "dataset") {
	            errors.push({code: ERR.INCOMPATIBLE_RESOURCE_TYPE});
	        }
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    ChartTab.prototype._dispose = function () {
	
	        if (this.ready === true) {
	            this._unbindEventListeners();
	        }
	    };
	
	    ChartTab.prototype._getEventTopic = function (evt) {
	
	        return EVT[evt] ? EVT[evt] + this.id : evt + this.id;
	    };
	
	    ChartTab.prototype._getEventTopicNoElem = function (evt) {
	
	        //Removing the reference to the object type(chart)
	        return EVT[evt] ? EVT[evt] +"."+ this.id.substring(this.id.indexOf("_")+1) : evt +"."+ this.id.substring(this.id.indexOf("_")+1);
	    };
	
	    ChartTab.prototype._setState = function (key, val) {
	
	        Utils.assign(this.state, key, val);
	
	        this._trigger("state", $.extend(true, {}, this.state));
	
	    };
	
	
	    ChartTab.prototype._getNestedProperty = function (path, obj) {
	
	        var obj = $.extend(true, {}, obj),
	            arr = path.split(".");
	
	        while (arr.length && (obj = obj[arr.shift()]));
	
	        return obj;
	
	    };
	
	
	    ChartTab.prototype._trigger = function (channel) {
	        if (!this.channels[channel]) {
	            return false;
	        }
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0, l = this.channels[channel].length; i < l; i++) {
	            var subscription = this.channels[channel][i];
	            subscription.callback.apply(subscription.context, args);
	        }
	        return this;
	    };
	
	    /**
	     * pub/sub
	     * @return {Object} component instance
	     */
	    ChartTab.prototype.on = function (channel, fn, context) {
	        var _context = context || this;
	        if (!this.channels[channel]) {
	            this.channels[channel] = [];
	        }
	        this.channels[channel].push({context: _context, callback: fn});
	        return this;
	    };
	
	    return ChartTab;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<button data-action=\"toolbar\" class=\"btn btn-floating fx-background-color-primary-color btn-fx-toolbar\" type=\"button\" title=\""
	    + alias4(((helper = (helper = helpers.tooltip_toolbar_button || (depth0 != null ? depth0.tooltip_toolbar_button : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"tooltip_toolbar_button","hash":{},"data":data}) : helper)))
	    + "\"><span class=\"icojam_options2\"></span></button>\n<button data-role=\"filter-btn\" class=\"btn btn-floating btn-fx-toolbar-confirm\" type=\"button\"><span class=\"icojam_check\"></span></button>\n\n<div data-role=\"toolbar\" class=\"col-xs-12 col-sm-6 col-md-6\">\n    <div data-selector=\"dimensionsSort\"></div>\n</div>\n\n<div class=\"tab-item-content-wrapper\">\n	<div id=\"chart_"
	    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
	    + "\" class=\"tab-item-content\"></div>\n</div>";
	},"useData":true});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(3),
	        __webpack_require__(67)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Shared) {
	
	        'use strict';
	
	        return $.extend(true, {}, Shared,{show : {
	
	            selector : {
	                id : "input",
	                type : "checkbox",
	                source : [
	                    { value : "code", label : "Code"}
	                ]
	            },
	
	            template : {
	                title : "Show"
	            }
	        }})
	
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    return {
	
	        format: {
	
	            selector: {
	                id: 'dropdown',
	                source: [
	                    {value: "localstring", label: "Local String"},
	                    {value: "value", label: "Raw Value"}
	                ],
	                config: {
	                    maxItems: 1
	                },
	                default: ['localstring']
	            },
	
	            template: {
	                title: "Format"
	            }
	        },
	
	        "decimals": {
	
	            "selector": {
	                "id": "dropdown",
	
	                "source": [
	
	                    {"value": "0", "label": 0},
	                    {"value": "1", "label": 1},
	                    {"value": "2", "label": 2},
	                    {"value": "3", "label": 3},
	                    {"value": "4", "label": 4},
	                    {"value": "5", "label": 5}
	                ],
	                "config": {
	                    maxItems: 1
	                },
	                default: [2]
	            },
	
	            "template": {
	                "title": "Decimals"
	            },
	
	
	            "className": "testDec"
	
	        }
	
	    }
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_68__;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(2),
	    __webpack_require__(4),
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(8),
	    __webpack_require__(9),
	    __webpack_require__(70),
	    __webpack_require__(46)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, log, _, C, ERR, EVT, BoxUtils, tabTemplate, Report) {
	
	    'use strict';
	
	    var s = {
	        CONTAINER: '[data-role="download"]',
	        DOWNLOAD_BTN: '[data-action="download"]'
	    };
	
	    function DownloadTab(obj) {
	
	        $.extend(true, this, {initial: obj, $el: $(obj.el), box: obj.box, model: obj.model, id: obj.id});
	
	        this.channels = {};
	        this.state = {};
	
	        this.report = new Report({
	            cache : this.initial.cache
	        });
	        this.lang = this.initial.lang;
	
	        return this;
	    }
	
	    /* API */
	    /**
	     * Tab initialization method
	     * Optional method
	     */
	    DownloadTab.prototype.init = function () {
	        log.info("Tab initialized successfully");
	    };
	
	    /**
	     * Method invoked when the tab is shown in the FENIX visualization box
	     * Mandatory method
	     */
	    DownloadTab.prototype.show = function (state) {
	
	        var valid = this._validateInput();
	
	        if (valid === true) {
	
	            this._show(state);
	
	            this.ready = true;
	
	            log.info("trigger 'ready' event");
	
	            this._trigger('ready');
	
	            log.info("Tab shown successfully");
	
	            return this;
	
	        } else {
	
	            log.error("Impossible to create show download tab");
	            log.error(valid)
	        }
	    };
	
	    /**
	     * Check if the current model is suitable to be displayed within the tab
	     * Mandatory method
	     */
	    DownloadTab.prototype.isSuitable = function () {
	
	        var isSuitable = this._isSuitable();
	
	        log.info("Download tab: is tab suitable? ", isSuitable);
	
	        if (isSuitable === true) {
	            return true;
	        } else {
	            log.error(isSuitable);
	            this._setState("errors", isSuitable);
	            return false;
	        }
	
	    };
	
	    /**
	     * Disposition method
	     * Mandatory method
	     */
	    DownloadTab.prototype.dispose = function () {
	
	        this._dispose();
	
	        log.info("Tab disposed successfully");
	
	    };
	
	    /**
	     * pub/sub
	     * @return {Object} component instance
	     */
	    DownloadTab.prototype.on = function (channel, fn, context) {
	        var _context = context || this;
	        if (!this.channels[channel]) {
	            this.channels[channel] = [];
	        }
	        this.channels[channel].push({context: _context, callback: fn});
	        return this;
	    };
	    /**
	     * Sync tab to passed state
	     * @param {Object} state
	     * @return {Object} filter instance
	     */
	    DownloadTab.prototype.sync = function (state) {
	        log.info("Sync tab. State:" + JSON.stringify(state));
	
	        if (state.hasOwnProperty("toolbar") && this.toolbar) {
	            this.toolbar.setValues(state.toolbar, true);
	        } else {
	            log.warn("Abort toolbar sync")
	        }
	    };
	
	    /* END - API */
	
	    DownloadTab.prototype._trigger = function (channel) {
	        if (!this.channels[channel]) {
	            return false;
	        }
	
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0, l = this.channels[channel].length; i < l; i++) {
	            var subscription = this.channels[channel][i];
	            subscription.callback.apply(subscription.context, args);
	        }
	        return this;
	    };
	
	    DownloadTab.prototype._validateInput = function () {
	
	        var valid = true,
	            errors = [];
	
	        //Check if box has an id
	        /*        if (!this.id) {
	
	         window.fx_vis_box_id >= 0 ? window.fx_vis_box_id++ : window.fx_vis_box_id = 0;
	
	         this.id = window.fx_vis_box_id;
	
	         log.warn("Impossible to find id. Set auto id to: " + this.id);
	         }         */
	
	        //Check if $el exist
	        if (this.$el.length === 0) {
	
	            errors.push({code: ERR.MISSING_CONTAINER});
	
	            log.warn("Impossible to find tab container");
	
	        }
	
	        return errors.length > 0 ? errors : valid;
	
	    };
	
	    DownloadTab.prototype._show = function (syncModel) {
	
	        if (this.initialized === true) {
	            log.info("Tab Download shown again");
	
	        } else {
	
	            log.info("Tab Download shown for the first time");
	
	            this.syncModel = syncModel;
	
	            this._attach();
	
	            this._initVariables();
	
	            this._renderComponents();
	
	            this._bindEventListeners();
	
	            this.initialized = true;
	        }
	
	    };
	
	    DownloadTab.prototype._attach = function () {
	
	        var html = tabTemplate(this);
	
	        this.$el.html(html);
	    };
	
	    DownloadTab.prototype._initVariables = function () {
	
	    };
	
	    DownloadTab.prototype._bindEventListeners = function () {
	
	        this.$el.find(s.DOWNLOAD_BTN).on("click", _.bind(function (e) {
	
	            var $this = $(e.target);
	
	            var format = $this.data('format');
	            (format== 'pdf')? this._downloadMetadata(format): this._downloadData(format);
	
	        }, this));
	
	    };
	
	    DownloadTab.prototype._downloadData = function (format) {
	
	        //check if uid exist
	        var resource = (this.model.data) ? this.model :
	        {
	            "metadata": {
	                "uid": this.model.metadata.uid
	            },
	            "data": []
	        };
	
	        var payload = {
	            resource: resource,
	            input: {
	                config: {}
	            },
	            output: {
	                config: {
	                    lang: this.box.lang.toUpperCase()
	                }
	            }
	        };
	
	        this.report.export({
	            format : "table",
	            config: payload
	        });
	
	    };
	
	    DownloadTab.prototype._downloadMetadata = function (format) {
	        
	        //check if uid exist
	        var fileName = this.model.metadata.title['EN'].replace(/[^a-z0-9]/gi, '_').toLowerCase();
	
	        var template = this.model.metadata.dsd && this.model.metadata.dsd.contextSystem && this.model.metadata.dsd.contextSystem  === 'uneca'?
	            'uneca' : 'fao';
	
	        var payload = {
	            resource: {
	                metadata: {
	                    uid: this.model.metadata.uid
	                },
	                data: []
	            },
	            input: {
	                config: {}
	            },
	            output: {
	                config: {
	                    template : template,
	                    lang: this.box.lang.toUpperCase(),
	                    fileName: fileName+'.pdf'
	                }
	            }
	        };
	
	        this.report.export({
	            format : "metadata",
	            config: payload
	        });
	
	    };
	
	    DownloadTab.prototype._renderComponents = function () {
	
	    };
	
	    DownloadTab.prototype._unbindEventListeners = function () {
	
	        this.$el.find(s.DOWNLOAD_BTN).off();
	
	    };
	
	    DownloadTab.prototype._isSuitable = function () {
	
	
	        var valid = true,
	            errors = [];
	
	        var resourceType = BoxUtils.getNestedProperty("metadata.meContent.resourceRepresentationType", this.model);
	
	        if (resourceType !== "dataset") {
	            errors.push({code: ERR.INCOMPATIBLE_RESOURCE_TYPE});
	        }
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    DownloadTab.prototype._dispose = function () {
	
	        if (this.ready === true) {
	            this._unbindEventListeners();
	        }
	
	    };
	
	    DownloadTab.prototype._getEventTopic = function (evt) {
	
	        return EVT[evt] ? EVT[evt] + this.id : evt + this.id;
	    };
	
	    DownloadTab.prototype._setState = function (key, val) {
	
	        Utils.assign(this.state, key, val);
	
	        this._trigger("state", $.extend(true, {}, this.state));
	    };
	
	    return DownloadTab;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div data-role=\"download\">\n\n    <div class=\"row\">\n        <div class=\"col-xs-6\">\n            <div class=\"jumbotron text-center\">\n\n                <h1>\n                    <span class=\"glyphicon glyphicon-cloud-download\" aria-hidden=\"true\"></span>\n                </h1>\n                <p>Data:</p>\n                <p>\n                <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n                    <button data-action=\"download\" data-format=\"xls\" type=\"button\" class=\"btn btn-default\">Excel\n                    </button>\n                </div>\n                </p>\n            </div>\n        </div>\n        <div class=\"col-xs-6\">\n            <div class=\"jumbotron text-center\">\n\n                <h1>\n                    <span class=\"glyphicon glyphicon-cloud-download\" aria-hidden=\"true\"></span>\n                </h1>\n                <p>Metadata:</p>\n                <p>\n                <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n                    <button data-action=\"download\" data-format=\"pdf\" type=\"button\" class=\"btn btn-default\">PDF</button>\n                </div>\n\n                </p>\n            </div>\n        </div>\n\n    </div>\n\n</div>";
	},"useData":true});

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(2),
	    __webpack_require__(4),
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(8),
	    __webpack_require__(9),
	    __webpack_require__(14),
	    __webpack_require__(72),
	    __webpack_require__(62),
	    __webpack_require__(11)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, log, _, C, ERR, EVT, BoxUtils, Utils, tabTemplate, Filter, i18nLabels) {
	
	    'use strict';
	
	    var defaultOptions = {
	        template: {
	            hideFooterButtons: true
	        }
	    }, s = {
	        CONTAINER: "[data-role='filter']",
	        SUBMIT_BTN: "[data-role='submit']",
	        RESET_BTN: "[data-role='reset']"
	    };
	
	    function FilterTab(obj) {
	
	        $.extend(true, this, defaultOptions, {
	            initial: obj,
	            $el: $(obj.el),
	            box: obj.box,
	            model: obj.model,
	            id: obj.id,
	            onReady : obj.onReady,
	            values: obj.values
	        });
	
	        this.channels = {};
	
	        this.state = {};
	
	        this.serviceProvider = obj.serviceProvider;
	        this.cache = this.initial.cache;
	        this.lang = this.initial.lang;
	
	        return this;
	    }
	
	    /* API */
	    /**
	     * Tab initialization method
	     * Optional method
	     */
	    FilterTab.prototype.init = function () {
	        log.info("Tab initialized successfully");
	    };
	
	    /**
	     * Method invoked when the tab is shown in the FENIX visualization box
	     * Mandatory method
	     */
	    FilterTab.prototype.show = function (state) {
	
	        var valid = this._validateInput();
	
	        if (valid === true) {
	
	            this._show(state);
	
	            this.ready = true;
	
	            log.info("Tab shown successfully");
	
	            return this;
	
	        } else {
	
	            log.error("Impossible to create show filter tab");
	            log.error(valid)
	        }
	    };
	
	    /**
	     * Check if the current model is suitable to be displayed within the tab
	     * Mandatory method
	     */
	    FilterTab.prototype.isSuitable = function () {
	
	        var isSuitable = this._isSuitable();
	
	        log.info("Filter tab: is tab suitable?", isSuitable);
	
	        if (isSuitable === true) {
	            return true;
	        } else {
	            log.error(isSuitable);
	            this._setState("errors", isSuitable);
	            return false;
	        }
	    };
	
	    /**
	     * Disposition method
	     * Mandatory method
	     */
	    FilterTab.prototype.dispose = function () {
	
	        this._dispose();
	
	        log.info("Filter tab disposed successfully");
	
	    };
	
	    /**
	     * pub/sub
	     * @return {Object} component instance
	     */
	    FilterTab.prototype.on = function (channel, fn, context) {
	        var _context = context || this;
	        if (!this.channels[channel]) {
	            this.channels[channel] = [];
	        }
	        this.channels[channel].push({context: _context, callback: fn});
	        return this;
	    };
	
	    /**
	     * Sync tab to passed state
	     * @param {Object} state
	     * @return {Object} filter instance
	     */
	    FilterTab.prototype.sync = function (state) {
	        log.info("Sync tab. State:" + JSON.stringify(state));
	
	        if (state.hasOwnProperty("toolbar") && this.filter) {
	            this.filter.setValues(state.toolbar, true);
	        } else {
	            log.warn("Abort toolbar sync")
	        }
	    };
	
	    /**
	     * Set values
	     * @param {Object} values
	     * @param {Boolean} silent
	     * @return {Object} filter instance
	     */
	    FilterTab.prototype.setValues = function (values, silent) {
	        log.info("Set values. values:" + JSON.stringify(values));
	
	        return this.filter ? this.filter.setValues(values, silent) : {};
	
	    };
	
	    /**
	     * Get values
	     * @param {Object} format
	     * @return {Object} filter instance
	     */
	    FilterTab.prototype.getValues = function (format) {
	        log.info("Get values. format:" + format);
	
	        return this.filter ? this.filter.getValues(format) : {};
	    };
	
	    /**
	     * Rebuild filter selectors
	     * @param {Object} payload
	     * @return {Object} filter instance
	     */
	    FilterTab.prototype.rebuild = function (payload) {
	
	        this.initial.config = payload.config;
	        this.initial.template = $.extend(true, {}, this.template);
	        this.initial.labels = $.extend(true, {}, this.labels);
	        this.initial.values = $.extend(true, {}, this.getValues(null));
	
	        this.dispose();
	
	        this.show();
	
	    };
	
	    /* END - API */
	
	    FilterTab.prototype._trigger = function (channel) {
	        if (!this.channels[channel]) {
	            return false;
	        }
	
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0, l = this.channels[channel].length; i < l; i++) {
	            var subscription = this.channels[channel][i];
	            subscription.callback.apply(subscription.context, args);
	        }
	        return this;
	    };
	
	    FilterTab.prototype._validateInput = function () {
	
	        var valid = true,
	            errors = [];
	
	        //Check if box has an id
	        /*        if (!this.id) {
	
	         window.fx_vis_box_id >= 0 ? window.fx_vis_box_id++ : window.fx_vis_box_id = 0;
	
	         this.id = window.fx_vis_box_id;
	
	         log.warn("Impossible to find id. Set auto id to: " + this.id);
	         }         */
	
	        //Check if $el exist
	        if (this.$el.length === 0) {
	
	            errors.push({code: ERR.MISSING_CONTAINER});
	
	            log.warn("Impossible to find tab container");
	
	        }
	
	        return errors.length > 0 ? errors : valid;
	
	    };
	
	    FilterTab.prototype._show = function (syncModel) {
	
	        if (this.initialized === true) {
	            log.info("Tab Filter shown again");
	
	        } else {
	
	            log.info("Tab Filter shown for the first time");
	
	            this.syncModel = syncModel;
	
	            this._attach();
	
	            this._initVariables();
	
	            this._renderComponents();
	
	            this._bindEventListeners();
	
	            this.initialized = true;
	
	            this._trigger('initialized');
	
	        }
	
	    };
	
	    FilterTab.prototype._attach = function () {
	
	        var m = $.extend(true, {}, defaultOptions.template, this.template, i18nLabels[this.lang.toLowerCase()], this.labels),
	            html = tabTemplate(m);
	
	        this.$el.html(html);
	    };
	
	    FilterTab.prototype._initVariables = function () {
	
	        this.$submitBtn = this.$el.find(s.SUBMIT_BTN);
	
	        this.$resetBtn = this.$el.find(s.RESET_BTN);
	
	        this.config = this.initial.config;
	        this.values = this.initial.values || {};
	        this.labels = this.initial.labels || {};
	        this.template = this.initial.template;
	        this.common = this.initial.common || {};
	
	    };
	
	    FilterTab.prototype._bindEventListeners = function () {
	
	        this.$submitBtn.on("click", _.bind(this._onSubmitBtnClick, this));
	
	        this.$resetBtn.on('click', _.bind(this._onResetBtnClick, this));
	
	        this.filter.on('ready', _.bind(this._onFilterReady, this));
	
	    };
	
	    FilterTab.prototype._onFilterReady = function () {
	
	        this.$submitBtn.prop('disabled', false);
	
	        this.$resetBtn.prop('disabled', false);
	
	        log.info("trigger 'ready' event");
	        this._trigger('ready');
	
	        this.filter.on('change', _.bind(this._onFilterChange, this));
	
	    };
	
	    FilterTab.prototype._onFilterChange = function () {
	
	        var values = this.filter.getValues();
	
	        log.info("trigger 'change' event " + JSON.stringify(values));
	
	        this._trigger('change', values);
	
	    };
	
	    FilterTab.prototype._onSubmitBtnClick = function () {
	        var values = this.filter.getValues();
	
	        log.info("trigger 'submit' event" + JSON.stringify(values));
	
	        this._trigger('submit', values);
	    };
	
	    FilterTab.prototype._onResetBtnClick = function (payload) {
	        log.info("trigger 'reset' event");
	
	        this.filter.reset();
	
	        this._trigger('reset')
	    };
	
	    FilterTab.prototype._renderComponents = function () {
	        log.info("render filter");
	
	        var model = {
	            selectors: this._createFilterConfiguration(),
	            el: this.$el.find(s.CONTAINER),
	            cache : this.cache,
	            template: this.template,
	            common :  this.common,
	            values : this.values,
	            serviceProvider: this.serviceProvider,
	            environment : this.initial.environment,
	            lang : this.lang
	        };
	
	        this.filter = new Filter(model);
	
	    };
	
	    FilterTab.prototype._createFilterConfiguration = function () {
	
	        var configuration = this.config ? $.extend(true, {}, this.config) : Utils.createConfiguration({
	                model: this.model
	            }),
	            defaultConfiguration = $.extend(true, {}, Utils.mergeConfigurations(configuration, this.syncModel || {})),
	            finalConfiguration = $.extend(true, {}, Utils.mergeConfigurations(defaultConfiguration, this.values || {}));
	
	        return finalConfiguration;
	    };
	
	    FilterTab.prototype._unbindEventListeners = function () {
	
	        this.$submitBtn.off();
	
	        this.$resetBtn.off();
	
	    };
	
	    FilterTab.prototype._isSuitable = function () {
	
	        var valid = true,
	            errors = [];
	
	        var resourceType = BoxUtils.getNestedProperty("metadata.meContent.resourceRepresentationType", this.model);
	
	        if (resourceType !== "dataset") {
	            errors.push({code: ERR.INCOMPATIBLE_RESOURCE_TYPE});
	        }
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    FilterTab.prototype._dispose = function () {
	
	        if (this.ready === true) {
	            this._unbindEventListeners();
	            this.filter.dispose();
	        }
	
	        this.$el.empty();
	
	        this.initialized = false;
	    };
	
	    FilterTab.prototype._getEventTopic = function (evt) {
	
	        return EVT[evt] ? EVT[evt] + this.id : evt + this.id;
	    };
	
	    FilterTab.prototype._setState = function (key, val) {
	
	        BoxUtils.assign(this.state, key, val);
	
	        this._trigger("state", $.extend(true, {}, this.state));
	    };
	
	    return FilterTab;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <button type=\"button\" data-role=\"submit\" class=\"btn btn-default\" disabled>"
	    + alias4(((helper = (helper = helpers.submit_button || (depth0 != null ? depth0.submit_button : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"submit_button","hash":{},"data":data}) : helper)))
	    + "</button>\n            <button type=\"button\" data-role=\"reset\" class=\"btn btn-default\" disabled>"
	    + alias4(((helper = (helper = helpers.reset_button || (depth0 != null ? depth0.reset_button : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"reset_button","hash":{},"data":data}) : helper)))
	    + "</button>\n        </div>\n    </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div data-role=\"filter\"></div>\n\n\n\n"
	    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.hideFooterButtons : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(2),
	    __webpack_require__(4),
	    __webpack_require__(74),
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(8),
	    __webpack_require__(9),
	    __webpack_require__(14),
	    __webpack_require__(75),
	    __webpack_require__(62),
	    __webpack_require__(76),
	    __webpack_require__(77),
	    __webpack_require__(11),
	    __webpack_require__(78),
	    __webpack_require__(48)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, log, _, Bootstrap,
	    C, ERR, EVT,
	    BoxUtils, Utils,
	    mapTemplate, Filter,
	    ToolbarModel,
	    mapBaseConfig,
	    i18nLabels,
	    MapCreator, amplify) {
	
	    var s = {
	        TOOLBAR: "[data-role='toolbar']",
	        TOOLBAR_BTN: "[data-role='filter-btn']"
	    };
	
	    function MapTab(obj) {
	
	        $.extend(true, this, {
	            initial: obj,
	            $el: $(obj.el),
	            box: obj.box,
	            model: obj.model,
	            id: obj.id
	        });
	
	        this.channels = {};
	        this.state = {};
	
	        this.cache = this.initial.cache;
	        this.lang = this.initial.lang;
	
	        return this;
	    }
	
	    /* API */
	    /**
	     * Tab initialization method
	     * Optional method
	     */
	    MapTab.prototype.init = function () {
	
	        log.info("Map initialized successfully");
	    };
	
	    /**
	     * Method invoked when the tab is shown in the FENIX visualization box
	     * Mandatory method
	     */
	    MapTab.prototype.show = function (opts) {
	
	        var valid = this._validateInput();
	
	        if (valid === true) {
	
	            this._show(opts);
	
	            log.info("Map tab shown successfully");
	
	            return this;
	
	        } else {
	
	            log.error("Impossible to create show map tab");
	            log.error(valid)
	        }
	    };
	
	    /**
	     * Check if the current model is suitable to be displayed within the tab
	     * Mandatory method
	     */
	    MapTab.prototype.isSuitable = function () {
	
	        var isSuitable = this._isSuitable();
	
	        log.info("Map tab: is tab suitable?", isSuitable);
	
	        if (isSuitable === true) {
	            return true;
	        } else {
	            log.error(isSuitable);
	            this._setState("errors", isSuitable);
	            return false;
	        }
	    };
	
	    /**
	     * Disposition method
	     * Mandatory method
	     */
	    MapTab.prototype.dispose = function () {
	
	        this._dispose();
	
	        log.info("Map disposed successfully");
	    };
	
	    /**
	     * pub/sub
	     * @return {Object} component instance
	     */
	    MapTab.prototype.on = function (channel, fn, context) {
	        var _context = context || this;
	        if (!this.channels[channel]) {
	            this.channels[channel] = [];
	        }
	        this.channels[channel].push({context: _context, callback: fn});
	        return this;
	    };
	
	    /**
	     * Sync tab to passed state
	     * @param {Object} state
	     * @return {Object} filter instance
	     */
	    MapTab.prototype.sync = function (state) {
	        log.info("Sync tab. State:" + JSON.stringify(state));
	
	        this.syncState = state;
	
	        this.toSync = true;
	
	        return this;
	    };
	
	    MapTab.prototype.update = function ( obj ) {
	
	       console.log("UPDATE MAP SETTINGS",obj)
	    };
	
	    /**
	     * Force redrawing
	     * @return {Object} filter instance
	     */
	    MapTab.prototype.redraw = function () {
	
	        if (this.map){
	            this.map.invalidateSize();
	        } else {
	            log.warn("Abort redraw");
	        }
	
	    };
	
	    /* END - API */
	
	    MapTab.prototype._trigger = function (channel) {
	        if (!this.channels[channel]) {
	            return false;
	        }
	
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0, l = this.channels[channel].length; i < l; i++) {
	            var subscription = this.channels[channel][i];
	            subscription.callback.apply(subscription.context, args);
	        }
	        return this;
	    };
	
	    MapTab.prototype._validateInput = function () {
	
	        var valid = true,
	            errors = [];
	
	        //Check if $el exist
	        if (this.$el.length === 0) {
	
	            errors.push({code: ERR.MISSING_CONTAINER});
	
	            log.warn("Impossible to find tab container");
	
	        }
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    MapTab.prototype._show = function (opts) {
	
	        //opts contain visualization options
	
	        if (this.initialized !== true) {
	
	            log.info("Map map shown for the first time");
	
	            this._attach();
	
	            this._initVariables();
	
	            this._renderComponents();
	
	            this._bindEventListeners();
	
	            this.initialized = true;
	
	            this._trigger('initialized');
	
	        } else {
	            log.info("Tab Map shown again");
	        }
	
	        if (this.toSync === true) {
	            log.info("Sync tab. State:" + JSON.stringify(this.syncState));
	
	            if (this.syncState.hasOwnProperty("toolbar") && this.toolbar) {
	                this.toolbar.setValues(this.syncState.toolbar, true);
	            }
	
	            if (this.syncState.hasOwnProperty("map")) {
	                this.addLayersByFilter(this.syncState.map);
	            }
	
	        }
	        return this;
	    };
	
	    MapTab.prototype._attach = function () {
	
	        var html = mapTemplate($.extend(true, {}, this, i18nLabels));
	
	        this.$el.html(html);
	    };
	
	    MapTab.prototype._initVariables = function () {
	
	        this.$toolbar = this.$el.find(s.TOOLBAR);
	
	        this.$toolbarBtn = this.$el.find(s.TOOLBAR_BTN);
	    };
	
	    MapTab.prototype._bindEventListeners = function () {
	
	        var self = this;
	
	        amplify.subscribe(this._getEventTopic("toolbar"), this, this._onToolbarEvent);
	
	        this.$el.find("[data-action]").each(function () {
	
	            var $this = $(this),
	                action = $this.data("action"),
	                event = self._getEventTopic(action);
	
	            $this.on("click", {event: event, tab: self}, function (e) {
	                e.preventDefault();
	
	                log.info("Raise event: " + e.data.event);
	
	                amplify.publish(event, {target: this, tab: e.data.tab});
	
	            });
	        });
	
	        this.$toolbarBtn.on("click", _.bind(this._onToolbarBtnClick, this));
	
	    };
	
	    MapTab.prototype._onToolbarEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("toolbar"));
	        log.trace(payload);
	
	        var direction = this.toolbarPosition !== "up" ? "up" : "down";
	
	
	        var map = this.map.leafletMap,
	            pxCen = map.latLngToContainerPoint(map.getCenter()),
	            newpxCen = pxCen;
	            
	        if(direction==='down')
	            newpxCen.x -= 200;
	        else if(direction==='up')
	            newpxCen.x += 200;
	        
	        map.panTo(map.containerPointToLatLng(newpxCen));
	
	        this._slideToolbar(direction)
	
	    };
	
	    MapTab.prototype._slideToolbar = function (direction) {
	
	        if (direction !== "up") {
	            this.$toolbar.addClass('in');
	            this.$toolbarBtn.addClass('in');
	            this.toolbarPosition = "down";
	        } else {
	            this.$toolbar.removeClass('in');
	            this.$toolbarBtn.removeClass('in');
	            this.toolbarPosition = "up";
	        }
	
	        this._setState("toolbarPosition", this.toolbarPosition);
	    };
	
	    MapTab.prototype._onToolbarBtnClick = function () {
	
	        this._onToolbarEvent();
	
	        this._renderMap();
	    };
	
	    MapTab.prototype._renderMap = function () {
	
	        var self = this;
	        //var toolbarValues = this.toolbar.getValues(),
	        //    configuration = BoxUtils.getMapCreatorConfiguration(toolbarValues);
	
	        if (C.renderVisualizationComponents === false ) {
	            log.warn("Render Visualization component blocked by configuration");
	            return;
	        }
	        
	        var $elMap = this.$el.find("#map_" + this.id),
	            lang = this.lang ? this.lang.toUpperCase() : "EN";
	
	            var MapCreatorOPTS = {
	                el: $elMap,
	                lang: lang,
	                fenix_ui_map: _.extend(mapBaseConfig, {
	                    guiController: {
	                        container: this.$el.find(s.TOOLBAR),
	                        wmsLoader: false
	                    }
	                })
	            };
	
	        var resType = BoxUtils.getNestedProperty("metadata.meContent.resourceRepresentationType", self.model);
	
	        if(resType==='dataset') {
	            MapCreatorOPTS.model = self.model;
	        }
	        else if(resType==='geographic') {
	
	            var layerName = BoxUtils.getNestedProperty("metadata.dsd.layerName", self.model),
	                workspace = BoxUtils.getNestedProperty("metadata.dsd.workspace", self.model);
	            
	            MapCreatorOPTS.uid = workspace+':'+layerName;
	        }
	
	        this.map = new MapCreator(MapCreatorOPTS);
	        //FOR TESTING TOOLBAR DRAGDROP
	        
	        //this.map.fenixMap.addLayer( this._getTestLayer() );
	
	        window.MMM = this;
	        this._filterLayers= {};
	    };
	
	    MapTab.prototype.addLayersByFilter = function(filter) {
	        
	        //console.log('addLayersByFilter', filter);
	
	        /*var filter = {
	            "valid": true,
	            "labels": {
	                "layers": { 
	                    "earthstat:abacaarea_3857":"Abaca",
	                    "earthstat:agave_area_3857":"Agave"
	                }
	            },
	            "values": {
	                "layers": [
	                    "earthstat:abacaarea_3857",
	                    "earthstat:agave_area_3857"
	                ]
	            }
	        };//*/
	
	        for(var i in filter.values.layers) {
	            var layerName = filter.values.layers[i];
	                layerTitle = filter.labels.layers[layerName];
	
	            if(this._filterLayers && !this._filterLayers.hasOwnProperty(layerName) )
	            {
	                this._filterLayers[layerName] = new FM.layer({
	                    urlWMS: "http://fenix.fao.org/demo/fenix/geoserver/wms",
	                    layers: layerName,
	                    layertitle: 'EarthStat Layer: '+layerTitle,
	                    opacity: '0.8',
	                    layertype: 'WMS'
	                });
	
	                this.map.fenixMap.addLayer( this._filterLayers[layerName] );
	            }
	            
	        }
	    },
	
	    MapTab.prototype._createFilterConfiguration = function () {
	
	        var configurationFromFenixTool = BoxUtils.getMapToolbarConfig(this.model),
	            configuration = $.extend(true, {}, ToolbarModel, configurationFromFenixTool),
	            result = $.extend(true, {}, Utils.mergeConfigurations(configuration, this.syncState.toolbar || {}));
	
	        return result;
	    };
	
	    MapTab.prototype._renderToolbar = function () {
	        log.info("Map tab render toolbar");
	
	        var self = this;
	
	        this.toolbar = new Filter({
	            selectors: this._createFilterConfiguration(),
	            el: this.$el.find(s.TOOLBAR),
	            cache : this.cache,
	            environment : this.initial.environment
	        });
	
	        this.toolbar.on('ready', _.bind(this._renderMap, this));
	
	        this.toolbar.on('select', function(e) {
	            
	            console.log('toolbar change',e)
	
	            var o = self.toolbar.getValues();
	
	            if(o.values)
	            {
	                if(o.values['map_boundaries'][0])
	                    self.map.fenixMap.boundariesShow();
	                else
	                    self.map.fenixMap.boundariesHide();
	
	                if(o.values['map_labels'][0])
	                    self.map.fenixMap.labelsShow();
	                else
	                    self.map.fenixMap.labelsHide();
	            }
	        });
	    };
	
	    MapTab.prototype._renderComponents = function () {
	
	        this._renderToolbar();
	
	        //init toolbar position
	        var position = this.initial.toolbarPosition || C.toolbarPosition;
	        if (position === 'up') {
	            this.toolbarPosition = 'up';
	            //this.$toolbar.hide();
	        } else {
	            this.toolbarPosition = 'down';
	        }
	
	    };
	
	
	    MapTab.prototype._unbindEventListeners = function () {
	
	        //this.$toolbarBtn.off();
	        this.$el.find("[data-action]").off();
	
	        amplify.unsubscribe(this._getEventTopic("toolbar"), this._onToolbarEvent);
	
	    };
	
	    MapTab.prototype._isSuitable = function () {
	
	        var valid = true,
	            errors = [];
	
	        var resourceType = BoxUtils.getNestedProperty("metadata.meContent.resourceRepresentationType", this.model);
	
	//console.log('MAP _isSuitable', resourceType);
	
	        if (resourceType !== "dataset" && resourceType !== "geographic") {
	            errors.push({code: ERR.INCOMPATIBLE_RESOURCE_TYPE});
	        }
	
	        var columns = BoxUtils.getNestedProperty("metadata.dsd.columns", this.model),
	            geoColumn = _.findWhere(columns, {subject: "geo"});
	
	        if (!geoColumn) {
	            errors.push({code: ERR.MISSING_GEO_COLUMN});
	        }
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    MapTab.prototype._dispose = function () {
	
	        this._unbindEventListeners();
	        
	    };
	
	    MapTab.prototype._getEventTopic = function (evt) {
	
	        return EVT[evt] ? EVT[evt] + this.id : evt + this.id;
	    };
	
	    MapTab.prototype._setState = function (key, val) {
	
	        BoxUtils.assign(this.state, key, val);
	
	        this._trigger("state", $.extend(true, {}, this.state));
	    };
	
	    MapTab.prototype._getTestLayer = function() {
	        var rawData = [["2","Afghanistan","512094.0","tonnes"]]
	        var joinData = _.map(rawData, function(d) {
	            var v = {};
	            v[d[0]] = parseFloat(d[2])
	            return v;
	        });
	
	        var joincolumnlabel = 'areanamee',
	            joincolumn = 'faost_code',
	            mu = 'Tonnes';
	
	        return new FM.layer({
	            layers: 'fenix:gaul0_faostat_3857',
	            layertitle: 'Rice Paddy Production 2013',
	            opacity: '0.5',
	            joincolumn: joincolumn,
	            joincolumnlabel: joincolumnlabel,
	            joindata: joinData,
	            mu: mu, measurementunit: mu,
	            layertype: 'JOIN',
	            jointype: 'shaded',
	            openlegend: false,
	            defaultgfi: true,
	            colorramp: 'Reds',
	            lang: 'en',
	            customgfi: {
	                content: {
	                    en: "<div class='fm-popup'>{{" + joincolumnlabel + "}} <div class='fm-popup-join-content'>{{{" + joincolumn + "}}}</div></div>"
	                },
	                showpopup: true
	            }
	        });
	    };
	
	    return MapTab;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_74__;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<button data-action=\"toolbar\" class=\"btn btn-floating fx-background-color-primary-color btn-fx-toolbar\" type=\"button\" title=\""
	    + alias4(((helper = (helper = helpers.tooltip_toolbar_button || (depth0 != null ? depth0.tooltip_toolbar_button : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"tooltip_toolbar_button","hash":{},"data":data}) : helper)))
	    + "\"><span class=\"icojam_options2\"></span></button>\n<button data-role=\"filter-btn\" class=\"btn btn-floating btn-fx-toolbar-confirm\" type=\"button\"><span class=\"icojam_check\"></span></button>\n\n<div data-role=\"toolbar\" class=\"col-xs-12 col-sm-6 col-md-6\"></div>\n\n<div class=\"tab-item-content-wrapper\">\n    <div id=\"map_"
	    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
	    + "\" class=\"tab-item-content\"></div>\n</div>";
	},"useData":true});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	     __webpack_require__(67)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Shared) {
	
	    'use strict';
	
	    return {
	        map_boundaries: {
	            selector : {
	                id : "input",
	                type : "checkbox",
	                source : [ { value : true, label :"Show Map Boundaries"}]
	            }
	        },
	        map_labels: {
	            selector : {
	                id : "input",
	                type : "checkbox",
	                source : [ { value : true, label :"Show Map Labels"}]
	            }
	        },
	        /* //TODO
	        "map_layers": {
	
	            selector: {
	                id: "sortable",
	                source : [
	                    {value: "1", label: "layer1"},
	                    {value: "2", label: "layer2"},
	                    {value: "3", label: "layer3"}
	                ],
	                config: {
	                    itemRender:  function (model) {
	
	                        var $el = $("<h1>[LAYER BOX " +model.label + "]</h1>");
	
	                        $el.on("click", function () {
	                            alert('Active layer')
	                        })
	
	                        return $el;
	                    }
	                }
	            },
	            template: {
	                title: "Map Filter"
	            }
	        }//*/
	
	    };
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	!(module.exports = {
	    lang: 'en',
	    plugins: {
	        fullscreen: true,
	        scalecontrol:'bottomleft'
	    },
	    guiController: {
	        container: '',
	        wmsLoader: false                 
	    },
	    baselayers: {
	        cartodb: {
	            title_en: "CartoDB light",
	            title_fr: "CartoDB light",
	            url: 'http://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png',
	            subdomains: 'abcd',
	            maxZoom: 19,
	            opacity: 1
	        },
	        osm: {
	            //url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
	            url: "http://{s}.tiles.wmflabs.org/osm-no-labels/{z}/{x}/{y}.png",
	            title_en: "Openstreetmap",
	            title_fr: "Openstreetmap",
	            maxZoom: 16,
	            opacity: 1            
	        },
	        world_imagery: {
	            url: "http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
	            title_en: "World Imagery",
	            title_fr: "World Imagery",
	            opacity:1
	        }
	    },
	    legendOptions: {
	        fontColor: '0x000000',
	        fontSize: '12',
	        bgColor: '0xFFFFFF'
	    }
	});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_78__;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(2),
	    __webpack_require__(4),
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(8),
	    __webpack_require__(9),
	    __webpack_require__(80),
	    __webpack_require__(15)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, log, _, C, ERR, EVT, BoxUtils, tabTemplate, MetadataViewer) {
	
	    'use strict';
	
	    function MetadataTab(obj) {
	
	        $.extend(true, this, {initial: obj, $el: $(obj.el), box: obj.box, model: obj.model, id: obj.id});
	
	        this.channels = {};
	        this.state = {};
	
	        this.cache = this.initial.cache;
	        this.lang = this.initial.lang;
	        this.environment = this.initial.environment;
	
	        return this;
	    }
	
	    /* API */
	    /**
	     * Tab initialization method
	     * Optional method
	     */
	    MetadataTab.prototype.init = function () {
	        log.info("Tab initialized successfully");
	    };
	
	    /**
	     * Method invoked when the tab is shown in the FENIX visualization box
	     * Mandatory method
	     */
	    MetadataTab.prototype.show = function (state) {
	
	        var valid = this._validateInput();
	
	        if (valid === true) {
	
	            this._show(state);
	
	            this.ready = true;
	
	            log.info("trigger 'ready' event");
	
	            this._trigger('ready');
	
	            log.info("Tab shown successfully");
	
	            return this;
	
	        } else {
	
	            log.error("Impossible to create show metadata tab");
	            log.error(valid)
	        }
	    };
	
	    /**
	     * Check if the current model is suitable to be displayed within the tab
	     * Mandatory method
	     */
	    MetadataTab.prototype.isSuitable = function () {
	
	        var isSuitable = this._isSuitable();
	
	        log.info("Metadata tab: is tab suitable?", isSuitable);
	
	        if (isSuitable === true) {
	            return true;
	        } else {
	            log.error(isSuitable);
	            this._setState("errors", isSuitable);
	            return false;
	        }
	
	    };
	
	    /**
	     * Disposition method
	     * Mandatory method
	     */
	    MetadataTab.prototype.dispose = function () {
	
	        this._dispose();
	
	        log.info("Metadata tab disposed successfully");
	
	    };
	
	    /**
	     * pub/sub
	     * @return {Object} component instance
	     */
	    MetadataTab.prototype.on = function (channel, fn, context) {
	        var _context = context || this;
	        if (!this.channels[channel]) {
	            this.channels[channel] = [];
	        }
	        this.channels[channel].push({context: _context, callback: fn});
	        return this;
	    };
	
	    /**
	     * Sync tab to passed state
	     * @param {Object} state
	     * @return {Object} filter instance
	     */
	    MetadataTab.prototype.sync = function (state) {
	        log.info("Sync tab. State:" + JSON.stringify(state));
	
	        if (state.hasOwnProperty("toolbar") && this.toolbar) {
	            this.toolbar.setValues(state.toolbar, true);
	        } else {
	            log.warn("Abort toolbar sync")
	        }
	    };
	
	    /* END - API */
	
	    MetadataTab.prototype._trigger = function (channel) {
	        if (!this.channels[channel]) {
	            return false;
	        }
	
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0, l = this.channels[channel].length; i < l; i++) {
	            var subscription = this.channels[channel][i];
	            subscription.callback.apply(subscription.context, args);
	        }
	        return this;
	    };
	
	    MetadataTab.prototype._validateInput = function () {
	
	        var valid = true,
	            errors = [];
	
	        //Check if box has an id
	        /*        if (!this.id) {
	
	         window.fx_vis_box_id >= 0 ? window.fx_vis_box_id++ : window.fx_vis_box_id = 0;
	
	         this.id = window.fx_vis_box_id;
	
	         log.warn("Impossible to find id. Set auto id to: " + this.id);
	         }         */
	
	        //Check if $el exist
	        if (this.$el.length === 0) {
	
	            errors.push({code: ERR.MISSING_CONTAINER});
	
	            log.warn("Impossible to find tab container");
	
	        }
	
	        return errors.length > 0 ? errors : valid;
	
	    };
	
	    MetadataTab.prototype._show = function (syncModel) {
	
	        if (this.initialized === true) {
	            log.info("Tab Metadata shown again");
	
	        } else {
	
	            log.info("Tab Metadata shown for the first time");
	
	            this.syncModel = syncModel;
	
	            this._attach();
	
	            this._initVariables();
	
	            this._renderComponents();
	
	            this._bindEventListeners();
	
	            this.initialized = true;
	
	            this._trigger('initialized');
	        }
	
	    };
	
	    MetadataTab.prototype._attach = function () {
	
	        var html = tabTemplate(this);
	
	        this.$el.html(html);
	    };
	
	    MetadataTab.prototype._initVariables = function () {
	
	    };
	
	    MetadataTab.prototype._bindEventListeners = function () {
	
	    };
	
	    MetadataTab.prototype._renderComponents = function () {
	
	        log.info("Render metadata viewer");
	
	        this.metadataViewer = new MetadataViewer({
	            model: this.model.metadata,
	            cache : this.cache,
	            environment : this.environment,
	            lang: this.lang,
	            el: this.$el.find('#metadata_' + this.id)
	        });
	
	    };
	
	    MetadataTab.prototype._unbindEventListeners = function () {
	
	    };
	
	    MetadataTab.prototype._isSuitable = function () {
	
	        var valid = true,
	            errors = [];
	
	        //errors.push({code: ERR.MISSING_CONTAINER});
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    MetadataTab.prototype._dispose = function () {
	
	        if (this.ready === true) {
	            this._unbindEventListeners();
	            this.metadataViewer.dispose();
	        }
	
	    };
	
	    MetadataTab.prototype._getEventTopic = function (evt) {
	
	        return EVT[evt] ? EVT[evt] + this.id : evt + this.id;
	    };
	
	    MetadataTab.prototype._setState = function (key, val) {
	
	        BoxUtils.assign(this.state, key, val);
	
	        this._trigger("state", $.extend(true, {}, this.state));
	
	        
	    };
	
	    return MetadataTab;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression;
	
	  return "<div class=\"tab-item-content-wrapper\">\n\n    <div id=\"metadata_"
	    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"id","hash":{},"data":data}) : helper)))
	    + "\" class=\"tab-item-content\" data-resourceRepresentationType='"
	    + alias1(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.metadata : stack1)) != null ? stack1.meContent : stack1)) != null ? stack1.resourceRepresentationType : stack1), depth0))
	    + "'></div>\n</div>\n\n";
	},"useData":true});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(2),
	    __webpack_require__(4),
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(8),
	    __webpack_require__(9),
	    __webpack_require__(14),
	    __webpack_require__(82),
	    __webpack_require__(62),
	    __webpack_require__(83),
	    __webpack_require__(11),
	    __webpack_require__(84),
	    __webpack_require__(48)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, log, _, C, ERR, EVT, BoxUtils, Utils, tabTemplate, Filter, ToolbarModel, i18nLabels, Table, amplify) {
	
	    'use strict';
	
	    var s = {
	        TOOLBAR: "[data-role='toolbar']",
	        FILTER_BTN: "[data-role='filter-btn']"
	    };
	
	    function TableTab(obj) {
	
	        $.extend(true, this, {initial: obj, $el: $(obj.el), box: obj.box, model: obj.model, id: obj.id});
	
	        this.channels = {};
	        this.state = {};
	
	        this.cache = this.initial.cache;
	        this.lang = this.initial.lang;
	        this.nls = $.extend(true, {}, i18nLabels[this.lang.toLowerCase()], this.initial.nls);
	
	        return this;
	    }
	
	    /* API */
	    /**
	     * Tab initialization method
	     * Optional method
	     */
	    TableTab.prototype.init = function () {
	        log.info("Tab initialized successfully");
	    };
	
	    /**
	     * Method invoked when the tab is shown in the FENIX visualization box
	     * Mandatory method
	     */
	    TableTab.prototype.show = function (opts) {
	
	        var valid = this._validateInput();
	
	        if (valid === true) {
	
	            this._show(opts);
	
	            log.info("Tab shown successfully");
	
	            return this;
	
	        } else {
	
	            log.error("Impossible to create show table tab");
	            log.error(valid)
	        }
	    };
	
	    /**
	     * Check if the current model is suitable to be displayed within the tab
	     * Mandatory method
	     */
	    TableTab.prototype.isSuitable = function () {
	        var isSuitable = this._isSuitable();
	
	        log.info("Table tab: is tab suitable?", isSuitable);
	
	        if (isSuitable === true) {
	            return true;
	        } else {
	            log.error(isSuitable);
	            this._setState("errors", isSuitable);
	            return false;
	        }
	
	    };
	
	    /**
	     * Disposition method
	     * Mandatory method
	     */
	    TableTab.prototype.dispose = function () {
	
	        this._dispose();
	
	        log.info("Table tab disposed successfully");
	
	    };
	
	    /**
	     * pub/sub
	     * @return {Object} component instance
	     */
	    TableTab.prototype.on = function (channel, fn, context) {
	        var _context = context || this;
	        if (!this.channels[channel]) {
	            this.channels[channel] = [];
	        }
	        this.channels[channel].push({context: _context, callback: fn});
	        return this;
	    };
	
	    /**
	     * Sync tab to passed state
	     * @param {Object} state
	     * @return {Object} filter instance
	     */
	    TableTab.prototype.sync = function (state) {
	        log.info("Sync tab. State:" + JSON.stringify(state));
	
	        this.syncState = state;
	
	        this.toSync = true;
	
	        return this;
	    };
	
	    /* END - API */
	
	    TableTab.prototype._trigger = function (channel) {
	
	        if (!this.channels[channel]) {
	            return false;
	        }
	
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0, l = this.channels[channel].length; i < l; i++) {
	            var subscription = this.channels[channel][i];
	            subscription.callback.apply(subscription.context, args);
	        }
	        return this;
	    };
	
	    TableTab.prototype._validateInput = function () {
	
	        var valid = true,
	            errors = [];
	
	        //Check if box has an id
	        /*        if (!this.id) {
	
	         window.fx_vis_box_id >= 0 ? window.fx_vis_box_id++ : window.fx_vis_box_id = 0;
	
	         this.id = window.fx_vis_box_id;
	
	         log.warn("Impossible to find id. Set auto id to: " + this.id);
	         }         */
	
	        //Check if $el exist
	        if (this.$el.length === 0) {
	
	            errors.push({code: ERR.MISSING_CONTAINER});
	
	            log.warn("Impossible to find tab container");
	
	        }
	
	        return errors.length > 0 ? errors : valid;
	
	    };
	
	    TableTab.prototype._show = function (opts) {
	
	        //TODO opts contain the chart type
	
	        if (this.initialized !== true) {
	
	            log.info("Tab table shown for the first time");
	
	            this._attach();
	
	            this._initVariables();
	
	            this._renderComponents();
	
	            this._bindEventListeners();
	
	            this.initialized = true;
	
	            this._trigger('initialized');
	
	        } else {
	            log.info("Tab table shown again");
	        }
	
	        if (this.toSync === true) {
	            log.info("Sync tab. State:" + JSON.stringify(this.syncState));
	
	            if (this.syncState.hasOwnProperty("toolbar") && this.toolbar) {
	
	                this.toolbar.setValues(this.syncState.toolbar, true);
	
	                this._renderTable();
	            }
	        }
	
	        return this;
	    };
	
	    TableTab.prototype._attach = function () {
	        var html = tabTemplate($.extend(true, {}, this, this.nls));
	
	        this.$el.html(html);
	    };
	
	    TableTab.prototype._initVariables = function () {
	
	        this.$toolbar = this.$el.find(s.TOOLBAR);
	
	        this.$toolbarBtn = this.$el.find(s.FILTER_BTN);
	
	
	    };
	
	    TableTab.prototype._bindEventListeners = function () {
	
	        var self = this;
	
	        amplify.subscribe(this._getEventTopic("toolbar"), this, this._onToolbarEvent);
	
	        this.$el.find("[data-action]").each(function () {
	
	            var $this = $(this),
	                action = $this.data("action"),
	                event = self._getEventTopic(action);
	
	            $this.on("click", {event: event, tab: self}, function (e) {
	                e.preventDefault();
	
	                log.info("Raise event: " + e.data.event);
	
	                amplify.publish(event, {target: this, tab: e.data.tab});
	
	            });
	        });
	
	        this.$toolbarBtn.on("click", _.bind(this._onToolbarBtnClick, this));
	
	        if (C.syncTabsOnToolbarChange === true) {
	            this.toolbar.on('change', _.bind(this._onToolbarChangeEvent, this));
	        }
	
	        this.$el.find('[data-toggle="tooltip"]').tooltip();
	
	    };
	
	    TableTab.prototype._onToolbarEvent = function (payload) {
	        log.info("Listen to event: " + this._getEventTopic("toolbar"));
	        log.trace(payload);
	
	        var direction = this.toolbarPosition !== "up" ? "up" : "down";
	
	        this._slideToolbar(direction)
	
	    };
	
	    TableTab.prototype._slideToolbar = function (direction) {
	
	        if (direction !== "up") {
	            this.$toolbar.addClass('in');
	            this.$toolbarBtn.addClass('in');
	            this.toolbarPosition = "down";
	        } else {
	            this.$toolbar.removeClass('in');
	            this.$toolbarBtn.removeClass('in');
	            this.toolbarPosition = "up";
	        }
	
	        this._setState("toolbarPosition", this.toolbarPosition);
	
	    };
	
	    TableTab.prototype._onToolbarBtnClick = function () {
	
	        this._onToolbarEvent();
	
	        this._onConfigurationChange();
	
	    };
	
	    TableTab.prototype._renderTable = function () {
	
	        var toolbarValues = this.toolbar.getValues(),
	            configuration = BoxUtils.getTableCreatorConfiguration(toolbarValues);
	
	        if (C.renderVisualizationComponents === false) {
	            log.warn("Render Visualization component blocked by configuration");
	            return;
	        }
	
	        var config = $.extend(true, {}, {
	            model: this.model,
	            el: "#table_" + this.id,
	            lang : this.lang.toUpperCase()
	        }, configuration);
	
	        this.table = new Table(config);
	    };
	
	    TableTab.prototype._renderToolbar = function () {
	        log.info("Table tab render toolbar");
	
	        var self = this,
	            model = {
	            selectors: this._createFilterConfiguration(ToolbarModel),
	            cache: this.cache,
	            el: this.$el.find(s.TOOLBAR),
	            environment: this.initial.environment
	        };
	
	        //force labels
	
	        var labeled = {};
	
	        if (model.selectors.hasOwnProperty("dimensionsSort")) {
	
	            _.each(model.selectors.dimensionsSort.selector.config.groups,function(value, key) {
	                labeled[key] = i18nLabels[self.lang.toLowerCase()]["tab_table_toolbar_" + key];
	            });
	
	            model.selectors.dimensionsSort.selector.config.groups =labeled;
	        }
	
	        //i18n
	        var source = BoxUtils.getNestedProperty("selectors.show.selector.source", model);
	        _.map(source, function(i) {
	            i.label =  i18nLabels[self.lang.toLowerCase()]["tab_table_toolbar_" + i.value] || i.label;
	            return i;
	        });
	        BoxUtils.assign(model, "selectors.show.selector.source", source);
	
	
	        this.toolbar = new Filter(model);
	
	        this.toolbar.on("ready", _.bind(this._renderTable, this))
	
	    };
	
	    TableTab.prototype._createFilterConfiguration = function () {
	
	        log.info("Create toolbar config");
	
	        var configurationFromFenixTool,
	            configuration,
	            result,
	            self = this;
	
	        configurationFromFenixTool = BoxUtils.getTableToolbarConfig(this.model, {lang : this.lang.toUpperCase()});
	
	        log.info(configurationFromFenixTool);
	
	        configuration = $.extend(true, {}, ToolbarModel, configurationFromFenixTool);
	
	        log.info(configuration);
	
	        result = $.extend(true, {}, Utils.mergeConfigurations(configuration, this.syncState.toolbar || {}));
	
	        _.each(result, _.bind(function (value, key) {
	            value.template.title = i18nLabels[self.lang.toLowerCase()]["tab_table_toolbar_" + key];
	        }, this));
	
	        log.info(result);
	
	        return result;
	
	    };
	
	    TableTab.prototype._onToolbarChangeEvent = function () {
	
	        this._onConfigurationChange();
	
	    };
	
	    TableTab.prototype._onConfigurationChange = function () {
	
	        this._trigger("filter", this.toolbar.getValues());
	
	        this._renderTable();
	    };
	
	    TableTab.prototype._renderComponents = function () {
	
	        this._renderToolbar();
	
	        //Table will be create when filter is 'ready'
	
	        //init toolbar position
	        var position = this.initial.toolbarPosition || C.toolbarPosition;
	        if (position === 'up') {
	            this.toolbarPosition = 'up';
	        } else {
	            this.toolbarPosition = 'down';
	        }
	
	    };
	
	    TableTab.prototype._unbindEventListeners = function () {
	
	        this.$toolbarBtn.off();
	        this.$el.find("[data-action]").off();
	
	        amplify.unsubscribe(this._getEventTopic("toolbar"), this._onToolbarEvent);
	
	    };
	
	    TableTab.prototype._isSuitable = function () {
	
	        var valid = true,
	            errors = [];
	
	        var resourceType = BoxUtils.getNestedProperty("metadata.meContent.resourceRepresentationType", this.model);
	
	        if (resourceType !== "dataset") {
	            errors.push({code: ERR.INCOMPATIBLE_RESOURCE_TYPE});
	        }
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    TableTab.prototype._dispose = function () {
	
	        if (this.state.ready === true) {
	            this._unbindEventListeners();
	        }
	    };
	
	    TableTab.prototype._getEventTopic = function (evt) {
	
	        return EVT[evt] ? EVT[evt] + this.id : evt + this.id;
	    };
	
	    TableTab.prototype._setState = function (key, val) {
	
	        BoxUtils.assign(this.state, key, val);
	
	        this._trigger("state", $.extend(true, {}, this.state));
	    };
	
	    return TableTab;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(17);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<button data-action=\"toolbar\" class=\"btn btn-floating fx-background-color-primary-color btn-fx-toolbar\" type=\"button\" title=\""
	    + alias4(((helper = (helper = helpers.tooltip_toolbar_button || (depth0 != null ? depth0.tooltip_toolbar_button : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"tooltip_toolbar_button","hash":{},"data":data}) : helper)))
	    + "\"><span class=\"icojam_options2\"></span></button>\n<button data-role=\"filter-btn\" class=\"btn btn-floating btn-fx-toolbar-confirm\" type=\"button\"><span class=\"icojam_check\"></span></button>\n\n<div data-role=\"toolbar\" class=\"col-xs-12 col-sm-6 col-md-6\">\n    <div data-selector=\"dimensionsSort\"></div>\n</div>\n\n<div class=\"tab-item-content-wrapper\">\n	<div id=\"table_"
	    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
	    + "\" class=\"tab-item-content\"></div>\n</div>";
	},"useData":true});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(3),
	        __webpack_require__(67)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Shared) {
	
	        'use strict';
	
	        return $.extend(true, {}, Shared, {show : {
	
	            selector : {
	                id : "input",
	                type : "checkbox",
	                source : [
	                    { value : "unit", label : "Unit"},
	                    { value : "flag", label : "Flag"},
	                    { value : "code", label : "Code"}
	                ]
	            },
	
	            template : {
	                title : "Show"
	            }
	        }})
	
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_84__;

/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// fenix-ui-visualization-box.min.js